import { h } from 'vue';
import { v4 as uuid } from 'uuid';

// import Images from '@/components/Global/Images.vue';
import ImageSameHeight from '@/components/Global/ImageSameHeight.vue';
import {
  serviceStatisticsACoreConfig,
  serviceStatisticsBExpandConfig,
  serviceStatisticsABExpand19982008Config,
  serviceStatisticsABExpandLastConfig,
  serviceStatisticsABExpandConfig,
} from '@/config/chartConfig';
import Chart from '@/components/Global/Chart.vue';

import communicationImg1 from '@/assets/img/services/img_communication_26.jpg';
import communicationImg2 from '@/assets/img/services/img_communication_27.jpg';
import communicationImg3 from '@/assets/img/services/img_communication_28.jpg';
import communicationImg4 from '@/assets/img/services/img_communication_20.jpg';
import communicationImg5 from '@/assets/img/services/img_communication_21.jpg';
import communicationImg6 from '@/assets/img/services/img_communication_22.jpg';
import communicationImg7 from '@/assets/img/services/img_communication_23.jpg';
import communicationImg8 from '@/assets/img/services/img_communication_24.jpg';
import communicationImg9 from '@/assets/img/services/img_communication_25.jpg';

import {
  HighRiskHypetensionContent,
  HighRiskThyroidContent,
  HighRiskUnderStandingContent,
  HighRiskWeightContent,
  HighRiskDiabetesContent,
  HighRiskLupusContent,
  HighRiskPlacentaPrevia1Content,
  HighRiskMultipleBirthContent,
  HighRiskPlacentaPrevia2Content,
  understandFoodType,
  understandFoodNutrition,
  drugEffectContent,
  trackingMemberContent,
  trackingNationalServiceContent,
  understandPregnantContent,
  // milkPowerPrescriptionContent,
  breastMilkExpireContent,
  milkPowerFeatureContent,
  subFoodMixinMethodContent,
  bodyTemperatureAdjustContent,
  takeBodyTemperatureContent,
  // babyGrowContent,
  babyHeatToHospitalContent,
  vaccinationContent,
  highRiskGroupsContent,
  preemieTrackingCheckAndEarlyCareContent,
  intracerebralHemorrhageSymdronesContent,
  babySleepDemainingContent,
  cerebralPalsyContent,
  openDuctusArteriosusTreatContent,
  bookStartReadingContent,
  retinopathyContent,
  chronicLungDiseaseTreatContent,
} from '@/config/simpleTableContent';
import SimpleTable from '@/components/SimpleTable/index.vue';
import CorrectedAge from '@/components/Resources/CorrectedAge.vue';
import CorrectedAgeIntro from '@/components/Resources/CorrectedAgeIntro.vue';
import Processing from '@/components/Global/Processing.vue';
import SingleImg from '@/components/Global/SingleImg.vue';

import LeftWordingRightImage from '@/components/Global/LeftWordingRightImage.vue';

import MultipleImg from '@/components/Global/MultipleImg.vue';
// import mock1 from '@/assets/img/services/img_01.svg';
// import mock2 from '@/assets/img/services/img_02.svg';
// import mock3 from '@/assets/img/services/img_03.svg';
// import mock4 from '@/assets/img/services/img_04.png';
// import mock5 from '@/assets/img/services/img_05.svg';
// import mock6 from '@/assets/img/services/img_07.jpg';
import mock7 from '@/assets/img/services/img_08.jpg';

import OpenItem from '@/components/Global/OpenItem.vue';
import OpenList from '@/components/Global/OpenList.vue';
import NationalHospitalNetwrok from '@/components/Services/NationalHospitalNetwork.vue';
import ContactItem from '@/components/Global/ContactItem.vue';
import burpImg from '@/assets/img/resource/burp.png';
import washBaby1 from '@/assets/img/resource/wash_baby_1.png';
import washBaby2 from '@/assets/img/resource/wash_baby_2.png';
import washBaby3 from '@/assets/img/resource/wash_baby_3.png';
import washBaby4 from '@/assets/img/resource/wash_baby_4.png';
import washBaby5 from '@/assets/img/resource/wash_baby_5.png';
import preemieBrochure from '@/assets/img/services/preemie-brochure.png';

// import HomeCareImg from '@/components/Global/HomeCareImg.vue';
import TextImg from '@/components/Global/TextImg.vue';
import dischargeIntroImg from '@/assets/img/services/28.png';

import { font, boldText, renderBoldText, textInRow, renderNormalBoldText } from '@/utils/texts';
import HomeCareImgWithText from '@/components/Global/HomeCareImgWithText.vue';

export const aboutUsText = [
  {
    type: 'large',
    text: ['在台灣，每十個出生的新生兒當中就有一位是早產兒'],
  },
  {
    type: 'normal',
    text: '在生育率節節降低的現今，依據國健署112年統計早產兒發生率為 10.87%，換言之，每十個出生的新生兒當中就有一位是早產兒。也意味著每年有近一萬五千名早產兒，還來不及準備妥當，就必須提早面對一段艱難的成長歷程，以及一個未知的未來；而早產兒父母的疑慮、憂心，更需要關懷與實質幫助。',
    style: {
      marginTop: '50px',
    },
  },
  {
    type: 'normal',
    text: '為了幫助早產兒，度過這段艱難的成長歷程，馬偕紀念醫院及民間企業團體，共同發起成立「財團法人中華民國早產兒基金會」。（2010年更名為「財團法人台灣早產兒基金會」）',
  },
  {
    type: 'normal',
    text: '事實上，只要有完整的醫療照顧，早產兒已有很高的存活率，但基金會不僅著重孩子的存活，更重視孩子及家庭的生活品質。以生命軸線架構早產兒照護，從婦女備孕開始，直到返家後的認知發展追蹤檢查，「孩子生得少，就一個都不能少」、「完整孕護．避免早產」、「好孕、好產、好寶貝-三好守護行動」，將口號化為實際行動，給他機會，讓他迎頭趕上。',
  },
  {
    type: 'normal',
    text: '基金會透過各界的協助，為早產兒及其家庭點燃信心與希望；同時也藉由各種活動，推廣正確的觀念與知識，以防早產的發生。這是一份生命事業，願凝聚你我的關懷，幫助早產兒，準備他還來不及準備的那一部份。',
  },
];

export const foundationDataText = [
  {
    type: 'important',
    text: '＊基金會立案資料',
    style: {
      marginTop: '30px',
    },
  },
  {
    type: 'normal',
    text: '民國81年1月16日地方法院正式立案通過登記字號：法人登記第66冊第9 頁第1639號。 ',
    style: {
      marginTop: '10px',
    },
  },
  {
    type: 'normal',
    text: '設立許可機關日期：行政院衛生署民國80年11月2日衛署醫字第983446號函。',
    style: {
      marginTop: 0,
    },
  },
];

export const servicesTitle = [
  {
    type: 'important',
    text: '只要對早產兒及其家庭有幫助的 ',
  },
  {
    type: 'important',
    text: '我們都願意全力以赴',
    style: {
      marginTop: 0,
    },
  },
];

export const foundationPurpose = [
  '讓每個早產兒接受適當的醫療並提昇早產兒醫療照顧品質。',
  '鼓勵社會大眾一起來關懷並重視早產的問題。',
  '致力於早產兒的預防與教育。',
];

export const historyText = [
  {
    type: 'large',
    text: ['為早產兒爭取更佳權益及優質的醫療環境，守護小腳ㄚ跨出大人'],
  },
  {
    type: 'normal',
    text: [
      '在回顧基金會成長的軌跡，我們滿心的感謝很多深具使命志工的投入、努力付出，我們期許能將滿滿的愛心，及奉獻，化成專業、具體、前瞻性的服務。多年來基金會一步一腳印隨著社會動經歷不同的生命週期，未來將結合更多人力、物力、財力為早產兒爭取更佳權益及優質的醫療環境，守護小腳ㄚ跨出大人。',
    ],
    style: {
      marginTop: '50px',
    },
  },
];

export const historyText2 = [
  {
    type: 'normal',
    text: [
      '創建期(1991-1994)-凝聚你我的關懷結合社會資源，提昇醫療品質',
      '擴充期(1995-2000)-全民健保起跑，加速擴創新服務',
      '穩定期(2001-2005)-環境變化努力經營，新住民增加多語宣傳',
      '轉型期(2006-2011)-生育率下降，加強孕產兒人性化服務方案',
      '成長期(2012-2019)-響應世界產兒日宣導，積極與政府合作',
      '永續發展期(2020-迄今)-強化夥伴關係，政策遊說倡議，永續全方位服務',
    ],
  },
];

export const historyTimeline1991Text = [
  {
    type: 'normal',
    text: ['>設立許可機關日期:行政院衛生署民國80年11月2日衛署醫字第983446號函', '>第一屆董事會成立,藍中基榮任董事長'],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1992Text = [
  {
    type: 'normal',
    text: [
      '>公告基金會正式成立記者會，並與合約醫院簽訂合約',
      '>實施「早產兒住院醫療費用補助」方案 ',
      '>出版《早產兒基金會會訊》創刊號 ',
      '>出版「預防早產」單張﹑《一個小小孩兒的故事》早產兒手冊﹑《巴掌大的仙子》書籍 ',
      '>台視、金車、民生報合辦「獻上康乃馨、馨香慰母心」為早產兒義賣活動',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1993Text = [
  {
    type: 'normal',
    text: [
      '>實施「補助專題研究計劃」方案，提升醫療照護品質 ',
      '>醫療團隊教育訓練，邀請澳洲（Victor余宇熙）﹑加拿大(潘妮‧麥可阿瑟)﹑日本(藤村正哲)來台演講 ',
      '>參訪日本大阪母子保健醫院、都立大塚病院、鹿兒島市立病院、東京女子醫科大學病院 ',
      '>製作「只要我長大」主題曲及Ｍ.T.V﹑出版《小小孩兒回家了──談早產兒出院後的照顧》書籍 ',
      '>青商會舉辦「只要我長大」為早產兒義賣園遊會',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1994Text = [
  {
    type: 'normal',
    text: [
      '>獲教育部評選為「八十三年度推動社會教育有功團體」 ',
      '>捐贈五部加護型救護車予合約醫院(彰化基督教醫院、台北馬偕醫院、嘉義基督教醫院、花蓮門諾醫院、中國醫藥學院附設醫院) ',
      '>舉辦首屆「早產兒護理研習會」 ',
      '>首次資助合約醫院醫護人員至日本大阪母子保健醫院代訓 ',
      '>出版《他很小，他是我寶貝》給早產兒父母的一本書',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const historyTimeline1995Text = [
  {
    type: 'normal',
    text: [
      '>實施「早產兒出院後居家照護儀器之租借費用補助」及「早產兒出院後追蹤檢查工作」專案',
      '>舉辦第一屆「早產兒加護病房護理長成長營」﹑「早產兒社會工作研討會」',
      ">參訪澳洲Mater Mother's Hospital、Royal Women's Hospital、Monash Medical Centre、Woden Valley Hospital、Westmead Hospital五家醫院",
      '>「他很小，他是我寶貝－關懷早產兒」攝影甄選及攝影展系列活動',
      '>出版《如何以母乳哺育早產兒》書籍﹑「避免早產孕婦篇－預約健康新生命」錄影帶',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1996Text = [
  {
    type: 'normal',
    text: [
      '>實施「相對補助合約醫院早產兒加護病房醫療儀器」方案',
      '>首次補助合約醫院聯合舉辦「早產兒回娘家活動」',
      '>邀請澳洲布里斯班聖母醫院Professor David Ian 來台演講',
      '>出版《強強的小腳丫》童書',
      '>與嬌生公司合作「寶貝生命──給他長大的希望」募款活動',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1997Text = [
  {
    type: 'normal',
    text: [
      '>正式開辦「信用卡捐款」（VISA、MASTER卡）',
      '>五週年慶暨本會吉祥物親蜜娃娃誕生活動，遠東航空公司率先認養第一隻親蜜娃娃',
      '>選派10名合約醫院醫療團隊至澳洲布里斯班馬特醫院接受代訓',
      '>出版「媽媽的心情日記~早產兒回家初期一般照顧」﹑「嬰幼兒神經學檢查」錄影帶及「心聲篇」「同學篇」公益CF片',
      '>嬌生公司舉辦「從撫觸 認識您的愛」座談會及「親蜜相伴 陪他長大」建立早產兒健康保護網義賣活動',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1998Text = [
  {
    type: 'normal',
    text: ['>與馬偕醫院合作開辦「早產兒防治中心」特別門診及衛教諮詢'],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline1999Text = [
  {
    type: 'normal',
    text: [
      '>與台灣北﹑中﹑南五家醫學中心合作「早產兒醫療訓練中心」掛牌成立，提供全面精緻化醫療照顧及國內院際交流與學習機會',
      '>實施「早產兒居家照護小組」專案工作',
      '>「早產兒有愛 成長無礙」記者會，發表「台灣極低體重早產兒至二歲的發展預後」白皮書',
      '>捐贈國軍澎湖醫院嬰兒呼吸器乙台﹑屏東基督教醫院早產兒救護車',
      '>參訪加拿大溫哥華Surrey﹑Vancouver之Healthiest Babies Possible﹑British Columbia’s Women’s and Children’s Hospital及美國西雅圖University of Washington Academic Medical Center六所機構',
      '>邀請西雅圖華盛頓大學護理學院教授Dr.Susan Blackburn，來台講授「早產兒照護之新趨勢」',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2000Text = [
  {
    type: 'normal',
    text: [
      '>邀請日本大阪母子保健醫院藤村正哲醫師演講「日本1000公克以下早產兒至12歲的發展狀況」',
      '>首辦「早產兒父母支持團體」',
      '>「天使搖籃曲」MTV發表記者會',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2001Text = [
  {
    type: 'normal',
    text: [
      '>與新生兒科醫學會共同發表「台灣地區早產兒之罹病與死亡情形」',
      '>「早產兒醫療訓練中心工作研討會暨成果發表」記者會',
      '>本會為中國信託第16屆「點燃生命之火」公益活動受贈團體',
      '>製作「預防早產醫多戰，幸福美滿一度讚」海報及宣導片',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2002Text = [
  {
    type: 'normal',
    text: [
      '>「永不止息的愛，讓早產兒成長無礙」十週年慶學術研討會及成果海報展',
      '>【來自台灣的愛】送保溫箱至友邦宏都拉斯，共捐贈29部新﹑舊保溫箱及相關醫療儀器乙批',
      '>出版《早產安胎》衛教手冊',
      '>克蘭詩化妝品公司舉辦「因為有妳，珍愛自己」系列義賣宣導活動',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2003Text = [
  {
    type: 'normal',
    text: [
      '>成功爭取中央健康保險局公告給付 「極低出生體重早產心智發展檢查」，有效執行早產追蹤評估、及時發現與診治進而降低未來社會醫療成本',
      '>與秦慧珠立委國會辦公室合辦「正視外籍新娘高早產率問題」記者會',
      '>與台北市衛生局合作，於木柵動物園舉辦早產兒關懷月「迷你早產兒同學會」',
      '>舉辦「彩繪青春~避免早產」海報徵選活動',
      '>參訪英國St.Marry’s Hospital﹑法國Prot-Royal Maternity Hospital﹑Jeanne de Frandre Hospita﹑德國科隆Children’s Hospital﹑荷蘭Sophia Children’s Hospital五家醫院',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2004Text = [
  {
    type: 'normal',
    text: [
      '>「與國健局局長有約」座談會，邀請國健局局長、新生兒科醫學會、周產期醫學會代表共同研議早產相關議題',
      '>爭取健保給付心智發展評估，評量學齡前學習適應力',
      '>與秦慧珠立委國會辦公室合辦「小孩生小孩，容易"早生貴子" 十八歲以下小媽媽，生早產兒比率偏高」記者會',
      '>「年輕要幸福 不要包袱」青少年預防早產TVCF記者會，呼籲大家共同關懷青少年',
      '>與台中市政府共同舉辦「呵護手心寶貝 讓愛永不止息」婦幼嘉年華會',
      '>發行早產兒電子報創刊號',
      '>花王公司舉行「關鍵時刻助他一臂之力」為早產兒加油記者會及紙尿褲捐贈儀式',
      '>職棒選手馮勝賢發起「點燃信心與希望」月曆義賣及「儲蓄愛心.傳播愛」捐贈記者會',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2005Text = [
  {
    type: 'normal',
    text: [
      '>「早產兒追蹤檢查十週年成果發表暨記者會」及「台、日新生兒醫療座談會」，邀請日本嬰孩成育網絡成員參與',
      '>與台北市政府衛生局及兒童保健協會合辦「打造巴掌仙子願景—早產防治研討會」',
      '>製作中越﹑中印﹑中泰﹑中英等認識早產單張及出院後居家照護手冊，協助新住民',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2006Text = [
  {
    type: 'normal',
    text: [
      '>首家「人性化安胎示範病房」於馬偕醫院成立',
      '>「完整孕護．避免早產」TVCF首映記者會',
      '>參訪大阪母子保健綜合醫院、東京女子醫科大學母子醫療中心、國立成育醫療中心三家醫院。',
      '>實施「早產兒居家護理服務補助」方案',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2007Text = [
  {
    type: 'normal',
    text: [
      '>醫學人文公益舞台劇「幸福的眼淚」全台巡迴演出',
      '>官方網站榮獲行政院研考會評選為「網際營活獎優質網站二獎」',
      '>「人性化安胎示範病房」分別在桃園聖保祿醫院及台灣最南端的屏東基督教醫院成立',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2008Text = [
  {
    type: 'normal',
    text: ['>首次與電信業者台灣大哥大合作手機募款案【518020】', '>首辦「諮詢義工媽媽成長營」﹑「安胎病房義工訓練營」'],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2009Text = [
  {
    type: 'normal',
    text: [
      '>實施「合約醫院早產兒使用28號PCVC醫材補助」方案',
      '>「人性化安胎示範病房」於花蓮門諾醫院﹑台南奇美醫院﹑新樓醫院成立',
      '>參訪美東Saint Barnabas Medical Center、New York-Presbyterian Morgan Stanley Children’s Hospital、Women & Infants Hospital of Rhode Island、Brigham and Women’s Hospital共四家醫院',
      '>舉辦『幸福的眼淚－見證巴掌仙子生命力』網路徵文活動並集結成冊',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2010Text = [
  {
    type: 'normal',
    text: [
      '>第七屆第一次董事會將「財團法人中華民國早產兒基金會」更名為「財團法人台灣早產兒基金會」並完成法人變更登記',
      '>衛生署衛生財團法人評核獲評為「特優」，獲頒獎勵狀乙只',
      '>成功爭取中央健康保險局公告，給付出生時懷孕週數28 週以下與35週以下合併慢性肺疾病早產兒施打6個月的RSV單株抗體',
      '>舉辦「追蹤檢查專案貝利嬰幼兒發展量表第三版（BSID-III）施測研討會」',
      '>「人性化安胎示範病房」於成大醫院﹑新竹馬偕醫院﹑中國醫藥大學附設醫院成立',
      '>製作『守護天使~早產兒的居家照護』DVD影片',
      '>舉辦「幸福的眼淚．見證巴掌仙子生命力」生活趣味寫真大募集',
      '>與亞太電信合作手機募款案【59014】',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2011Text = [
  {
    type: 'normal',
    text: [
      '>「早到的天使．找到幸福」記者會，發表「台灣極低出生體重早產兒十年期間的早期預後」白皮書',
      '>20週年學術研討會暨「期待你長大」紀錄片首映會，邀請日本大阪母子保健醫院藤村正哲總長演講',
      '>製作「醫多戰」廣告短片及平面影像，邀請黃富源、李晶玉及楊淑君代言',
      '>「早產兒圓緣袋」由合約醫院轉贈每位住院的早產兒家長',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2012Text = [
  {
    type: 'normal',
    text: [
      '>「與國健局有約」座談會研議早產預防、治療、追蹤、居家照護等議題',
      '>正式成立官方臉書',
      '>「人性化安胎示範病房」於台中中山醫學大學附設醫院成立',
      '>剪輯「站立」「期待你長大」記錄片為「早落的果實」影片，於大台北校園巡迴映演',
      '>「預防早產．全民守護」話報徵件活動',
      '>「給愛力量。用行動支持--我騎1公里，您捐1塊錢」由上班族林青雪發起籌募購置「小安妮BABY急救訓練組」活動，贈予新生兒科醫學會及合約醫院',
      '>首屆響應1117世界早產兒日，舉辦「小腳丫奮鬥記」早產兒說故事活動',
      '>「小腳丫加油!」臉書照片徵選活動，得獎作品於立法院、中央健康保險局﹑社區﹑學校及合約醫院巡迴展覽',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2013Text = [
  {
    type: 'normal',
    text: [
      '>「國健局有約座談會」討論早產兒防治、追蹤照護等與政府合作之議題',
      '>與立法委員蔡錦隆國會辦公室共同召開「小腳ㄚ有話說！早產兒醫療權維護公聽會」',
      '>向財政部申請電子發票愛心碼【1117】',
      '>響應1117世界早產兒日「用愛．守護小腳ㄚ平安長大」，舉辦「衣世傳承」臉書徵選頒獎活動，當晚與全球同步於台北101大樓點燈《早產兒加油》',
      '>終身志工馮勝賢首次發起「體壇心齊力 讓生命更棒」公益高爾夫活動為早產兒募款',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2014Text = [
  {
    type: 'normal',
    text: [
      '>首辦「母親節桔梗花傳愛」活動，獻花給11家安胎示範病房的安胎媽媽們並為她們加油打氣',
      '>「守護小腳丫」早產兒關懷活動，榮獲財團法人公共關係基金會頒發2014非營利組織公關獎',
      '>製作「安霓日記」衛教宣導短片',
      '>父親節在市立動物園，舉辦「小腳丫相見歡」與貓熊寶貝”圓仔”有約早產兒親子活動',
      '>響應1117世界早產兒日，與台北市政府衛生局合辦「守護小腳ㄚ，跨出大人生」記者會，當晚與全球同步在台北市政府周邊及信義商圈點亮紫燈',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2015Text = [
  {
    type: 'normal',
    text: [
      '>「孕媽咪早產防治」行動網站啟用',
      '>與新生兒科醫學會共同推動「台灣新生兒聯合網絡Taiwan Neonatal Network (TNN)」',
      '>「巴掌小袋鼠－早產衛教故事屋」首演記者會，分別在合約醫院及社區巡迴演出',
      '>舉辦「早產兒政策論壇」座談會，討論「兒少立法後，中央與地方如何共同推動早產防治及落實早產兒追蹤」議題',
      '>響應1117世界早產兒日，與新竹市政府共同召開「守護小腳丫．跨出大人生」記者會，當晚與全球同步在新竹東門城及台北101商圈點紫燈',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2016Text = [
  {
    type: 'normal',
    text: [
      '>《給早產兒-第二次機會》記錄片首映記者會',
      '>王育敏立委辦公室召開「早產兒追蹤檢查計畫及相關預防保健政策」協調會',
      '>製作「孕婦產前檢查自我檢核紀錄」海報，寄送至22家縣市衛生局和723家醫療院所張貼宣傳',
      '>「早產兒名人巡迴展-抓周one歲」漫畫刊版於合約醫院巡迴展覽',
      '>響應1117世界早產兒日，在台中國家歌劇院舉行「守護小腳丫跨出大人生」記者會，當晚與全球同步在台中國家歌劇院、新竹東門城及台北101商圈點亮關懷紫燈',
      '>製作「小腳丫記者．立院大冒險」宣導短片，由長大早產兒採訪陳曼麗、林靜儀及黃秀芳委員，宣導加強民眾早產防治概念',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2017Text = [
  {
    type: 'normal',
    text: [
      '>承接國民健康署「極低出生體重早產兒追蹤關懷先驅計畫」',
      '>響應1117世界早產兒日，與國民健康署共同召開「守護小腳丫跨出大人生」記者會，當晚與全球同步在台南赤崁樓、台中國家歌劇院、新竹東門城及台北101商圈，點亮關懷紫燈',
      '>「愛在台南平安福 預防早產保安康」關懷小腳丫公益園遊會',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2018Text = [
  {
    type: 'normal',
    text: [
      '>承接國民健康署「早產兒健康照護數位教材製作暨宣導案」',
      '>「好孕旅程」早產防治動畫影片臉書首映宣傳',
      '>「早產兒youtube」頻道系統化，擴大衛教宣傳之效益',
      '>邀請7位網紅醫師拍攝公益衛教系列，於臉書及youtube宣傳',
      '>響應1117世界早產兒日，與國健署召開記者會，共同推動e化「早產兒居家照顧手冊」電子版，會中首映「小花與醬醬」早產兒成長記錄片。當晚在台北信義商圈、新竹東門城、台中柳川水岸、台南赤崁樓及高雄大立精百貨，五都點亮紫燈，為小腳丫祈福!',
      '>與立法委員吳玉琴、黃秀芳辦公室及新生兒科醫學會共同舉辦「一個都不能少 台灣新生兒醫療政策三大訴求共識會議」，共同為台灣新生兒醫療政策發聲與支持。',
    ],
    style: {
      marginTop: '0px',
    },
  },
];
export const historyTimeline2019Text = [
  {
    type: 'normal',
    text: [
      '>承接辦理新北市政府衛生局「108年-109年度新北市早產兒個案管理計畫案」',
      '>結合產官學推動周產期及早產兒議題，出席國家衛生研究院舉辦「周產期及新生兒轉診制度國際研討會」及「改善兒童藥品及醫材短缺」共識研討會',
      '>第七年與全台11家安胎示範病房同步舉辦「母親節桔梗花傳愛」活動，送花給住院安胎媽媽並為其加油打氣',
      '>響應1117世界早產兒日，與新北市政府召開記者會，呼籲極低體重早產兒追蹤檢查的重要性，把握黃金療育期讓早產兒能順利長大響應世界早產兒日，於臉書發起「E起紫爆」換大頭貼活動。當晚在台北101信義商圈、新北市新月橋﹑台中麗寶樂園、台南赤崁樓、高雄大立精品百貨及屏東鵬灣跨海大橋同步點早產兒代表色的亮紫色燈光，為早產兒祈福',
      '>與全球新生兒照護聯盟(Global Alliance for Newborn Care)串聯，並協助將新生兒照護全球行動呼籲譯成中文版本',
      '>申請辦理「109關懷早產兒勸募專案」勸募活動，通過衛福部社會救助及社工司公益勸募管理系統平台審核，許可文號為：衛部救字第第1081370408號',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2020Text = [
  {
    type: 'normal',
    text: [
      '>與台灣新生兒科醫學會及吳玉琴立法委員辦公室共同推動之「兒童困難取得之臨床必要藥品及醫材調度中心」正式上線。',
      '>承接新北市政府衛生局委辦之「108年-109年度新北市早產兒個案管理計畫」。',
      '>「母親節桔梗花傳愛」活動，全台11家安胎示範病房同步舉行，邀請陳治平董事長及張德馨董事代表，送花給馬偕醫院住院安胎媽媽並為其加油打氣。',
      '>本會與台灣新生兒科醫學會、立委吳玉琴、黃秀芳，歷時兩年促成「兒童困難取得之臨床必要藥品及醫材調度中心」於10月正式上線，呼籲『優化早產兒醫療資源、一個不能少』。',
      '>響應世界早產兒日，晚間在台北信義商圈、新北市新月橋﹑台中麗寶樂園、台南赤崁樓、高雄市立圖書館、高雄衛武營藝術中心、屏東鵬灣跨海大橋、臺東市國際地標、鐵花新聚落及臺東故事館同步點亮早產兒代表色紫色燈光，並首創線上串聯點燈為早產兒祈福。',
      '>申請辦理「110關懷早產兒勸募專案」勸募活動，通過衛福部社會救助及社工司公益勸募管理系統平台審核，許可文號為：衛部救字第1091364579號。',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2021Text = [
  {
    type: 'normal',
    text: [
      '>完成衛教動畫影片「極低出生體重早產兒五大問」及「黃金一分鐘」，同步上架官網及Youtube。',
      '>承接辦理新北市政府衛生局「108年-109年度新北市早產兒個案管理計畫案」之110-111年擴充計畫。',
      '>出版「早產兒基金會30週年特刊」及「追蹤專案25週年紀念專刊」，呈現基金會30年的服務成果及極低出生體重早產兒追蹤成效。',
      '>舉辦「台灣早產兒基金會30週年感恩記者會」及「早產兒基金會30週年暨追蹤25週年學術研討會」，呼籲政府及社會大眾持續關注早產議題、優化早產兒醫療資源、持續推動高危險妊娠孕產婦追蹤、爭取兒童用藥權益等相關醫療照護，保護國家未來的主人翁。',
      '>響應世界早產兒日，晚間在台北馬偕醫院、新北市新月橋、碧潭吊橋、淡海情人橋、桃園藝文展演中心、台中心之谷教育園區、台中麗寶樂園、台南赤崁樓、台灣文學館、高雄市立圖書館、屏東鵬灣跨海大橋、恆春南城門、臺東市國際地標、國際地標及花蓮新車站同步點亮早產兒代表色紫色燈光，首創全台公益光雕點燈為早產兒祈福。',
      '>向衛福部社會救助及社工司申請111年度公益勸募許可文號。(12/22函許可文號為：衛部救字第1101364652號)',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2022Text = [
  {
    type: 'normal',
    text: [
      '>本會「新官網」及「好孕媽咪APP」正式上架。',
      '>承接辦理新北市政府衛生局「108年-109年度新北市早產兒個案管理計畫案」之110-111年擴充計畫。',
      '>完成衛教影片「預防早產兒RSV感染，降低重症風險」首播，同步上架官網及Youtube。',
      '>於台北市立兒童新樂園舉辦「世界早產兒日11.17讓愛轉動」點燈儀式，呼籲政府及社會大眾持續關注早產議題、優化早產兒醫療資源、持續推動高危險妊娠孕產婦追蹤。當晚同步於台中麗寶樂園及花蓮遠雄海洋公園同步點亮代表早產兒的紫色摩天輪。',
      '>申請112年度衛福部社會救助及社工司公益勸募管理系統平台公益勸募專案，許可文號-衛部救字第1111364685號。',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const historyTimeline2023Text = [
  {
    type: 'normal',
    text: [
      '>「母親節桔梗花傳愛」活動，全台11家安胎示範病房同步舉行，張瑞幸董事長及永齡基金會一同出席，送花給聖保祿醫院住院安胎媽媽並為其加油打氣。曾馨瑩女士擔任2023年度早產兒防護大使，拍攝代言宣導影片。',
      '>邀請台灣新生兒科醫學會進行「早產兒經常性自費支出費用補助共識會」，討論早產兒常見自費項目及合理補助金額，出版「2023早產兒政策建言書」。',
      '>與吳玉琴、蘇巧慧、陳靜敏立法委員國會辦公室共同舉辦「支持早產兒養育照護津貼，守護健康成長指標」記者會，會中王婉諭委員、黃秀芳委員及新生兒科醫學會鄭玫枝秘書長一同出席呼籲民眾重視早產議題。',
      '>於台中秋紅谷及心之谷永續教育園區舉辦點燈儀式，呼籲政府及社會大眾持續關注早產議題、優化早產兒醫療資源、持續推動高危險妊娠孕產婦追蹤。',
      '>竹北東元醫院、高雄聖功及苗栗大千醫院加入本會合約醫院。',
      '>制定與執行「出生≦29週且體重>1500公克個案心智發展檢查補助」及「早產兒視網膜病變眼內注射藥補助試辦計畫」。與新生兒科醫學會合作出版「早產兒爸媽情緒安定筆記」。',
    ],
    style: {
      marginTop: '0px',
    },
  },
];

export const currDirectorList = [
  {
    type: 'important',
    text: '現任 第十屆(107.12-110.12)',
  },
  {
    type: 'normal',
    text: [
      '董事長：陳治平',
      '董 事：王昭珷、吳玉琴、林瑞瑩、陳金杏、陳震宇、許瓊心、張凱、張弘洋、張德馨、彭純芝、鄒國英、詹俊裕、鄭文宗、鄭明敏',
    ],
  },
];

export const formerDirectorList = [
  {
    type: 'important',
    text: '第九屆(107.12-110.12)',
  },
  {
    type: 'normal',
    text: [
      '董事長：陳治平',
      '董 事：王昭珷、吳玉琴、林瑞瑩、陳金杏、陳震宇、許瓊心、張凱、張弘洋、張德馨、彭純芝、鄒國英、詹俊裕、鄭文宗、鄭明敏',
    ],
  },
  {
    type: 'important',
    text: '第八屆(107.12-110.12)',
  },
  {
    type: 'normal',
    text: [
      '董事長：陳治平',
      '董 事：王昭珷、吳玉琴、林瑞瑩、陳金杏、陳震宇、許瓊心、張凱、張弘洋、張德馨、彭純芝、鄒國英、詹俊裕、鄭文宗、鄭明敏',
    ],
  },
];

export const prepareToDischargedFromHospitalTexts = [
  {
    type: 'normal',
    text: '其實出院準備從寶寶出生後就可以開始，例如儘早到病房中探視嬰兒、觸摸嬰兒、參與嬰兒的照顧（餵奶，換尿片等），甚至於施行袋鼠式護理法，都可以增進親子關係，促進爸媽對寶寶的了解，增進照顧嬰兒的信心。',
  },
  // {
  //   type: 'normal',
  //   text: '早產寶寶在醫院歷經了「過五關‧斬六將」後，隨著病情穩定及體重增加達一定程度後，終於可以開心的跟著爸比媽咪們回到溫暖的家囉！不過，早產新手家長們是不是感覺到一股壓力襲來呢？！別擔心，這是正常的反應，也是每個要迎接寶貝回來的家庭都會面臨的問題。父母親心情的起伏不安，除了擔心疾病合倂症外，隨即擔心孩子出院後的居家照顧適應，深害怕因照顧的疏失而讓寶寶受到絲毫傷害。因此能在寶貝出院前，做好完善的居家環境準備及規劃，相信能幫助您們將不安及焦慮情緒降到最低喔。',
  // },
  {
    type: 'important',
    text: '一、出院時機',
  },
  {
    type: 'normal',
    text: [
      '寶寶出院的時間依據個別狀況而有所不同，但會有以下基本原則：',
      '1.營養攝取不需使用靜脈注射，可完全藉由瓶餵或胃管進食。',
      '2.可以自行維持穩定的體溫，不需要保溫箱。',
      '3.體重穩定增加，已達2,000-2,300公克或以上。',
      '4.沒有嚴重、急性的內外科疾病。',
      '5.可脫離呼吸器，但若有長期使用呼吸器需求，經醫師許可，在寶寶使用呼吸器穩定的情況下，透過出院衛教，可帶呼吸器返家，由照顧者自行照護。',
    ],
  },
  {
    type: 'important',
    text: '二、照護學習',
  },
  {
    type: 'normal',
    text: [
      '1.一般照護：洗澡、餵奶、體溫測量、及如何觀察正常生理狀況等，並了解寶寶的作息及喝奶情形，學習熟悉遇到特殊問題時之觀察與處理方式。',
      '2.特殊衛教：若您的孩子經醫師評估出院後仍需使用氧氣或血氧濃度監測器者，於出院前應事先與廠商聯繫租借儀器，並學習操作技巧至可完全獨立使用為止。必要時亦需學習抽痰及拍痰技巧。',
    ],
  },
  // {
  //   type: 'normal',
  //   text: '若您的孩子經醫師評估出院後仍需使用氧氣或血氧濃度監測器者，於出院前應事先與廠商聯繫租借儀器，並學習操作技巧至可完全獨立使用為止。必要時亦需學習抽痰及痰拍技巧。',
  // },
  {
    type: 'important',
    text: '三、用物準備',
  },
  {
    type: 'normal',
    text: [
      '在寶寶回家前將所需的日常用物事先備妥，同時必須確認要有足夠存量。',
      '1.餵食用具：奶瓶、奶嘴、溢奶巾(多條)、消毒鍋器具、奶瓶刷、奶粉。',
      '2.穿著用具：紗布衣、外衣、帽子、襪子手套、尿布、小毛巾、包巾。',
      '3.清潔用具：專用澡盆、肥皂(嬰兒用沐浴乳)、柔濕巾(護理巾)、浴巾、保暖用具。',
      '4.居家寢具：獨立嬰兒床、棉被、尿布墊。',
      '5.外出用品：背巾、推車、安全座椅。',
    ],
  },
  {
    type: 'important',
    text: '四、環境設置',
  },
  {
    type: 'normal',
    text: [
      '1.保持房間空氣通暢及環境清潔。',
      '2.注意室內光線保持充足以利評估觀察孩子的變化。',
      '3.注意溫溼度控制，室內溫度建議維持攝氏25-28度；且台灣屬海島型國家，空氣溼度偏高，視情況家中可準備冷氣機或除濕機；而於冬天可備電暖氣。',
    ],
  },
  {
    type: 'important',
    text: '五、藥物使用',
  },
  {
    type: 'normal',
    text: [
      '於返家前照顧者需確實了解藥物作用及正確使用方法，回家後須按時給予正確劑量。',
      '1.口服鐵劑：補充鐵質及預防貧血，一般服用至矯正年齡9-12個月大。',
      '2.另外常見藥物：綜合維他命、維他命D3、益生菌、消化劑等。',
    ],
  },
  // {
  //   type: 'normal',
  //   text: '早產寶寶出院後常有攜帶藥物返家的機會，因此爸比媽咪們應於返家前確實了解藥物作用及正確使用方法，回家後須按時給予正確劑量。 ',
  //   style: {
  //     marginTop: '16px',
  //   },
  // },
  // {
  //   type: 'normal',
  //   text: '早產兒為補充成長所需之鐵質及預防貧血，通常於出院後會持續口服鐵劑，一般服用至矯正年齡9-12個月大，而服用鐵劑時其大便呈現深綠色為正常現象。另外常見藥物為綜合維他命、消化劑、利尿劑等，請依定要遵從醫師醫囑服用。',
  // },
  {
    type: 'important',
    text: '六、照顧者心理準備',
  },
  {
    type: 'normal',
    text: '鼓勵照顧者對自己信心喊話，必要時尋求管道抒發情緒和取得建議，調整狀態，以正向的態度來克服接踵而來的各項照顧挑戰，唯有在身心狀態準備好的情況，才能幫助寶寶做最適切的照顧。',
  },
  {
    type: 'important',
    text: '七、家庭緊急聯絡系統',
  },
  {
    type: 'normal',
    text: '建議整理常用及緊急時所需聯繫的電話資料，適當尋求支援，可以在面臨緊急狀況時，能有效率、快速地取得聯絡以幫寶寶做適當處置。',
  },
];

export const communicationServiceAndPropagandaDesc = [
  {
    type: 'large',
    text: [
      '因全民健保的實施提高了早產兒的就醫機會，但其家庭在早產兒出院時往往面臨身理及心理上極大的壓力，使得早產兒返家後無法獲得良好的後續照護。',
    ],
  },
  {
    type: 'normal',
    text: '為落實早產兒持續性照護，小組致力於建立早產兒居家照護之服務模式，追蹤及管理早產兒出院後之照護及發展，提升早產兒家庭生活品質，促進早產兒出院後之健康以降低醫療成本。期待小組的努力能幫助更多的早產兒家庭有更好的未來。',
    style: {
      marginTop: '50px',
    },
  },
];

export const communicationServiceAndPropagandaMemberTitle = [
  {
    type: 'large',
    text: '(一)早產兒基金會社區健康中心成員：',
  },
];

export const communicationServiceAndPropagandaMembersService = {
  // 周瑞瑩護理師
  1: [
    {
      type: 'normal',
      text: [
        '1.早產防治暨早產兒照護衛教諮詢',
        '2.舉辦早產兒父母成長團體',
        '3.認識早產暨早產兒居家照護教育宣導',
        '4.早產兒社區資源提供及轉介',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
  // 陳嘉蕙社工師
  2: [
    {
      type: 'normal',
      text: [
        '1.醫療補助申請及社會福利諮詢',
        '2.早產兒防治校園暨社區教育宣導',
        '3.早產兒回娘家活動申請及評估',
        '4.早產兒諮詢義工管理與訓練',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
  // 童子庭管理師
  3: [
    {
      type: 'normal',
      text: '出生體重低於1501公克早產兒之追蹤 檢查專案管理及諮詢服務等',
      style: {
        marginTop: '0px',
      },
    },
  ],
};

export const communicationServiceAndPropagandaMembersPhone = {
  // 周瑞瑩護理師
  1: [
    {
      type: 'normal',
      text: ['電話:02-25230908', '傳真:02-25217723', '(提供全國諮詢電話服務)'],
      style: {
        marginTop: '0px',
      },
    },
  ],

  // 陳嘉蕙社工師

  2: [
    {
      type: 'normal',
      text: ['電話:02-25230908', '傳真:02-25217723'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  // 童子庭管理師
  3: [
    {
      type: 'normal',
      text: ['電話:02-25221792', '傳真:02-25217723'],
      style: {
        marginTop: '0px',
      },
    },
  ],
};

export const communicationServiceAndPropagandaMembersTime = [
  {
    type: 'normal',
    text: ['週一至週五', '8:00~12:00', '13:00~17:00', '(國定假日未提供服務)'],
    style: {
      marginTop: '0px',
    },
  },
];

export const communicationServiceAndPropagandaServicesTitle = [
  {
    type: 'large',
    text: '(二)服務項目：',
  },
];

export const communicationServiceAndPropagandaServices = {
  1: [
    {
      type: 'normal',
      text: [
        '早產兒個案諮詢服務',
        '早產兒社區健康中心提供電話、官網以及Facebook等多元管道的衛教諮詢服務，針對有早產兒出院後居家照顧相關問題之家庭，適時的給予問題解決及轉介，以提升居家照護的能力，降低父母親因照護問題所帶來的焦慮及壓力。',
        '衛教諮詢專線：02-2523-0908 (星期一至星期五 8:00~12:00；13:00~17:00）',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
  2: [
    {
      type: 'normal',
      text: [
        '家庭訪視',
        '本會2006年至今推展早產兒居家訪視服務補助方案，補助合約醫院3,046個案，補助金額4,279,500元。',
        '透過本會多年遊說倡議下，衛生福利部國民健康署自2021-2024年試辦「低(含極低)出生體重兒居家照護計畫」，2025年將繼續擴大推展補助服務，因此，為使基金會資源充分運用，避免造成重複補助，本會自2025年起取消早產兒居家訪視服務補助。',
      ],
      style: {
        marginTop: '0px',
      },
    },
    {
      type: 'normal',
      // render: h('div', [
      //   h('p', { style: { display: 'flex' } }, [
      //     h(OpenItem, {
      //       link: {
      //         name: 'form-download',
      //       },
      //       label: '詳細補助方式請於各式表單中自行下載',
      //       type: 'internal',
      //     }),
      //   ]),
      //   h(ImageSameHeight, {
      //     images: [communicationImg10, communicationImg11, communicationImg12],
      //   }),
      // ]),

      style: {
        marginTop: 0,
      },
    },
  ],
  3: [
    {
      type: 'normal',
      text: '提供相關醫療資訊及轉介',
      style: {
        marginTop: '0px',
      },
    },
  ],
  4: [
    {
      type: 'normal',
      text: [
        '成立早產兒父母成長團體',
        '近年來，由於醫療科技的精進，醫護品質的提昇使得早產兒的生存機會提高，而這些存活下來的早產兒在住院期間有醫療團隊的照顧，但出院後其家庭即面對獨自照顧上的壓力，父母長期照顧早產兒往往造成身體與心理上的疲憊，且心情亦隨著寶寶的一舉一動而忐忑不安。',
        '有鑑於此，早產兒基金會社區護理小組成立了早產兒父母成長團體，並由北、中、南各區進行全國性推廣，期望藉此活動的參與，除了加強相關育嬰知識外，更讓早產兒家庭能有彼此分享照顧的機會，使在照顧早產兒的過程中更為順利。',
      ],
      style: {
        marginTop: '0px',
      },
    },
    {
      render: h(ImageSameHeight, {
        images: [communicationImg1, communicationImg2, communicationImg3],
      }),
    },
  ],
  5: [
    {
      type: 'normal',
      text: [
        '早產兒居家照護教育宣導',
        '(1)托育人員早產兒居家照護研習會',
        '有鑒於早產兒的誕生為家庭帶來之衝擊，返家後的早產兒居家照護及其家庭面臨挑戰，如何讓早產兒在返家後延續良好的照顧及生活品質，是本會所努力的目標之一。然現代社會雙薪家庭比重提高，極需倚重專業保母人員協助父母照顧返家的早產兒，而保母人員極容易因不熟悉早產兒之特性與照護方式，進而婉拒照顧，讓早產兒及其照顧系統陷入危機。',
        '早產兒基金會自100年起分別於北、中、南…等地區舉辦『早產兒居家照護—保母人員研習會』，邀請各區保母從業人員共同進修早產兒居家照護課程。課程內容包含認識早產、早產兒異常徵象之評估與處理、早產嬰幼兒之生長與發育評估、早產兒居家照護技巧與常用儀器設備簡介、早產嬰幼兒之營養與副食品添加、社會資源之運用。期盼藉由課程訓練，讓保母人員對早產兒有正確的認知，提升照顧早產兒的意願，進而協助早產兒家庭於早產兒返家之照護困境。',
      ],
      style: {
        marginTop: '0px',
      },
    },
    {
      render: h(ImageSameHeight, {
        images: [communicationImg4, communicationImg5, communicationImg6],
      }),
    },
    {
      type: 'normal',
      text: [
        '(2)社區居家托育服務中心、校園暨其他機構宣導',
        '由於近年來生育率逐漸回升，雙薪家庭對保母托育需求也逐日高升，早產兒基金會除了於全國各區域輪流舉辦「保母人員早產兒居家照護研習會」外，亦走遍全台進入各鄉鎮，進行多場次的托育人員相關機構「早產兒居家照護」之課程宣導，期盼與課的托育人員，藉由知識與專業性的提升，強化對早產兒居家照護的能力及意願，進一步協助有托育服務需要的早產兒家庭。',
      ],
      style: {
        marginTop: '0px',
      },
    },
    {
      render: h(ImageSameHeight, {
        images: [communicationImg7, communicationImg8, communicationImg9],
      }),
    },
  ],
};

export const whatIsPreemieTitleOne = [
  {
    type: 'important',
    text: '(一)早產發生的原因，目前僅有50%可以探知其相關因素 ，大致可由以下幾個方面來分析：',
  },
  {
    type: 'normal',
    text: '因此，懷孕中的婦女，都必須注意早產徵象，儘量避免早產的發生。1947年，著名產科權威 Dr.Eastman 表示『唯有對造成早產的多項原因充分的了解，才能有效的預防。』正如同所有的疾病一樣，預防重於治療。',
  },
];

export const whatIsPreemieIntro = [
  {
    type: 'normal',
    // text: '『唯有對造成早產的多項原因充分的了解，才能有效的預防。』',
    render: h('p', { style: font({}) }, [
      h(
        'span',
        '由於早產的發生有50%不明原因，經評估為高危險群者，並非一定會早產，而經評估非高危險群者，也不表示一定不會早產。因此，懷孕中的婦女，都必須注意早產徵象，儘量避免早產的發生。1947年，著名產科權威 Dr.Eastman 表示',
      ),
      h(
        'span',
        {
          style: font({ fontWeight: '700' }),
        },
        '『唯有對造成早產的多項原因充分的了解，才能有效的預防。』',
      ),
      h('span', '正如同所有的疾病一樣，預防重於治療。'),
    ]),
  },
];

export const whatIsPreemieDetail = [
  {
    type: 'important',
    text: '一、早產的定義',
  },
  {
    type: 'normal',
    text: [
      '▶早產兒：出生週數大於20週，小於37週之新生兒',
      '▶低體重出生兒：出生體重＜2500公克之新生兒',
      '▶極低體重出生兒：出生體重≦1500公克之新生兒',
    ],
  },
  {
    type: 'important',
    text: '二、早產的高危險群',
  },
  {
    type: 'normal',
    text: '早產發生的原因，目前僅有50%可以探知其相關因素 ，大致可由以下幾個方面來分析：',
  },
  {
    render: h(SimpleTable, {
      content: highRiskGroupsContent,
    }),
  },
];

export const howToPrevent = [
  {
    type: 'important',
    text: '一、孕前準備及預防措施',
  },
  {
    type: 'normal',
    text: [
      '首先諮詢婦產科以了解本身是否屬於早產高危險群、培養正確認知，盡可能消除或減低風險。',
      '1.定期且確實配合產前檢查，透過產檢及病史評估作早產高危險因子判定，並加以因應及重視。',
      '2.維持正常的妊娠時間，儘量延長胎兒在子宮內成長的時間。 ',
    ],
  },
  {
    type: 'important',
    text: '生活習慣',
  },
  {
    type: 'normal',
    text: [
      '◎維持健康營養攝取、保持心情愉快。',
      '◎勿抽煙、喝酒及成癮藥物使用者。',
      '◎培養良好生活衛生習慣，勿憋尿、避免久坐久站。',
      '◎減少工作壓力及工作量，勿工作過度勞累。',
      '◎避免長途勞累、避免提重物以增加腹壓。',
    ],
  },
  {
    type: 'important',
    text: '生理狀況',
  },
  {
    type: 'normal',
    text: [
      '◎避免青少年、高齡時懷孕。',
      '◎孕前避免體重過輕(<40kg)。',
      '◎懷孕間隔勿太密。',
      '◎曾人工流產。',
      '◎避免子宮頸傷害。',
      '◎有子宮頸閉鎖不全病史。',
      '◎避免醫源性(人工生殖)多胞胎',
    ],
  },
  {
    type: 'important',
    text: '二、了解孕期現象',
  },
  {
    type: 'normal',
    text: [
      '1.胎動(胎兒的活動)：',
      '舉凡翻身﹑打嗝都算。初產婦通常胎動出現在懷孕20週左右，經產婦則在18週左右。當孕婦感覺胎動減少時，可用手輕推肚子、吃點甜食、飲料或走動刺激胎動，觀察半個小時到半天。',
      '2.宮縮：',
      '懷孕期間可能會偶爾有生理性收縮，症狀為偶發性、不規則，持續時間較短，在休息後多可緩解。正常標準為：30週以前，大約＜3次/時，30週以後，大約＜4次/時，如超過標準，請臥床休息並每天以手觸摸子宮2-3次，注意每小時收縮、變硬的次數，若仍無改善，需立即就醫。',
      '3.分泌物、漏尿、破水辨識：',
    ],
  },
  {
    render: h(SimpleTable, {
      content: understandPregnantContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
  {
    type: 'important',
    text: '認識早產徵兆',
  },
  {
    type: 'normal',
    text: ['◎胎動：'],
  },
  {
    type: 'normal-indent',
    text: [
      '1.突然胎動劇烈。',
      '2.二小時內無胎動者。',
      '3.一天胎動少於10次。',
      '4.與平常及前一天相比，胎動次數減少50%。',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: [
      '◎早期子宮收縮：',
      '異常子宮收縮是頻率規則、持續時間長，休息也無法緩解，而且子宮頸可能會軟化或擴張。每小時有5-6次以上(等於每10分鐘有1次以上)的子宮收縮。',
      '◎持續的下背痠痛或腰酸感。',
      '◎如月經來時的下腹悶痛或脹痛及腫脹。',
      '◎持續不斷的腹瀉及腸絞痛。',
      '◎腹部痙攣、或有下墜感、陰道骨盆有壓迫感(覺得好像胎兒往下推)，經臥床休息，情況仍持續沒有改善。',
      '◎破水：陰道流出清澈透明的水樣液體，或羊水突然大量流出。',
      '◎陰道分泌物增加或夾雜紅色血絲：鮮紅血狀分泌物或大量出血(約第2-3天經血量或更多)可能為產前出血，或是原有出血情形但經醫生診治後返家休息，突然出血量增加或出現血塊。',
    ],
  },

  {
    type: 'normal',
    text: '懷孕過程中若有以上異常情形，請立即求治婦產科，萬一無法避免早產，建議選擇有新生兒加護病房的醫院生產，避免等到早產兒出生再轉送，容易因後送，造成體溫降低、呼吸窘迫等，產生日後的併發症。',
  },
];

export const correctedAgeWording = [
  {
    type: 'normal',
    text: [
      '由預產期當天開始算的年齡。',
      '例如：寶寶出生日期3月1日出生，預產期為5月１日，在9月1日時，其出生後年齡為4個月。 ',
      '矯正年齡的算法則為：',
    ],
  },
  {
    render: CorrectedAge,
  },
];

export const whatIsPreemieAnalytic = {
  1: [
    {
      type: 'normal',
      text: [
        '◎ 營養狀況不良 ',
        boldText('◎抽菸、喝酒'),
        '◎ 使用成癮藥物。 ',
        '◎ 工作過度勞累。 ',
        '◎ 衛生習慣不良。 ',
        '◎ 情緒焦躁不安。 ',
        '◎ 貧血…等。',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
  2: [
    {
      type: 'normal',
      text: [
        boldText('◎懷孕年齡小於18歲或大於40歲。'),
        '◎ 未婚懷孕。 ',
        '◎ 孕前體重不足。 ',
        '◎ 曾發生過早產、早發陣痛或妊娠早期～中期流產。 ',
        '◎ 懷孕間隔太密。 ',
        '◎ 曾患腎盂腎炎。 ',
        '◎ 前胎有子宮閉鎖不全之現象。 ',
        '◎ 曾有不良的產科病史。 ',
        '◎ 子宮接受過手術〈如人工流產...等〉。',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
  3: [
    {
      type: 'normal',
      text: [
        '◎ 感染、發燒。',
        renderBoldText('ddd'),
        '◎ 子癲前症、妊娠高血壓。 ',
        '◎ 多胞胎。 ',
        '◎ 前置胎盤。 ',
        '◎ 胎盤早期剝離。 ',
        '◎ 早期破水。 ',
        '◎ 羊水過多或過少。 ',
        '◎ 子宮畸型。 ',
        '◎ 腹部手術。 ',
        '◎ 產前曾出血。 ',
        '◎ 身體或情緒方面的創傷。 ',
        '◎ 胎兒染色體異常或先天性畸型。',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
};

export const whatIsPreemieTitleTwo = [
  {
    type: 'important',
    text: '(二)孕媽咪請注意，哪些是容易早產的母體與胎兒：',
  },
];

export const whatIsPreemieNotice = {
  1: [
    {
      type: 'normal',
      text: '胎盤：前置胎盤，胎盤功能不佳或胎盤早期剝離。',
      style: {
        marginTop: '0px',
      },
    },
  ],
  2: [
    {
      type: 'normal',
      text: '子宮：子宮畸形，例如：雙角子宮或子宮肌瘤造成胎兒成長空間狹小；子宮頸閉鎖不全，或是接受過原位癌之子宮頸錐狀切除或流產手術。',
      style: {
        marginTop: '0px',
      },
    },
  ],

  3: [
    {
      type: 'normal',
      text: [
        '胎兒：',
        '(1)先天畸形：例如，食道閉鎖不全，造成羊水過多。',
        '(2)子宮內生長遲緩：胎兒特別的小，懷孕時照超音波可以發現。',
        '(3)雙胞胎或多胞胎：雙胞胎有一半的機率會早產，三胞胎的機率更大，以此類推。',
        '(4)胎兒過大：媽媽本身子宮無法負荷，子宮便會提早收縮，造成早產。',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
  4: [
    {
      type: 'normal',
      text: [
        '母體：',
        '(1)妊娠高血壓：常會合併胎盤早期剝離，或不適合繼續懷孕而必須及早引產。',
        '(2)妊娠糖尿病：可能會產下巨嬰，子宮不能負荷便會提早宮縮。',
        '(3)孕期感染：例如，泌尿道及生殖系統的感染，容易使細菌跑到子宮內，造成胎盤內絨毛膜及羊膜發炎，造成刺激而提早宮縮破水。',
        '(4)孕期腹部急症：例如盲腸炎或是卵巢扭轉、腹膜炎，發炎組織會刺激宮縮。 (5)母親年齡：超過 40 歲而懷孕早產比率較高， 18 歲以下則是因為社會壓力及本身未發育完全，也容易早產。 (6)不良生活習慣：抽煙、喝酒及濫用藥物都會造成早產。 (7)孕期體重：超過80公斤或小於40公斤。',
      ],
      style: {
        marginTop: '0px',
      },
    },
  ],
};

export const dischargedLowWeightCheckingText = [
  {
    type: 'large',
    text: '出院後追蹤檢查工作',
  },
  {
    type: 'normal',
    text: '『早期發現：早期治療』',
  },
  {
    type: 'normal',
    text: '早產兒出院後的定期回診對於追蹤檢查工作非常重要!為了克服出生時生理條件的差異，出生體重小於1501公克的早產兒在矯正年齡兩歲以前，需要更充分的環境刺激、訓練機會以促進其發展。此時，家庭環境的配合、家屬的支持、相關教養知識的瞭解，以及處理技巧...等諮詢就更顯重要，這些都可藉由早產兒追蹤檢查門診提早發現問題，讓專業的醫護相關人員幫助父母進行評估，進一步提供給早產兒更好的發展環境與機會。',
    style: {
      marginTop: '0px',
    },
  },
  {
    type: 'normal',
    text: '『兩歲追蹤』',
    style: {
      marginTop: '20px',
    },
  },
  {
    type: 'normal',
    text: ' 有鑑於此，基金會於民國1995年8月起，在台灣北、中、南陸續開辦七區「極低出生體重早產兒出院後的追蹤檢查工作」。配合新生兒醫師、兒童發展心理師及早產兒個案管理師等專業人員，於矯正年齡 6、12、24 個月時返診進行評估，及早發現問題、及時做適當處置或轉介至眼科、耳鼻喉科、復建科、早療...等機構，期待將早產併發的後遺症減至最低，並獲得完善治療。',
    style: {
      marginTop: '0px',
    },
  },
  {
    type: 'normal',
    text: '『五歲追蹤』',
    style: {
      marginTop: '20px',
    },
  },

  {
    type: 'normal',
    text: '其後，為進一步協助瞭解早產兒於學齡前之適應狀況，本會於2006年8月起，提出「極低體重早產兒五歲追蹤計畫」，此時期的評估重點放在對學習的影響上，如：注意力缺失、過動、語言及理解問題、動作協調、視力狀況或是學習適應不良等問題。期盼藉由學齡前的相關評估，協助極低體重早產兒為就學做準備。',
    style: {
      marginTop: '0px',
    },
  },
  {
    type: 'normal',
    text: '『擴大全國性服務計畫』',
    style: {
      marginTop: '20px',
    },
  },

  {
    type: 'normal',
    text: '考量極低體重早產兒出院後追蹤檢查之重要性，為能普及全國，本會自2009年至2011年推行「極低體重早產兒全國性三年服務計畫」。其後，並於2012年起續推「極低體重早產兒擴大全國性服務計畫」，將追蹤檢查評估模式與及時轉介概念，推廣至台灣北、中、南、東部未曾進行追蹤檢查的醫院，照顧全國更多有需要的早產兒。',
    style: {
      marginTop: '0px',
    },
  },
];

export const dischargedTrackingTitleAnd1999 = [
  {
    type: 'large',
    text: '出院後追蹤檢查工作',
  },
  {
    type: 'important',
    text: '台灣極低體重早產兒至二歲的發展預後—1999年成果報告',
  },
];

export const dischargedTracking2011 = [
  {
    type: 'important',
    text: '台灣極低出生體重早產兒十年期間的早期預後—2011年成果報告',
  },
];

export const dischargedTrackingBook = [
  {
    type: 'important',
    text: ['★台灣極低出生體重早產兒十年期間的早期預後-', '2011年成果報告【實體書籍索取】'],
  },
  {
    type: 'normal',
    text: [
      '本書印製成冊並已發送本會合約醫院之早產兒照護相關單位及全國衛生局，提供本土化早產兒醫療與預後珍貴的參考數據。目前尚有少量庫存，有興趣之醫護人員歡迎來電索取',
      '【02-2522-1792 童小姐】。',
    ],
  },
];

export const dischargedTracking1999Text = {
  1: [
    {
      type: 'normal',
      text: ['鄒國英', '曹伯年'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  2: [
    {
      type: 'normal',
      text: '林鴻志',
      style: {
        marginTop: '0px',
      },
    },
  ],
  3: [
    {
      type: 'normal',
      text: ['何茂霖', '陳家玉'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  4: [
    {
      type: 'normal',
      text: ['王儷燕', '陳昭惠'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  5: [
    {
      type: 'normal',
      text: ['王藍浣', '黃朝慶', '林其和', '王新台'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  6: [
    {
      type: 'normal',
      text: ['陳淑貞'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  7: [
    {
      type: 'normal',
      text: ['陳英堯', '謝凱生'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  8: [
    {
      type: 'normal',
      text: ['周怡宏'],
      style: {
        marginTop: '0px',
      },
    },
  ],
};

export const dischargedTracking2011Text = {
  1: [
    {
      type: 'normal',
      text: ['鄒國英'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  2: [
    {
      type: 'normal',
      text: ['江明洲', '林鴻志', '林瑞瑩'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  3: [
    {
      type: 'normal',
      text: ['張振宗', '陳英堯', '王曉萍', '謝凱生'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  4: [
    {
      type: 'normal',
      text: ['唐家婉', '王曉萍', '陳英堯', '謝凱生'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  5: [
    {
      type: 'normal',
      text: ['許瓊心', '高信安', '洪漢陽', '張瑞幸', '詹偉添'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  6: [
    {
      type: 'normal',
      text: '鄒國英',
      style: {
        marginTop: '0px',
      },
    },
  ],
  7: [
    {
      type: 'normal',
      text: ['曹珮真', '陳淑貞'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  8: [
    {
      type: 'normal',
      text: ['王藍浣', '黃朝慶'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  9: [
    {
      type: 'normal',
      text: ['白家銘', '許瓊心', '高信安', '洪漢陽', '張瑞幸'],
      style: {
        marginTop: '0px',
      },
    },
  ],
  10: [
    {
      type: 'normal',
      text: ['陳倩儀', '周弘傑', '曹伯年', '謝武勳'],
      style: {
        marginTop: '0px',
      },
    },
  ],
};

export const teamTrainingDesc = [
  {
    type: 'normal',
    text: '本會為提昇台灣早產兒醫療照護品質與技能，促進各合約醫院醫療團隊之互動與交流，並加強本會與合約醫院工作團隊合作，提供早產兒醫療團隊人員接受新的醫療訊息與學習的機會，增加醫療團隊自我了解及提昇個人壓力調適之能力，並促進國際交流與學習。特舉辦早產兒醫療護理、預防早產、社工、眼科、營養等專業研習會或座談會及國外訪問研習與短期代訓之教育訓練，以期讓高危險孕婦及早產兒獲得精緻化及完善的照顧。',
  },
  {
    type: 'large',
    text: '國內教育訓練',
  },
];

export const teamTrainingTitle1 = [
  {
    type: 'large',
    text: '國內教育訓練',
  },
];

export const teamTrainingTitle2 = [
  {
    type: 'large',
    text: '國外醫療訪問研習',
  },
];

export const teamTrainingTitle3 = [
  {
    type: 'large',
    text: '國外短期代訓研習',
  },
];

export const diseaseText = [
  {
    type: 'large',
    text: '台灣在近十多年來，拜經濟成長之賜，醫療品質有大幅度的進步，早產兒的存活率也提高很多。',
  },
  {
    type: 'normal',
    text: '但早產兒存活率增加，和其有關的種種問題也更加突顯。無論是住院期間或出院後的各種狀況，都會令早產兒父母覺得很慌張、憂心。但實際上，問題的發生及其嚴重性和早產程度是有很大的關係，以下帶您認識，早產兒從出生-出院-返家，所需要認識的疾病、照護等。希望您在這方面有較多及較正確的認識後，可減輕心中的憂慮與擔心。',
    style: {
      marginTop: '50px',
    },
  },
];

export const registerBenefit = [
  {
    type: 'important',
    text: '加入會員可享以下福利',
  },
  {
    type: 'normal',
    text: [
      '1.及時掌握基金會最新相關資訊',
      '2.家長可獲得最新衛教知識及活動訊息，並可報名父母團體課程',
      '3.主動提醒出生體重≦1500公克早產兒定期返診',
      '4.醫療團隊報名相關課程請先加入會員',
      '5.請避免使用免費信箱(Yahoo、Hotmail)，以免收不到系統信件；未收到信件，請至【垃圾信件匣】內確認信件',
    ],
    style: {
      marginTop: '10px',
    },
  },
];

export const donateListText = [
  {
    type: 'large',
    text: '親愛的早產兒之友您好，依據《財團法人法》第25條規定，除捐款人表示反對，本會需主動公開捐贈者姓名及金額。',
  },
  {
    type: 'normal',
    text: '如果您不願意公開相關捐款資料，或有任何疑問，請來電02-25111608，由專人為您服務。',
    style: {
      marginTop: '50px',
    },
  },
];

export const workReportText = [
  {
    type: 'large',
    text: '早產兒基金會以協助早產兒獲得適當之醫療並促進各界對早產兒之關懷為宗旨。',
  },
  {
    type: 'normal',
    text: [
      '依據本會捐助章程，服務範圍如下：',
      '一﹑協助早產兒接受適當醫療及照顧。',
      '二﹑協助有關醫院推展早產兒之醫療及照顧。',
      '三﹑推展有關早產兒治療之研究及教育。',
      '四﹑舉辦有關早產兒之各類活動。',
    ],
    style: {
      marginTop: '50px',
    },
  },
  {
    type: 'normal',
    text: '依財團法人法第25條，各項工作報告內容於主管機關備查後1個月內主動公開至本會官網。',
  },
];

export const financialReportText = [
  {
    type: 'large',
    text: '在早產兒基金會收入皆依法保管運用；年度財報依法報請主管機關備查，並經會計師查核簽證。',
  },
  {
    type: 'normal',
    text: '感謝多年來許多朋友一路陪伴基金會成長茁壯，透過您們的參與及捐獻，基金會能執行有效的服務，改善早產兒醫療及照護環境，謹代表受助者致予最大謝意！讓我們一起繼續為早產兒的成長而努力。',
    style: {
      marginTop: '50px',
    },
  },
  {
    type: 'normal',
    text: '依財團法人法第25條，各項工作報告內容於主管機關備查後1個月內主動公開至本會官網。',
  },
];

export const experienceShareText = [
  {
    type: 'normal',
    text: [
      // '感謝早產兒母親長期的義務服務，經驗分享過程，若涉及醫護問題有疑義，請打電話至早產兒社區健康中心衛教諮詢專線  (02)2523-0908與社工師共同討論。',
      // '為保護助人與受助者，執行任務時若發現傳播未經醫學證實之訊息、販賣商品…等，敬請與本會聯絡。',
      // '若有意願提供諮詢服務的早產兒媽媽，請與早產兒社區健康中心社工師聯絡。',
    ],
  },
  {
    type: 'large',
    text: '合約醫院社工師名單',
  },
];

export const selfCheckingSemiMotherText = [
  {
    type: 'normal',
    text: '由許多個案顯示，準媽媽對「早」經缺警！到面有產的徵兆時，才開始緊張！慌恐！其實在孕期的每個階段，媽媽們的身體都會有很多微妙的變化，除了要定期產檢、記住醫護人員的叮嚀之外，也可由婦幼刊物中汲取正確的知識。若妳是屬於早產高危險群，妳對造成早產的因子有多少認識？ 讓我們來檢測一下!',
  },
];

export const homeCareSemiMotherText = [
  {
    type: 'normal',
    text: [
      '家有早產兒的父母常存有許多疑慮，',
      '好不容易等到寶寶能出院返家，',
      '但又擔心自己的照護不如醫院，',
      '到底返家後該注意那些重點？遇到問題該如何求助？',
      '希望透過以下的檢測能增加您對孩子的了解。',
      '並提昇您居家照護寶寶的能力。',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const assistanceText = [
  {
    type: 'large',
    text: '依據財團法人法第25條第3項第2款之規定，財團法人應主動公開前一年度之接受補助者之姓名或名稱及補助金額。',
  },
  {
    type: 'normal',
    text: '依財團法人法第26條第1項第3款之規定，本會資訊之主動公開方式為提供公開閱覽、抄錄、影印、錄音、錄影、攝影、重製或複製。如果您有索取需求或其他問題，請來電02-25111608，由專人為您服務。',
    style: {
      marginTop: '50px',
    },
  },
];

export const whatICanDoForFoundation = [
  {
    type: 'normal',
    text: '我們提供豐富多元的捐款管道,歡迎您挑適合的方式。',
    style: {
      marginTop: 0,
    },
  },
  {
    render: h(OpenItem, {
      link: {
        name: 'donate-channel',
      },
      label: '點我捐款支持早產兒基金會',
      type: 'internal',
    }),
  },
  {
    type: 'normal',
    text: ['如有疑問,也歡迎隨時來電02-2511-608我們有專人協助您', '感謝您的愛心,讓我們一起為早產兒點亮生命之光。'],
    style: {
      marginTop: 0,
    },
  },
];

export const whenCanIGetReceiptWording = [
  {
    type: 'normal',
    text: '我們會在確認到您的滙款捐款後三週內，將您的捐款收據寄出。',
    style: {
      marginTop: 0,
    },
  },
];
export const donateQuestionContactWording = [
  {
    type: 'normal',
    text: '請來信或來電本會，我們有專人協助您。',
    style: {
      marginTop: 0,
    },
  },
  {
    // render: h('p', { style: font() }, '02-2511-1608'),
    render: h(ContactItem, { icon: 'mobile', label: '02-2511-1608' }),
  },
  {
    // render: h('a', { style: { ...font(), 'text-decoration': 'underline' }, href: 'mailto:pbf@pbf.org.tw' }, 'pbf@pbf.org.tw'),
    render: h(ContactItem, { icon: 'email', label: 'pbf@pbf.org.tw' }),
  },
];
export const whatIfLosingReceiptWording = [];
export const howToModifyReceiptDataWording = [];
export const donateByCreditCardWording = [
  {
    type: 'normal',
    text: '可以的。請您在填寫捐款基本資料、收據資訊時分別敘明即可。',
  },
];
export const dollarCostAveragingWording = [];
export const howToSearchDonateRecordWording = [
  {
    type: 'normal',
    text: '依法，本會會將每筆捐款明細公開在官網及會訊徵信錄。',
  },
];

export const serviceStatisticsACoreWording = [
  {
    type: 'normal',
    text: [
      '早產兒基金會自1995年8月起，辦理早產兒出院後的追蹤檢查工作，並陸續於全國多家醫院成立Level II早產兒追蹤門診。二十八年來，全國1501公克以下的早產兒收案人數已逾30,000人，累計完成早產兒矯齡6、12、24個月的追蹤次數已逾70,000人次。',
    ],
  },
  {
    type: 'normal',
    text: [
      '經由長期返診施測的貝利嬰幼兒發展測驗分數分佈狀況得知：1501公克以下早產兒與一般足月兒在心智發展與動作發展上皆有明顯差異，出生體重不足1501公克的早產兒在矯正年齡兩歲以前，都需要更充分的環境刺激、訓練機會、促進發展，以克服出生時生理條件的差異。此時，家庭環境的配合、家屬的支持、相關教養知識的瞭解、處理技巧的諮詢就更顯重要，這些都可藉由早產兒追蹤門診提早發現問題，進一步提供給早產兒更好的發展環境與機會。',
    ],
  },
  {
    type: 'normal',
    text: [
      '目前已成立追蹤門診者，北部包含北一區（台大、婦幼、永和耕莘、國泰、北醫附醫、亞東）、北二區（新光、台北榮總、台北長庚、三總）、北三區（台北馬偕、新竹馬偕）、北四區（林口長庚）等十三家醫院；中部包含中一區（中國、中山）、中二區（台中榮總、彰基）等四家醫院；南部包含台南區（成大、奇美、新樓、郭綜合、嘉義基督教）、高雄區（高雄榮總、高雄長庚、高醫、義大）等九家醫院。1999年4月起，由基金會與各地區主要醫院以專案方式合作執行。1995-2023年期間極低出生體重早產兒核心追蹤院區歷年收案暨追蹤數如下圖：',
    ],
  },
  {
    render: h('div', { style: { position: 'relative' } }, [
      h(Chart, {
        chartOptions: serviceStatisticsACoreConfig,
        maxWidth: '60%',
      }),
      h(
        'small',
        {
          style: {
            position: 'absolute',
            left: '50%',
            color: '#999999',
            fontSize: '11px',
            bottom: '0px',
            transform: 'translateX(-50%)',
          },
        },
        '點擊可呈現單項歷年數據',
      ),
    ]),
  },
  {
    type: 'important',
    text: ['註：1996-2024年追蹤院所變動狀況'],
  },
  {
    type: 'normal',
    text: [
      '1996年加入中區及南二區',
      '1997年7月加入永和耕莘醫院',
      '1999年7月加入新光醫院',
      '2006年加入三軍總醫院',
      '2008年加入彰基醫院、嘉基醫院',
      '2009年加入林口長庚醫院',
      '2016年嘉基醫院退為擴大追蹤院區',
      '2019年加入義大醫院',
      '2021年加入嘉基醫院、台東馬偕醫院',
      '2022年台東馬偕醫院退為擴大追蹤院區',
      '2023年加入北醫附醫、亞東醫院、新竹馬偕兒童醫院',
    ],
  },
];

export const serviceStatisticsBExpandWording = [
  {
    type: 'normal',
    text: [
      '為使追蹤檢查制度普及全國相關醫院，自2009年9月起，極低出生體重早產兒追蹤檢查擴大全國性服務計畫，以既有的二十六院區追蹤檢查服務模式，推廣至北、中、南、東全國二十六院區以外的醫療院所，依照各院之資源、人力，以醫院主動安排門診追蹤、家屬自行掛號返診和適時的轉介他院等方式進行早產兒追蹤檢查工作。',
    ],
  },
  {
    type: 'normal',
    text: [
      '目前擴大全國性服務計畫涵蓋院區包含：北區(基隆長庚、部立基隆、淡水馬偕、汐止國泰、臺安、市立仁愛、宏恩、部立雙和、新店耕莘、萬芳、台北慈濟、恩主公、輔大附醫、土城、國軍桃園、東元、新竹臺大、陽大附醫、羅東博愛、羅東聖母)有二十家醫院，中區(大甲光田、沙鹿光田、部立豐原、台中慈濟、中港澄清、部立臺中、林新、童綜合、彰濱秀傳、彰化秀傳、南投佑民、虎尾若瑟、雲林台大)有十三家醫院，南部(大林慈濟、嘉義長庚、聖馬爾定、國軍高雄、屏東基督教)有五家醫院，東部(花蓮慈濟、花蓮門諾、台東馬偕、台東馬偕、台東基督教)有四家醫院，合計共四十二家醫療院所，與既有的二十六家追蹤院區，共同交織成全國性追蹤網絡，服務極低出生體重早產兒。',
    ],
  },
  {
    type: 'normal',
    text: [
      '2009-2022年間，極低出生體重早產兒擴大全國性服務收案人數，與國民健康署出通報出生<1500公克的收案占比如下圖：',
    ],
  },
  {
    type: 'important',
    style: {
      fontWeight: 'bold',
    },
    text: '極低體重早產兒擴大全國性服務收案概況',
  },
  // {
  //   render: h(SingleImg, {
  //     src: mock2,
  //   }),
  // },
  {
    render: h(Chart, {
      chartOptions: serviceStatisticsBExpandConfig,
    }),
  },
  {
    type: 'normal',
    text: ['備註：以當年度國健局<1500公克之個案為母群體進行收案數比較'],
  },
];

export const serviceStatisticsABWording = [
  {
    type: 'normal',
    text: [
      '早產兒基金會極低出生體重早產兒追蹤檢查工作，自1995年起嘗試與各院區合作，規劃完善的早產兒追蹤檢查流程與評估模式，從既有的核心追蹤院區出發，共同進行極低出生體重早產兒追蹤檢查收案服務。另一方面，政府能迅速、完整掌握人口出生動態，有效提升出生通報率，引進網路出生通報系統，於2004年達成全面網路通報。',
    ],
  },
  {
    type: 'normal',
    text: [
      '自此以後，基金會得以瞭解早產兒追蹤檢查工作在國內的收案服務概況。透過早產兒核心追蹤院區的收案人數，逐年比對國民健康署公告出生<1500公克人數，以調整並擬定更合適的國內院區早產兒追蹤檢查合作方式。1998-2008年早產兒基金會核心追蹤院區收案人數暨2004-2008期間與國民健康署出生通報人數占比如下圖。',
    ],
  },
  {
    type: 'important',
    text: '1998-2008年追蹤檢查專案核心追蹤院區收案概況',
    style: {
      fontWeight: 'bold',
    },
  },
  {
    render: h('div', { style: { position: 'relative' } }, [
      h(Chart, {
        chartOptions: serviceStatisticsABExpand19982008Config,
      }),
      h(
        'small',
        {
          style: {
            position: 'absolute',
            left: '50%',
            color: '#999999',
            fontSize: '11px',
            bottom: '0px',
            transform: 'translateX(-50%)',
          },
        },
        '點擊可呈現單項歷年數據',
      ),
    ]),
  },
  {
    type: 'normal',
    text: [
      '如何在政府未能全面接手國內早產兒追蹤檢查工作之前，幫助這些有需要的早產孩子們提早發現問題，及時轉介療育，生活的有品質、有希望，降低國家長期醫療成本外，能進一步為社會貢獻，是基金會、醫療團隊、早產兒家庭所關注與擔心的議題。',
    ],
  },
  {
    type: 'normal',
    text: [
      '為此，本會於於2009年9月起，設立極低出生體重早產兒追蹤檢查擴大全國性服務計畫，以既有的核心追蹤院區檢查服務模式，擴大推廣並結合高區域性的在地醫院，合作辦理早產兒出院後的追蹤檢查工作。希望透過此一前瞻式、連續性、主動性及跨院的全面性早產兒追蹤檢查工作，及早發現發展遲緩的孩童，即時介入給予轉介或治療，以降低往後的發展障礙、醫療與家國資源及成本。2009-2023年之間，既有的核心追蹤與推廣的擴大追蹤院區收案人數全國占比自初始的五成逐步提升逾八成，結合向外推廣的擴大追蹤院區後，使得早產兒基金會傾力服務的早產兒追蹤網絡涵蓋觸角更加廣泛，至今全國收案占比已達82.79%(1203/1453)。',
    ],
  },
  {
    type: 'important-center',
    text: '極低體重早產兒追蹤檢查暨擴大全國性服務收案概況',
    style: {
      marginTop: '50px',
      fontWeight: 'bold',
    },
  },
  // {
  //   render: h(SingleImg, {
  //     src: mock3,
  //   }),
  // },
  {
    render: h(Chart, {
      chartOptions: serviceStatisticsABExpandConfig,
    }),
  },
  // {
  //   render: h(Chart, {
  //     chartOptions: serviceStatisticsABExpandConfigTest,
  //   }),
  // },
  {
    type: 'important',
    text: ['2023年度追蹤服務全國收案占比'],
    style: {
      marginTop: '50px',
    },
  },
  {
    type: 'normal',
    text: [
      '根據衛生福利部國民健康署2023年出生通報統計年報，全國出生體重＜1500公克活產嬰兒人數共1,453人，進一步依產婦配偶戶籍計算各縣市人數占全國之比例，占比最高的前五名依序為：新北市19.41%(282人)、桃園市11.42%(166人)、高雄市10.94%(159人)、臺北市10.39%(151人) 、臺中市9.22%(134人)。其他縣市占比除台南市6.81%(99人)、彰化縣5.51%(80人)之外，皆在5%以下。',
    ],
  },
  {
    render: h(SingleImg, {
      src: mock7,
      maxWidth: '75%',
    }),
  },

  {
    type: 'normal',
    text: [
      '資料來源：衛生福利部國健署中華民國2023出生通報統計年報。',
      '＊統計分子：國健署出生通報統計年報(<1500公克) 2023年各縣市個案數。',
      '＊統計分母：國健署出生通報統計年報(<1500公克) 2023年全國出生人數。',
    ],
  },
  {
    type: 'normal',
    text: [
      '依據2023年度本會早產兒追蹤網絡(A核心追蹤院區+B擴大追蹤院區)收案人數，與衛生福利部國民健康署2023年出生通報統計年報<1500公克出生人數，依產婦配偶戶籍進行全國各縣市收案佔比之分析。該縣市出生<1500公克且收案服務比例低於七成的縣市依序計有：花蓮縣、雲林縣、台東縣、宜蘭縣、新竹市、苗栗縣、連江縣，這些在基金會現有能力之外，尚未被追蹤服務的孩子們，亦包含弱勢、高風險等家庭，極需要政府單位主動作為，協助早產兒追蹤檢查服務，讓全國的有需要被追蹤服務的孩子得以聯繫並改善其預後。',
    ],
    style: {
      marginTop: '50px',
    },
  },
  {
    type: 'important-center',
    text: '2023年極低出生體重早產兒全國各縣市收案比率',
  },
  // {
  //   render: h(SingleImg, {
  //     src: mock5,
  //   }),
  // },
  {
    render: h(Chart, {
      chartOptions: serviceStatisticsABExpandLastConfig,
    }),
  },
];

export const understandPreventWording = [
  {
    type: 'large',
    text: '愈早發現早產徵象，越早就醫診治，安胎成功的機會就愈大。',
  },
  {
    type: 'normal',
    text: [
      '▶什麼情況需要住院安胎？',
      '▪早產性子宮收縮，口服藥物無法控制，或有子宮頸擴張情形',
      '▪早期破水',
      '▪陰道出血',
      // '▶了解早產徵兆，相關衛教資訊可至認識早產-如何預防早產了解更多。',
    ],
  },
  {
    type: 'normal',
    render: h('p', { style: font() }, [
      h('span', '▶了解早產徵兆，相關衛教資訊可至'),
      h(OpenItem, {
        link: {
          name: 'what-is-preemie',
        },
        label: '認識早產-如何預防早產了解更多',
        type: 'internal',
      }),
      h('span', '。'),
    ]),
  },
];

export const whenShouldPreventWordng = [
  {
    type: 'normal',
    text: ['1、早產性子宮收縮，口服藥物無法控制，或有子宮頸擴張情形', '2、早期破水', '3、陰道出血'],
    style: {
      marginTop: 0,
    },
  },
];

export const inHospitalAndCareWording = [
  {
    type: 'normal-bold',
    text: ['處置→'],
    style: {
      marginTop: 0,
    },
  },

  {
    type: 'normal',
    text: [
      '1、視情況接受子宮收縮胎兒心跳監視器檢查，一般一週檢查2次。',
      '2、有必要時需鴨嘴或內診檢查。',
      '3、安胎藥物給予:Yutopar、MgSO4、Adalat…抑制子宮收縮。',
      '4、抗生素使用：早期破水時可預防感染。',
      '5、類固醇使用：懷孕34週前使用，可幫助胎兒肺部提早成熟，預防早產而產生之呼吸窘迫症狀。',
      '6、硫ㄒ酸鎂使用:除安胎作用外，臨床實證證明懷孕32週前使用，可降低新生兒腦性麻痺發生機率。',
      '7、完全或部分臥床休息，一天聽1-2次胎心音。',
    ],
    style: {
      marginTop: 0,
    },
  },

  {
    type: 'normal-bold',
    text: ['照護→'],
    style: {
      marginTop: 0,
    },
  },

  {
    type: 'normal',
    text: [
      '1.每天至少刷牙、洗臉一次，以保持清潔與健康。',
      '2.安胎需絕對臥床休息，能否下床活動、沐浴或上廁所應由主治醫師評估病情狀況決定。',
      '3.不能下床沐浴者，可每天用毛巾擦拭身體及更換衣褲。',
      '4.不能下床上廁所者，可於床上使用便盆。',
      '5.不能下床活動者，可於床上翻身或採半坐臥姿，時間不宜過長。',
      '6.至少每週洗頭一次，有必要時可請護理人員協助聯絡美容院人員到病房服務，費用依當時定價及頭髮長度而訂。',
      '7. 床頭燈及護士鈴的拉繩，請放於伸手可及之處，以方便需要使用。',
      '8.保持環境安靜，儘量限制訪客及降低聲量，讓孕婦能夠充分的得到休息。',
      '9.子癇前症的孕婦，應減少光線刺激或過鹹食物，也需特注意胎動。',
      '10.必要時會裝上胎兒監視器，密切觀察子宮收縮與胎心音變化，故孕婦若欲拆下胎兒監視器時，須先通知醫護人員予以評估後再決定是否可拆除。',
      '11.保持外陰部的清潔，方法如下：',
    ],
    style: {
      marginTop: 0,
    },
  },

  {
    type: 'normal-indent',
    text: [
      '(1)如廁後用沖洗器裝溫水（約八分滿）由前往後沖洗，並用衛生紙由前往後擦乾，以免將肛門處之細菌帶至會陰處導致感染。',
      '(2)使用棉墊時，應勤於更換，更換時由前放由後抽離，以免細菌滋生導致感染。',
      '(3)勿用衛生紙墊於會陰部，因衛生紙浸水後會化成顆粒狀或糊狀，造成不適或感染。',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const whatShouldPregnantKnow = [
  { type: 'normal-bold', text: '1、了解早產徵兆' },
  { type: 'normal-bold', text: '2、如何判斷子宮收縮：' },
  {
    type: 'normal',
    text: [
      '(1)每天固定2-3次以手觸摸腹部，注意每小時子宮收縮、變硬次數，並記錄子宮收縮次數，幫助自己及醫療人員判斷是否為早產性子宮收縮。',
      '(2)若每小時有5-6次以上，即每10分鐘有一次以上的子宮收縮，應立即通知醫護人員注意胎動。',
    ],
    style: {
      marginTop: 0,
    },
  },
  { type: 'normal-bold', text: '3、注意胎動：' },
  {
    type: 'normal',
    text: [
      '(1)每天記錄胎動次數。',
      '(2)如12小時無胎動或一天胎動少於4次或和之前比較少於50%，應立即通知醫護人員。',
      '(3)當產婦感覺胎動減少時，可以稍微進食或聲音、震動刺激，看看胎動是否改善。',
    ],
    style: {
      marginTop: 0,
    },
  },
  { type: 'normal-bold', text: '4、何時要通知護理人員：' },
  {
    type: 'normal',
    text: [
      '(1)子宮收縮次數30分鐘多於3次',
      '(2)子宮收縮時有腹部疼痛、腰痠或便意感',
      '(3)陰道出血量增加、顏色轉為鮮紅色',
      '(4)陰道分泌物有異味或水樣分泌物流出',
      '(5)突然胎動劇烈、胎動減少(一天少於10次或與平常及前一天相比，胎動次數減少一半或刺激後2小時內仍無胎動)',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: [
      '(6)其他明顯不舒服的情形，如有畏寒或發燒等現象',
      '(7)子癲前症之孕婦，若感到頭痛、視力模糊、上腹痛等不適症狀',
    ],
    style: {
      marginTop: 0,
    },
  },
  { type: 'normal-bold', text: '5、簡單了解安胎過程中的處置及安胎藥物的副作用：' },
  {
    type: 'normal',
    text: [
      '藥名：Nifedipine(Adalat)',
      '(1)作用：可讓子宮平滑肌鬆弛。',
      '(2)副作用：面潮紅、發汗、頭痛、呼吸困難、低血壓、頻脈、噁心等。',
      '(3)一般是舌下給藥或口服，使用後效果快速，經常為子宮收縮時的緊急用藥。',
      '(4)服用此藥物後會使血壓降低、臉紅、溫熱感等不適，故使用前需測量血壓。',
      '藥名：Yutopar(Ritodrine)',
      '(1)作用：可使子宮鬆弛、預防早產。',
      '(2)副作用：此藥剛注射時可能會覺得有心跳加速、出汗、呼吸喘、噁心、嘔吐等不適症狀，可將床頭抬高減輕不適，一段時間後即會適應。',
      '(3)靜脈注射，藥量滴數由醫護人員依孕婦情況調整，至宮縮穩定，孕婦如有任何不適請通知醫護人員，切勿自行調降。',
      '藥名：硫酸鎂MgSO4(Magnesium Sulfate)',
      '(1)作用：輔助平滑肌鬆弛，可降低血壓、減少子宮收縮頻率。懷孕32週前使用，可降低新生兒腦性麻痺發生機率。',
      '(2)副作用：口乾、全身發熱、臉潮紅、噁心、嘔吐、呼吸不順，經一段時間後可改善。因藥物刺激性高靜脈注射部位及血管偶會有疼痛感',
      '(3)可能會使小便量減少，故須詳實記錄小便量及進食量以便評估輸入、輸出量是否平衡。',
      '(4)若有感到肌肉無力、想睡覺或呼吸困難須隨時通知醫護人員。',
      '(5)靜脈注射，藥量由醫師依孕婦情況所計算出來，有其特定的治療劑量，不可任意調降，若有任何不適，隨時通知醫護人員處理。',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: [
      '藥名：Tractocile(Atosiban)',
      '(1)作用：預防早產。於健保安胎藥物出現嚴重副作用時可考慮採用',
      '(2)副作用：輕微的心跳加速、噁心、嘔吐、頭痛、眩暈、低血壓。',
      '(3)此藥為自費安胎藥物，費用昂貴。',
      '(4)可使用於有心血管病史、糖尿病史及代謝性疾病的產婦。',
      '(5)靜脈注射，藥量滴數由醫護人員依孕婦情況調整，至宮縮穩定，孕婦如有任何不適請通知醫護人員，切勿自行調降。',
      '藥名：類固醇 Betamethasone(Rinderon)',
      '(1)作用：肌肉注射，促進胎兒肺部成熟。',
      '(2)副作用：體液電解質不平衡(鈉滯留、鉀流失)、體重增加、水腫。',
    ],
    style: {
      marginTop: 0,
    },
  },
  { type: 'normal-bold', text: '6、住院安胎的飲食及日常生活注意事項：' },
  {
    type: 'normal',
    text: '(1)懷孕第二期後，胎兒腦部發育迅速需要更多的營養，所需的份量如下：',
    style: {
      marginTop: 0,
    },
  },
  {
    render: h('h1', '一個表格'),
  },
  {
    type: 'normal',
    text: '(2)六大類食物選擇來源：',
    style: {
      marginTop: 0,
    },
  },
  {
    render: h('h1', '一個表格'),
  },
  {
    type: 'normal',
    text: [
      '(3)易產氣的食物如發酵食物、豆類、蘋果、洋蔥、地瓜、洋芋，比較容易產生氣體，造成腸胃道的脹氣，最好暫時不要食用或減少攝取。',
      '(4)少吃果糖及飲料以優酪乳取代牛奶。',
      '(5)細嚼慢嚥，少量多餐。',
      '(6)可以服用孕婦奶粉，因易脹氣，應依個人體質酌量使用。',
      '(7)多吃蔬菜水果。',
      '(8)由於長期臥床、不習慣用便盆及藥物影響，您可能容易便秘，應注意下面事項：',
      'A.攝取足夠水分，最好一天攝取2000cc',
      '的水分。',
      'B.多進食高纖維類的蔬菜水果。',
      'C.若有便秘或腹脹請通知醫護人員，因為這些情況都會引起子宮收縮。',
      'D.住院中如果3天以上未解便，請告知護理人員。',
      'E.必要時會給予軟便劑服用。口服軟便劑的孕婦，請注意排便情形，若有腹瀉情形需告知醫護人員。',
      '(9)使用安胎電動床。',
      '(10)臥床休息，盡量在床上如廁',
      '(使用便盆或便盆椅)。',
      '(11)狀況穩定後，經醫師評估後可下床上廁所。',
      '(12)改口服後可不必限制臥床休息。',
      '(13)需注意下床安全，預防跌倒。',
      '(14)放鬆心情，可以做些靜態活動',
      '(如無線上網、看DVD、看書、聽音樂…等等)。',
      '(15)音樂療法：選擇自己所喜愛的音樂類型，可有效降低焦慮程度，並可穩定生命徵象及胎心率。',
      '(16)與鄰床媽媽分享心情，互相支持鼓勵。',
      '(17)必要時可請家人安排親友探訪（如小兒女），但時間不宜過長，以免影響休息與情緒。(但有重大傳染疫情期間，還是須遵守規範)',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const homeCareNoticeWording = [
  {
    type: 'normal',
    text: [
      '1、臥床休息：一般返家後建議繼續臥床休息，若無破水、陰道出血或子宮收縮情形，可依身體狀況調整適度下床活動，減輕壓力及焦慮',
      '2、避免引起子宮收縮之活動：如刺激乳頭、從事粗重工作及激烈活動 (如搬重物、跑步、爬山、頻繁上下樓梯等)',
      '3、避免性生活及陰道灌洗',
      '4、每日測量體溫一次，注意有無感染現象。',
      '5、當出現以下情形立即返院求診：',
      '(1).胎動：突然胎動劇烈、胎動減少(一天少於 10 次或與平常及前一天相比，胎動次數減少一半或刺激後 2 小時內仍無胎動)。',
      '(2).子宮收縮：半小時有 3 次以上收縮或有規則收縮現象。',
      '(3).出現下背部酸痛、腹部痙攣、骨盆受壓迫感（覺得好像胎兒往下推），經臥床休息情況持續發生沒有改善。',
      '(4).破水：陰道分泌物有異味、水樣分泌物流出，或羊水突然大量流出。',
      '(5).出血：陰道忽然有出血現象，顏色為鮮紅色，或原有出血經醫生診治後返家休息，但突然出血量增加或出現血塊。',
      '(6).血壓：子癲前症者需注意血壓，如出現頭痛、頭暈、視力模糊、上腹痛等情形，須立即返診',
      '6.依醫生指示按時服用藥物，按時返診',
      '7.有任何問題可以向原產檢醫院婦產科門診/病房醫護人員諮詢',
      '8.安胎營養品補充',
      '(1)葉酸:建議前三個月補充。',
      '(2)孕婦綜合維他命:懷孕三個月後可補充。',
      '(3)DHA:主要來源有魚油、藻油、堅果類食物。',
      '(4)Ca:建議額外補充，因為孕婦綜合維他命中所含的鈣通常不足。',
      '(5)Vit. D3:除可幫助鈣的吸收，臨床上對調整身體免疫及心理狀態也有幫助。',
      '9.妊娠子癲前症孕婦出院注意事項:與一般安胎孕婦出院後自我照顧相同，但是需特別注意：',
      '(1)每日測量記錄血壓三次，收縮壓應小於 140mmHg(毫米汞柱)，舒張壓應小於 90 mmHg(毫米汞柱)。',
      '(2)注意有無頭痛、視力模糊、上腹痛等不適症狀，如有上述現象，請立即就醫。',
      '10.妊娠糖尿病孕婦出院注意事項:與一般安胎孕婦出院後自我照顧相同，但是需特別注意：',
      '(1)請定時測量血糖並做紀錄，於返診時將資料提供給醫師參考。',
      '(2)避免甜食及油炸食物、增加膳食纖維及少量多餐，如此有助於血糖的穩定。',
      '(3)請依醫師指示服用藥物或注射藥物，且定時返診追蹤，有任何異常立即就醫。',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const understandingHighRiskPregnant = [
  {
    type: 'important',
    text: ['(一)何謂高危險妊娠?'],
  },
  {
    type: 'normal',
    text: [
      '指在妊娠期間母親、胎兒、胎盤羊水有潛在的危險，導致胎兒或母親的健康受到威脅或傷害，可能發生懷孕結果不如預期的狀況，而高危險妊娠發生率約10%。',
    ],
  },
  {
    type: 'important',
    text: ['(二)危險因素包括母親、胎兒及胎盤羊水，參見下方表格：'],
  },
  {
    render: h(SimpleTable, {
      content: HighRiskUnderStandingContent,
    }),
  },
];

export const understandingHighRiskPregnantNotices = [
  {
    type: 'important',
    text: ['(一)子宮方面須注意事項'],
  },
  {
    type: 'normal',
    text: [
      '子宮頸閉鎖不全、子宮頸曾做過手術、上一胎曾早產的孕婦，這一次懷胎可先做早產風險評估：懷孕初期可做陰道超音波，看子宮頸的長度，如果子宮頸長度太短，可能會有早產風險，中期可做子宮頸環紮術，大約36、37週再拆除環紮處，若提前發生陣痛或有感染，就得提前拆線。',
    ],
  },
  {
    type: 'important',
    text: ['(二)危險妊娠者需要特別加強的檢查'],
  },
  {
    type: 'normal',
    text: [
      '1.孕前評估：有特殊疾病者，評估疾病嚴重程度，控制疾病於穩定狀況再懷孕。',
      '2.懷孕早期篩檢：早期篩檢疾病發生率，高風險個案給予預防性治療及密集的監測。',
      '3.遺傳諮詢與檢驗：有家族遺傳病史者，由遺傳諮詢醫師做詳細諮詢，必要時接受羊膜穿刺檢查，做遺傳診斷。',
      '4.高層次超音波：由專門的醫師執行，檢查胎兒各個部位及器官。',
      '5.胎兒監測：有必要時較密集監測胎兒狀況，如胎兒監測器及都卜勒超音波。',
      '6.均衡營養：攝取均衡的營養，妊娠高血壓及糖尿病的孕婦，可諮詢營養師給予適合的飲食建議。',
      '7.疾病用藥：根據醫師指示用藥，不可擅自停藥、改藥或是亂服用偏方。',
      '8.留意自己的健康狀況：有需要就監測血壓、血糖及胎動，感覺身體不適或胎動異常時，盡快至醫院檢查。',
    ],
  },
  {
    type: 'important',
    text: ['(三)孕期體重'],
  },
  {
    type: 'normal',
    text: [
      '孕期的營養不僅影響媽媽也影響胎兒健康。如果對熱量與營養素攝取有疑問，建議找合格營養師做進一步的營養評估與諮詢以獲取最適合自己的飲食改善建議。',
      '標準體重：懷孕期間，孕婦體重應依懷孕前體重做適當調整，應以孕前的身體質量指數（Body Mass Index，BMI）來計算，以做為孕期體重增加調控參考，建議增加10-14公斤為宜，且須注意體重增加的速度，懷孕期間不適於減重，孕期體重增加指引請參考下表：',
    ],
  },
  {
    render: h(SimpleTable, {
      content: HighRiskWeightContent,
    }),
  },
  {
    type: 'normal',
    // text: [
    //   '身體質量指數BMI=體重(公斤)/身高2(公尺2)',
    //   '資料來源：國民健康屬孕婦衛教手冊(https://mhb.hpa.gov.tw/phebook_2_3.html)',

    // ],
    render: h('div', [
      h('p', { style: font() }, '身體質量指數BMI=體重(公斤)/身高2(公尺2)'),
      h('p', [
        h(
          'span',
          {
            style: font(),
          },
          '資料來源：',
        ),
        h(
          'a',
          {
            href: 'https://mhb.hpa.gov.tw/phebook_2_3.html',
            target: '_blank',
            rel: 'noreferrer noopener',
            style: {
              ...font(),
              'text-decoration': 'underline',
              cursor: 'pointer',
            },
          },
          '國民健康屬孕婦衛教手冊',
        ),
      ]),
    ]),
  },
  {
    type: 'important',
    text: ['(四)就醫提醒'],
  },
  {
    type: 'normal',
    render: renderNormalBoldText('定期產前檢查', '1.', '，自覺有異常可提早返診，需要比一般孕婦更密集的追蹤。'),
    style: {
      marginTop: '10px',
    },
  },
  {
    type: 'normal',
    render: renderNormalBoldText('選擇有高危妊娠門診的醫院產檢，有新生兒專科醫師及加護病房的醫院生產。', '2.建議'),
  },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.定期產前檢查，自覺有異常可提早返診，需要比一般孕婦更密集的追蹤。',
  //     '2.建議',
  //   ],
  // },
];

// 貧血
export const highRiskAnemiaWording = [
  {
    type: 'normal',
    text: ['產檢時會篩檢有無傳染性疾病如德國麻疹、梅毒等，以降低胎兒先天性感染胎兒的機率。'],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal-bold',
    text: ['1.梅毒'],
  },
  {
    type: 'normal',
    render: renderNormalBoldText(
      '梅毒檢查共需兩次，一次在懷孕早期（第一次檢查時），一次在晚期，避免孕婦於懷孕間染病。',
      '',
      '產檢一旦發現孕婦有感染，醫師通常會以盤尼西林加以治療。如果胎兒感染梅毒，胎兒須做超音波檢查及追蹤並考慮做胎兒臍帶血檢查，可能影響包括胎兒水腫、牙齒與骨骼發育異常、先天性梅毒感染及畸型等，嚴重可能會導致胎死腹中。',
    ),
  },
  {
    type: 'normal-bold',
    text: ['2.德國麻疹'],
  },
  {
    type: 'normal',
    render: renderNormalBoldText(
      '預防德國麻疹最有效的方法為接種疫苗',
      '可經由飛沫或接觸感染，孕婦一旦感染德國麻疹，病毒會透過胎盤垂直傳染給胎兒，情況嚴重可能會造成死產、流產或胎兒主要器官受損如先天性耳聾、青光眼、白內障、小腦症、智能不足及先天性心臟病等缺陷，統稱為先天性德國麻疹症候群。',
      '，如不確定是否具有德國麻疹抗體，建議於孕前健康檢查進行抗體檢測，檢查結果若呈陰性，應在懷孕前儘速持德國麻疹抗體檢查陰性(-)證明，至各衛生所或預防接種合約醫院診所，接種1劑 MMR公費疫苗，同時建議接種後4週內應避免懷孕。',
    ),
  },
  // {
  //   type: 'normal-bold',
  //   text: ['3.好發族群'],
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '18歲以下青少女為早產的好發族群之一，也比較容易有胎盤著床的問題。',
  //     '高齡產婦的妊娠高血壓、妊娠糖尿病、前置胎盤、產程遲滯、子宮外孕以及胎兒先天畸形的機率都比較高。根據統計，30歲孕婦生出唐氏症寶寶的機率為1/900，35歲增加到1/365，40歲為1/109，因此，衛生福利部建議，34歲以上的高齡產婦最好接受羊膜穿刺，並以34歲以上做為費用補助的認定標準（高齡孕婦，健保部分減免5000元羊膜穿刺的費用）。',
  //   ],

  // },
];

// 好發族群
export const highRiskGroupsWording = [
  {
    type: 'normal',
    render: renderNormalBoldText('18歲以下青少女', '', '為早產的好發族群之一，也比較容易有胎盤著床的問題。'),
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    render: renderNormalBoldText(
      '高齡產婦',
      '',
      '的妊娠高血壓、妊娠糖尿病、前置胎盤、產程遲滯、子宮外孕以及胎兒先天畸形的機率都比較高。根據統計，30歲孕婦生出唐氏症寶寶的機率為1/900，35歲增加到1/365，40歲為1/109，因此，衛生福利部建議，34歲以上的高齡產婦最好接受羊膜穿刺，並以34歲以上做為費用補助的認定標準（高齡孕婦，健保部分減免5000元羊膜穿刺的費用）。',
    ),
    style: {
      marginTop: 0,
    },
  },
];

// 妊娠高血壓、子癲前症、子癲症
export const highRiskHypetensionWording = [
  {
    render: h(SimpleTable, {
      content: HighRiskHypetensionContent,
    }),
  },
  // {
  //   type: 'normal-bold',
  //   text: ['⊙重度子癲前症：'],
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '血壓>160/110mmHg、蛋白尿>5(3?)g/day、24小時尿量<300cc、嚴重頭痛(持續性或劇烈性)、視力模糊、呼吸困難、右上腹痛、胎兒生長遲緩、胎盤早期脫離。',
  //   ],
  // },
  {
    type: 'normal-bold',
    text: ['⊙自費子癲前症篩檢：'],
  },
  {
    type: 'normal',
    text: [
      '懷孕第一孕期(11-13週6天)執行，檢查的項目包括基本病史及資料、血壓、子宮動脈血流阻力、特定血清檢驗(PlGF和PAPP-A)等，根據這些資料計算出早發型子癲前症的風險值。若是只抽血篩檢，篩檢率約76-80%，如果搭配上超音波子宮動脈血流阻力，則這個篩檢對早發型子癲前症的檢出率可達到91%。',
    ],
  },
];

// 懷孕合併甲狀腺功能異常
export const highRiskThyroidWording = [
  {
    render: h(SimpleTable, {
      content: HighRiskThyroidContent,
      mt: false,
      mb: false,
    }),
  },
];

// 妊娠糖尿病
export const highRiskDiabetesWording = [
  {
    type: 'normal',
    text: [
      '妊娠糖尿病的產婦於懷孕前並沒有糖尿病，但因為產婦的身體對碳水化合物產生耐受性不良而使得血糖偏高，孕程中的人體代謝會隨著各種荷爾蒙(人類胎盤泌乳素、動情素及黃體素等)分泌而出現變化，導致人體增加胰島素的需求，進而產生妊娠糖尿病，台灣產婦的發生率為4-5%。',
      '在懷孕中後期，因胎兒及胎盤逐漸長大，更容易產生血糖不穩的狀況，此時必須多加注意控制並追蹤血糖值，以免出現併發症。妊娠糖尿病對胎兒的影響是會造成胎兒過大，引發肩難產及剖腹產機率上升，也引發新生兒低血糖及電解質不平衡，也會因此進入加護病房治療。90%的妊娠糖尿病患者在產後均會恢復正常，但之後可能發展成第二型糖尿病的機率上升。',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    render: h(SimpleTable, {
      content: HighRiskDiabetesContent,
      mb: false,
    }),
  },
];

// 懷孕合併全身性狼瘡
export const highRiskLupusWording = [
  {
    render: h(SimpleTable, {
      content: HighRiskLupusContent,
      mt: false,
      mb: false,
    }),
  },
];

// 胎兒生長遲滯
// export const highRiskGrowLateWording = [
//   {
//     render: h('h1', '一個表格'),
//   },
// ];

// // 早產
// export const highRiskPrematureBirthWording = [
//   {
//     render: h('h1', '一個表格'),
//   },
// ];

// 多胞胎妊娠
export const highRiskMultipleBirthWording = [
  {
    render: h(SimpleTable, {
      content: HighRiskMultipleBirthContent,
      mt: false,
      mb: false,
    }),
  },
];

// 早產早期破水
export const highRiskWaterBreakingWording = [
  {
    type: 'normal',
    text: [
      '所謂「早期破水」是指子宮未規則收縮前，胎膜已破裂而導致羊水流出來。早期破水的發生率約為3%，有1/3的早產兒都是因為早期破水而出生的。若是小於37週之前的早期破水，又稱為「早產早期破水」。無論是早產早期破水或是早期破水都可能會導致感染或早產，應盡快就醫，給予抗生素與住院安胎，或是考慮是否提前生產。',
    ],
  },
];

// 前置胎盤及胎盤早期剝離
export const highRiskPlacentaPreviaWording = [
  {
    type: 'normal-bold',
    text: ['1.前置胎盤'],
    style: {
      marginTop: 0,
    },
  },
  {
    render: h(SimpleTable, {
      content: HighRiskPlacentaPrevia1Content,
    }),
  },
  // {
  //   type: 'normal',
  //   text: [
  //     '※補充：有時候前置胎盤也會有合併植入性胎盤，引發子宮收縮不良，而造成產後更大的出血，是產科醫師很大的挑戰也是令患者置身極度危險的疾病。絕大部分的前置胎盤容易引發胎盤早期剝離及產後大出血，但前置胎盤無法預防。',
  //   ],
  // },
  {
    type: 'normal-bold',
    text: ['2.胎盤早期剝離'],
  },

  {
    render: h(SimpleTable, {
      content: HighRiskPlacentaPrevia2Content,
      mb: false,
    }),
  },
];

export const dietPrincipleWording = [
  {
    type: 'important',
    text: ['1.養成良好飲食原則：'],
  },
  {
    type: 'normal',
    text: [
      '(1)採細嚼慢嚥，少量多餐。',
      '(2)攝取足夠水分，每天需攝取2000cc的水分。',
      '(3)多進食高纖維類的蔬菜水果。',
      '(4)勿過度攝取果糖、飲料以及易產氣體食物而造成糖分過高及脹氣。',
      '(5)可以服用孕婦奶粉，為避免脹氣，應依個人體質酌量使用。',
    ],
  },
  {
    render: h(SimpleTable, {
      content: understandFoodType,
    }),
  },
  {
    type: 'important',
    text: [' 2.懷孕第二期後，胎兒腦部發育迅速需要更多的營養，可參考下表：'],
  },
  {
    render: h(SimpleTable, {
      content: understandFoodNutrition,
    }),
  },
];

export const medicalCareWording = [
  {
    type: 'normal',
    text: [
      '1.必要時會裝上胎兒監視器，密切觀察子宮收縮與胎心音變化，一天聽1-2次胎心音，要移除胎兒監視器時，須先通知醫護人員予以評估後再決定是否可拆除。',
      '2.完全或部分臥床休息。',
      '3.有必要時醫師會以鴨嘴或內診檢查。',
      '4.依醫師評估給予藥物治療。',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal-indent',
    text: [
      '(1)安胎藥物：抑制子宮收縮。',
      '(2)抗生素：早期破水時可預防感染。',
      '(3)硫酸鎂: 除安胎作用外，臨床實證證明懷孕32週前使用，可降低新生兒腦性麻痺發生機率。',
      '(4)類固醇：可幫助胎兒肺部提早成熟，預防早產而產生之呼吸窘迫症狀。',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const takeCare = [
  {
    type: 'normal',
    text: [
      '1.使用安胎電動床，床頭燈及護士鈴的拉繩，置於伸手可及處，以方便使用。',
      '2.安胎需絕對臥床休息，由主治醫師評估決定能否下床活動、沐浴或上廁所。不能下床活動者：需維持身體基本清潔、注意外陰部的清潔、準備便盆或便盆椅如廁使用、經常協助床上翻身或半坐臥姿，以保持清潔與健康。經醫師評估後可不必限制臥床休息後，需注意下床安全，預防跌倒。',
      '3.保持環境安靜，儘量限制訪客及降低聲量，讓孕婦能夠充分的得到休息，可安排親友探訪(如小兒女)但時間不宜過長，以免影響休息與情緒。(有重大傳染疫情期間，還是須遵守規範)',
      '4.由於長期臥床、不習慣用便盆及藥物影響，可能容易便秘，應注意下面事項：',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal-indent',
    text: [
      '(1)攝取足夠水分及多進食高纖維類的蔬菜水果。',
      '(2)若有便秘或腹脹請通知醫護人員，因為這些情況都會引起子宮收縮。',
      '(3)住院中若3天以上未解便，請主動告知醫護人員。',
      '(4)必要時會給予軟便劑服用，持續注意排便情形，若有腹瀉情形需告知醫護人員。',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: [
      '5.子癲前症的孕婦，應減少光線刺激或過鹹食物，也需特注意胎動。',
      '6.放鬆心情，可以做些靜態活動 (如上網、看電影、影集、閱讀書籍、聽音樂…等等)。',
      '7.音樂療法：選擇自己喜愛的音樂類型，可有效降低焦慮程度及穩定生命徵象、胎心率。',
      '8.鼓勵與鄰床媽媽分享心情，互相支持鼓勵。',
    ],
    style: {
      marginTop: 0,
    },
  },
];

export const uterineContractionsWording = [
  {
    type: 'normal-bold',
    text: '判斷子宮收縮：',
  },
  {
    type: 'normal',
    text: '每天固定2-3次以手觸摸腹部，注意每小時子宮收縮、變硬次數，並記錄子宮收縮次數，以判斷是否為早產性子宮收縮。',
  },
  {
    type: 'normal-bold',
    text: '注意胎動：',
  },
  {
    type: 'normal',
    text: ['(1)每天記錄胎動次數。', '(2)感覺胎動減少時，可以稍微進食或聲音、震動刺激，看看胎動是否改善。'],
  },
  {
    type: 'normal-bold',
    text: '何時要通知護理人員',
  },
  {
    type: 'normal',
    text: [
      '(1)子宮收縮次數每小時有5-6次以上即每10分鐘有一次以上的子宮收縮。',
      '(2)子宮收縮時有腹部疼痛、腰痠或便意感。',
      '(3)陰道出血量增加、顏色轉為鮮紅色。',
      '(4)陰道分泌物有異味或水樣分泌物流出。',
      '(5)突然胎動劇烈、胎動減少(一天少於10次或與平常及前一天相比，胎動次數減少一半或刺激後2小時內仍無胎動)。',
      '(6)子癲前症之孕婦有頭痛、視力模糊、上腹痛等不適症狀。',
      '(7)其他明顯不舒服的情形，如有畏寒或發燒等現象。',
    ],
  },
];

export const drugEffect = [
  {
    render: h(SimpleTable, {
      content: drugEffectContent,
      mt: false,
      mb: false,
    }),
  },
];

export const coreTrackingWording = [
  {
    type: 'normal-bold',
    text: '『兩歲前追蹤』',
    style: {
      fontSize: '20px',
      marginBottom: '10px',
    },
  },
  {
    type: 'normal',
    text: [
      '有鑑於長期追蹤檢查之重要，基金會於民國84年8月起，在台灣北、中、南陸續開辦八區「極低出生體重早產兒出院後的追蹤檢查工作」。全國聘請8位個案管理師，配合新生兒科醫師、兒童發展心理師等專業人員，於矯正年齡6、12、24個月時返診進行評估，及早發現問題、及時做適當處置或轉介至眼科、耳鼻喉科、復建科、早療…等機構，期待將早產併發的後遺症減至最低，並獲得完善治療。',
    ],
    style: {
      marginTop: '0',
    },
  },
  {
    type: 'important-center',
    text: '早產兒基金會各區追蹤小組成員',
  },
  {
    render: h(SimpleTable, {
      content: trackingMemberContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
  {
    type: 'normal-bold',
    text: '『滿五歲追蹤』',
    style: {
      fontSize: '20px',
      marginBottom: '10px',
    },
  },

  {
    type: 'normal',
    text: [
      '為瞭解早產兒學齡前的發展狀況，自民國96年起，於部份追蹤檢查院區增加「極低出生體重早產兒五歲追蹤服務」，將評估重點放在對學習的影響上，如：注意力缺失、過動、語言及理解問題、動作協調、視力狀況或是學習適應不良等問題。針對其未來進入小學就讀的需求，給予適當的評估與建議。配合各院心理師施測評量資源，目前進行五歲追蹤之院區，請與您寶寶出生醫院的個案管理師聯繫洽詢。',
    ],
    style: {
      marginTop: '0',
    },
  },
];

export const expandTrackingWording = [
  {
    type: 'normal',
    text: [
      '『擴大全國性服務計畫』',
      '為使追蹤檢查制度普及全國相關醫院，早產兒基金會自民國98年至100年推行「極低出生體重早產兒全國性三年服務計畫」，並於101年起繼續將「極低出生體重早產兒擴大全國性服務」，推廣至台灣北、中、南及東部未曾進行追蹤檢查的醫院，輔導醫院自行建立追蹤檢查評估模式與及時轉介概念，照顧全國更多需要服務的極低出生體重早產兒。',
    ],
  },
  {
    type: 'important-center',
    text: '早產兒基金會輔導及推展之追蹤檢查擴大全國性服務計畫合作醫院',
  },
  {
    render: h(SimpleTable, {
      content: trackingNationalServiceContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
];

export const nationalTrackingNetworkWording = [
  {
    type: 'normal',
    text: [
      '基金會在各院際間長期的合作下，將既有的核心追蹤院區，與追蹤模式推廣的擴大追蹤院區，聯合成為全國性的早產兒追蹤網絡，期盼每一個早產孩子，都能藉由此網絡的相互支援與協助獲得最適的幫助。',
    ],
  },
  {
    type: 'important-center',
    text: '極低出生體重出院後追蹤檢查全國網絡',
  },
  {
    // render: h('h1', '這裡有一個台灣醫院資訊'),
    render: NationalHospitalNetwrok,
  },
];

export const preemieTrackingFromWording = [
  {
    type: 'normal',
    text: [
      '過去在台灣平均每年有近18至20萬個新生兒誕生，早產兒出生比例約佔10%，因此每年約有1萬8千位早產兒出生。隨著少子化時代到來，早產兒發生比率並未降低，反而早產兒照護品質更形重要。民國84年3月全民健保的實施，提升了早產兒存活率，而二十幾年來台灣之早產兒醫護水準也有顯著進步，其中出生體重不足1500公克(極低出生體重)早產兒存活機率明顯增加，如何協助這些弱小的孩子進行全面性的長期追蹤顯得十分重要。',
    ],
    style: {
      marginBottom: '20px',
    },
  },
  {
    type: 'normal',
    text: [
      '本會的宗旨是讓每個早產兒都能接受適當的醫療，提升早產兒醫療照顧品質，鼓勵社會大眾一起來關懷並重視早產所產生的問題，同時也致力於早產兒的預防與教育。早產兒是高危險群，特別是極低出生體重早產兒可能會罹患呼吸道疾病、敗血症、視網膜病變、顱內出血及周腦室白質軟化症等疾病，出院後要定期進行追蹤檢查，需要醫護人員與父母一起評估孩子的營養狀況、心智以及身體發展的成熟度。在矯正年齡兩歲以前，更需要早期發現異常，提供更充分的環境刺激和訓練機會，進行早期治療，促進其發展，以期及早發現問題，及時給予適當的療育。',
    ],
    style: {
      marginBottom: '20px',
    },
  },
  {
    type: 'normal',
    text: [
      '民國84年本會開始「極低出生體重早產兒門診追蹤檢查」服務方案，與全國26家合約醫院共同推展追蹤門診檢查服務至今已邁過28年，有逾八成的極低出生體重早產兒獲得追蹤檢查，但仍有近二成的早產兒無法獲得追蹤照顧，需要結合政府、醫療院所及社區公衛體系共同合作以達到全面性追蹤照顧。早產兒父母總是期待孩子出院後，能夠與一般孩子一樣健康發展，但是極低出生體重早產兒因為出生週數小體重輕，需要在矯正年齡兩歲以前提供追蹤關懷，給予適切的環境刺激及訓練機會。',
    ],
  },
];

export const preemieTrackingWhoAndScheduleWording = [
  {
    type: 'normal',
    text: '在早產兒追蹤檢查計畫中，我們建議出生體重≤1500公克或出生週數≤29週的極低出生體重早產兒，於『矯正年齡』第6、12、24個月定期回診接受完整的追蹤檢查直到矯正年齡2歲為止（所謂矯正年齡，是以媽媽的預產期來計算寶寶的年齡）。依據不同年齡進行適齡能力與心智發展成熟度的評估，及早篩檢出異常情形，做適當的轉介與治療，進一步提供給早產兒更好的發展環境與機會。',
  },
  {
    type: 'normal',
    text: '矯正年齡算法：',
  },
  {
    render: h(CorrectedAgeIntro),
  },
  {
    type: 'normal',
    text: '不論寶寶何時出生，以目前日期減預產期日期即可計算寶寶的矯正年齡。(例如：寶寶出生日期為5月1日，媽媽的預產期是7月1日，則至8月1日時，寶寶的矯正年齡為1個月。)',
  },
  {
    render: h(SingleImg, {
      src: dischargeIntroImg,
      // maxWidth: '75%',
    }),
  },
];

export const preemieTrackingContentWording = [
  {
    type: 'normal',
    text: '早產兒追蹤門診檢查的項目，著重於生長營養狀態、視覺、聽覺、心智發展、神經肌肉與粗細動作的發展評量。期能早期發現發展遲滯的孩童，以便能幫助他們獲得早期治療。完整的早產兒追蹤檢查計畫，應該包括有五大項目：',
  },
  {
    type: 'normal-bold',
    text: '1、身高、頭圍、體重與營養狀態評估：',
    style: {
      marginTop: '20px',
    },
  },
  {
    type: 'normal',
    text: '除了量測生長指標，並對照矯正年齡的生長曲線表外，並應針對營養狀態、哺育攝取情形、副食品添加比重提供適當的營養諮詢。',
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal-bold',
    text: '2、神經發育與粗細動作檢查：',
  },
  {
    type: 'normal',
    text: '藉由肌肉張力的評量(如關節角度的量測)，神經反射的出現或消失、坐姿與站姿的穩定性來評量早產兒的神經發育狀況。提醒家長及醫療人員，注意早產兒之後是否迎頭趕上。',
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal-bold',
    text: '3、心智發展評測：',
  },
  {
    type: 'normal',
    text: '目前常用來評測心智發展的工具在3歲以前為「貝利嬰幼兒發展測驗」第3版(Bayley Scales of Infant Development, 簡稱為 BSID－Ⅲ)，藉由經設計過的模型、圖型與玩具加以評量嬰幼兒目前在認知、語言、社會人際以及精細動作（如手部模仿、握筆）、粗動作（如爬、坐、站、走）之各項功能，配合評測過程的行為觀察，全面而整體性地了解嬰幼兒的心智發展情形。在5歲兒童的追蹤門診中，心智發展評測的工具包括中文版魏氏幼兒智力量表修訂版、以及活動量表、氣質量表的評估，希望藉助完整的評估來瞭解學前早產兒的心智發展狀況與行為表現。',
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal-bold',
    text: '4、眼科評估：',
  },
  {
    type: 'normal',
    text: [
      '視網膜是寶寶看到物體的重要工具，而早產兒們視網膜產生病變的機率偏高，建議父母應該讓寶寶追蹤至受孕滿40週的週齡左右，才可以安心（部分早產兒日後仍會發生遠視、近視、斜視、散光、視力障礙與影像變形的後遺症）。',
      '視網膜以及視力檢查是早產兒的追蹤檢查中重要的一環，因為一些眼科問題並非外觀或肉眼觀察就可得知，尤其是視網膜病變的變化快速，更要及早發現，才能避免發生嚴重的視力問題。因此在早產兒追蹤門診中，除了滿40週齡左右的首次視網膜檢查外，建議在早產兒矯正年齡1歲到1歲半時，也須開始做視力檢查，之後再依照寶寶的個別情況，由小兒眼科醫師持續追蹤。',
    ],
    style: {
      marginTop: 0,
    },
  },

  {
    type: 'normal-bold',
    text: '5、聽力評估：',
  },
  {
    type: 'normal',
    text: '早產兒寶寶出院前，皆須接受初步的聽力篩檢檢查。檢測結果若出現異常，則需在門診中提醒家屬後續的追蹤，與決定是否需要及早轉介小兒耳鼻喉科醫師進一步評估與處理。另外提醒父母的是，並沒有一種聽力檢查能夠完全檢查出聽力問題，所以除了聽力篩檢所提供的數據以外，仍應多從小朋友發展的語言、說、聽、理解、表達或認知能力，來評估聽力是否異常，才能更為準確。',
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: '另外，針對早產兒寶寶實際發生的併發症，如慢性肺疾病的居家照顧、腦室內出血、疝氣或如何避免感染等問題，視其需要而作個別的評估與處理。唯有經由實際的接觸與追蹤，才能找出需要指導與復健的寶寶，給予安排檢查，作適當地處理與治療。',
  },
];

export const homeCareDietWording = [
  {
    type: 'important',
    text: '一、母乳、母乳添加劑',
  },
  {
    type: 'normal-bold',
    text: ' ◎母乳的好處',
  },
  {
    type: 'normal',
    text: [
      '1.營養成分高：母乳營養最完整均衡，成份更會隨著早產兒成長而調整，量身定做滿足其各階段的生長需求。',
      '2.容易吸收：母乳屬於容易消化吸收，母乳中的鐵50%被吸收，牛奶中的鐵只有10%被吸收。',
      '3.抗菌因子多：母乳含有A型免疫球蛋白、生長因子、補體及乳鐵蛋白等成份，可以增強抵抗力。',
      '4.過敏風險低：皮膚、鼻子及支氣管較不易致敏，降低過敏性疾病的發生。',
      '5.增加親子間連結：早產寶寶一出生被迫與媽媽分離，但只有媽媽能夠提供給母奶，縱使還無法親餵，但為他擠奶也使你們之間有如懷孕期間的連結感，唯有媽媽提供的母奶能幫助他成長和茁壯。',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎奶量計算原則',
  },
  {
    type: 'normal',
    text: [
      '每天總奶量大約是每公斤體重*(150 ± 30 cc)，總奶量÷每日哺餵次數=每次餵奶量。',
      '(資料來源：衛生福利部國民健康署-孕產婦關懷網站)',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎母乳的儲存',
  },
  {
    type: 'normal',
    text: [
      '對早產兒而言，擠出之奶水除非於1小時內使用，否則應立即放入冰箱並標示日期、時間，建議置於冷藏室存放時間為2天，且避免放在冰箱的門邊，而是儘量放在冰箱的內部，比較不會受開關門影響溫度的地方。',
    ],
  },
  {
    type: 'normal',
    text: [
      '1.保存時間：『333原則』：在室溫下可放置3小時、冷藏室可放3天、獨立冷凍室可放3個月。這是絕對安全的時間，家長們也可以以此方式來儲存。',
      '母乳之存放期限表格如下：',
    ],
  },
  {
    render: h(SimpleTable, {
      content: breastMilkExpireContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
  {
    type: 'normal',
    text: '2.奶水回溫的使用',
  },
  {
    type: 'normal',
    text: [
      '◦溫度：不超過攝氏60度(建議：40度左右)。',
      '◦方式：食物加熱器或隔水加熱。(絕不可用微波爐或瓦斯爐回溫)',
      '◦回溫時，水位不超過瓶蓋。',
      '◦食用前輕微的搖晃，使脂肪混合均勻',
    ],
  },
  {
    type: 'normal',
    text: [
      '★注意事項',
      '1.冷藏過的奶水於室溫下退涼，可將奶瓶放於內有溫水的碗中回溫。',
      '2.冷凍過的奶水可放在冷藏室解凍，或是在流動的涼或溫水下解凍。',
      '3.回溫加熱過的奶水若未使用，則可放回冷藏並於4小時內食用完畢。',
      '4.食用過的奶水，若未食用完畢應丟棄，不能再冷藏或冷凍重覆使用。',
    ],
  },
  {
    render: h('p', [
      h(
        'span',
        {
          style: {
            ...font(),
          },
        },
        '◎',
      ),
      h(
        'a',
        {
          href: 'https://mammy.hpa.gov.tw/Home/NewsKBContent/471?type=01',
          target: '_blank',
          rel: 'noreferrer noopener',
          style: {
            ...font(),
            'text-decoration': 'underline',
            cursor: 'pointer',
          },
        },
        '母乳庫資訊請點擊我',
      ),
    ]),
  },
  {
    type: 'normal',
    text: '◎母乳添加劑：通常為粉劑包裝，醫師會評估早產兒的生長狀況來建議添加母乳添加劑劑量，以提高鈣、磷含量，並增加母乳中蛋白質和其他礦物質的含量。',
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'important',
    text: '二、早產兒配方奶、早產兒出院後配方',
  },
  {
    type: 'normal',
    text: [
      '1.營養',
      '早產兒母親若因故無法以母乳餵養，此時會使用專為早產兒設計的配方奶粉，它含有較高的熱量、蛋白質、礦物質及維他命，且蛋白質、脂肪較易吸收，以達到胎兒在母親子宮內的生長速度。各類奶粉成分特色如下表：',
    ],
  },
  {
    render: h(SimpleTable, {
      content: milkPowerFeatureContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
  {
    type: 'normal-bold',
    text: '◎配方奶粉沖泡方式',
  },
  {
    type: 'normal',
    text: [
      '1.依廠牌湯匙大小不同沖泡不同的水量，依罐裝外標示為主。',
      '2.洗淨雙手→先放冷水後放熱水調至適當溫度(>70度~阪崎腸桿菌)→再放奶粉→以手臂前臂內側測試溫度。',
      '3.沖泡濃度太濃—腹瀉；濃度不足(太稀)—便秘',
    ],
  },
  // {
  //   type: 'normal-bold',
  //   text: '◎配方奶奶量建議表',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '欲增加奶量，一次以5~10ml為宜，且於增加奶量後須觀察早產兒有無腹脹，嘔吐情形，依早產兒需要，不要強迫餵食。下表為參考之建議表：',
  //   ],
  // },
  // {
  //   render: h(SimpleTable, {
  //     content: milkPowerPrescriptionContent,
  //     style: {
  //       marginTop: '20px',
  //       marginBottom: '20px',
  //     },
  //   }),
  // },
  {
    type: 'important',
    text: '三、餵奶須知',
  },
  {
    type: 'normal-bold',
    text: '◎奶嘴的選擇',
  },
  {
    type: 'normal',
    // text: [
    //   '早產兒因為吸吮能力較弱，奶嘴應以質軟、圓洞為佳；因每位早產兒吸吮與吞嚥情況有個別差異，實際哺餵前可與醫護人員討論。通常合適的奶洞大小，是以奶瓶倒立時，奶水可以一秒一滴流下來為宜。',
    // ],
    render: textInRow([
      {
        t: '早產兒因為吸吮能力較弱，奶嘴應以',
      },
      {
        t: '質軟、圓洞',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
      {
        t: '為佳；因每位早產兒吸吮與吞嚥情況有個別差異，實際哺餵前可與醫護人員討論。通常合適的奶洞大小，是以奶瓶倒立時，奶水可以',
      },
      {
        t: '一秒一滴',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
      {
        t: '流下來為宜。',
      },
    ]),
    // render: h('p', [
    //   h('span', '早產兒因為吸吮能力較弱，奶嘴應以'),
    //   h('span', '質軟、圓洞'),
    //   h('span', '為佳；因每位早產兒吸吮與吞嚥情況有個別差異，實際哺餵前可與醫護人員討論。通常合適的奶洞大小，是以奶瓶倒立時，奶水可以'),
    //   h('span', '一秒一滴'),
    //   h('span', '流下來為宜。'),
    // ])
  },
  {
    type: 'normal-bold',
    text: '◎奶瓶的消毒',
  },
  {
    type: 'normal',
    text: [
      '現今消毒的方式及工具的選擇都很多，如煮沸消毒、蒸氣消毒、紫外線消毒以及蒸氣烘乾式消毒，照顧者可依需求選擇合適的消毒種類及器具。',
      '6個月以下的寶寶一定要消毒奶瓶，而未滿1歲的寶寶腸胃抵抗力普遍都比較弱。建議持續消毒奶瓶直到寶寶滿1歲。',
    ],
  },
  {
    type: 'important',
    text: '四、餵奶技巧',
  },
  {
    type: 'normal-bold',
    text: '◎餵奶方法',
  },
  {
    render: h(TextImg, {
      wording: [
        {
          type: 'normal',
          text: [
            '1.以肥皂徹底將手清洗乾淨，再抱嬰兒。',
            '2.餵奶時將寶寶抱起，頭部抬高45度。',
            '3.將奶瓶傾斜，使奶嘴充滿奶水，以免寶寶吸進空氣，導致腹脹。',
            '4.餵完讓寶寶坐著或斜靠在大人肩上，手呈杯狀，輕拍或摩擦寶寶的背部讓寶寶打嗝，若仍未打嗝，可讓寶寶向右側臥或頭部抬高，避免因吐奶而造成吸入性肺炎。',
          ],
        },
      ],
      imgOption: {
        src: burpImg,
        maxWidth: '200px',
        textAlign: 'left',
        label: '(拍嗝示意圖)',
      },
    }),
  },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.以肥皂徹底將手清洗乾淨，再抱嬰兒。',
  //     '2.餵奶時將寶寶抱起，頭部抬高45度。',
  //     '3.將奶瓶傾斜，使奶嘴充滿奶水，以免寶寶吸進空氣，導致腹脹。',
  //     '4.餵完讓寶寶坐著或斜靠在大人肩上，手呈杯狀，輕拍或摩擦寶寶的背部讓寶寶打嗝，若仍未打嗝，可讓寶寶向右側臥或頭部抬高，避免因吐奶而造成吸入性肺炎。',
  //   ],
  // },
  // {
  //   render: h(SingleImg, {
  //     src: burpImg,
  //     maxWidth: '200px',
  //     textAlign: 'left',
  //     label: '(拍嗝示意圖)',
  //   }),
  // },
  {
    type: 'normal',
    text: [
      '★注意事項',
      '1.餵奶時應採分段餵食，並隨時注意早產兒的膚色及唇色，若有發紺現象，應先停止餵奶，並給予適當刺激，待早產兒的膚色及唇色恢復後再繼續餵奶。',
      '2.隔餐奶不可再餵食。',
      '3.勿讓寶寶平躺著自己喝奶，以免嗆到，或導致中耳炎。',
      '4.餵配方奶之早產兒，因奶粉消化較慢，餵奶間隔時間可較長，通常開始時每隔3~4小時餵食一次即可。在六週後，可減少晚上餵奶的次數，至於減少的次數及餵食間隔的長短，須視嬰兒的大小和發展狀況而定。',
      '5.餵食量有時會有奶量不一情況，切勿長期大小餐，並觀察寶寶的體重、身高及頭圍有無持續增加。',
    ],
  },
  {
    type: 'important',
    text: '五、副食品',
  },
  {
    type: 'normal-bold',
    text: '◎添加副食品時機：',
  },
  {
    type: 'normal',
    text: '副食品添加是以矯正年齡來計算，當早產寶寶矯正年齡達四個月大有出現厭奶期奶量減少、不肯喝奶、或是稍微保持坐姿，對食物表現出興趣時，都是添加副食品的好時機。別忘記每個寶寶都是獨特的個體，幾個月的差別是正常的，副食品添加一般不建議早於矯齡4個月，但也不宜晚於6個月，以免影響孩子日後對固體食物的接受度。',
  },
  {
    type: 'normal-bold',
    text: '◎添加副食品順序',
  },
  {
    type: 'normal',
    text: '添加副食品的種類應循序漸進，一般建議順序為五榖類→蔬菜泥→水果泥→肉泥、蛋黃泥→魚。',
  },
  {
    type: 'normal-bold',
    text: '◎副食品添加原則',
  },
  {
    type: 'normal',
    text: [
      '1.持續哺餵母乳或餵食配方奶。',
      '2.以天然食物為主，注意新鮮及安全，製作副食品時應注意食物、用具及雙手的清潔。',
      '3.由少量到多量，由稀到稠，由流質到固體，一次一種新食物，每種食物最好可持續食用3~5天，若吃過的食物無任何不良反應則可持續食用。',
      '4.建議選擇在早上添加新食物，方便後續觀察有無過敏反應。',
      '5.可於餵奶前半小時到1小時添加，吃完副食品再喝牛奶。',
      '6.副食品不要放在奶瓶中，應使用湯匙餵食以訓練嬰兒咀嚼的功能，避免強迫餵食。',
      '7.注意有無不良反應：過敏如皮膚紅疹(尤其嘴巴周圍)、氣喘或腹瀉等。',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎副食品添加方式及參考建議',
  },
  {
    render: h(SimpleTable, {
      content: subFoodMixinMethodContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
  {
    type: 'normal-bold',
    text: ' 副食品添加注意事項',
  },
  {
    type: 'normal',
    text: [
      '避免容易引起過敏的食物：牛奶、蛋白、花生、帶殼的海鮮類、酸性的水果，如：草莓、柑橘、蕃茄，都是比較容易引起過敏的食物，一歲之前不要食用。',
      '蜂蜜：一歲前的小孩，不適合攝取任何形式的蜂蜜，以免引起肉毒桿菌中毒。',
      '花生：兩歲前的小孩，不適合餵食花生醬和其他堅果類食物。',
      '鮮奶：一歲前的嬰兒建議使用母乳或配方奶，一歲以下的嬰孩無法吸收鮮奶中的蛋白質，且其中某些礦物質可能損害嬰兒的腎臟。兩歲之前不要給寶寶脫脂牛奶，以免缺乏必需脂肪酸。',
      '如寶寶屬過敏性機會高的嬰兒，建議一歲時才加入奶油製品，兩歲給予雞蛋，三歲才開始接觸花生、堅果類、魚類與海鮮食物。',
      '對矯正年齡一歲以內的寶寶來說，奶以外的食物為副食品，也就是說可能非主要營養來源。除了一些上述的禁忌食物以外，此時期應多方讓孩子嚐試各種食物，一開始都可從少量嚐試來觀察有無不適之反應；而一歲過後，則要漸漸讓孩子以食物為主、奶為輔，以避免營養素攝入不均以及培養日後良好的用餐習慣。',
    ],
  },
];

export const homeCareDrainWording = [
  {
    type: 'important',
    text: '一、便秘',
  },
  {
    type: 'normal',
    text: '一般而言，寶寶一天大概解1~3次大便，平時應仔細觀察寶寶排泄物的形狀、顏色、氣味以及排便量，以初步預防腸胃道疾病。早產兒與足月嬰兒的排泄並無不同，請依一般狀況照顧。',
  },
  {
    type: 'normal-bold',
    text: '◎何謂便秘',
  },
  {
    type: 'normal',
    text: '大便質地變硬、堅實，大便次數減少，甚至數天未解大便。不過，若數天才解1次大便，但不是硬便，且寶寶平時沒有不舒適的表現，則不是便秘。',
  },
  {
    type: 'normal-bold',
    text: '◎原因',
  },
  {
    type: 'normal',
    text: ['1.胃腸蠕動遲緩。', '2.配方奶沖泡不當，如牛奶沖泡濃度太稀。', '3.其他，如腸阻塞、巨結腸症。'],
  },
  {
    type: 'normal-bold',
    text: '◎居家照顧',
  },
  {
    type: 'normal',
    text: [
      '1.若3天未解大便，可先做腹部按摩、雙腳踩腳踏車運動、增加活動力。',
      '2.已經開始攝取副食品之早產兒，則鼓勵多攝取果泥、菜泥或黑棗汁。',
      '3.可就醫由醫師評估或經醫師同意後再以肛溫計或棉花棒塗上潤滑油（如凡士林、甘油）抬高雙腿，放入肛門1~2公分，輕輕旋轉，以刺激腸胃蠕動及幫助排便。',
    ],
  },
  {
    type: 'normal',
    text: [
      '★注意事項',
      '1.純母乳者由於母乳較易消化，殘渣較少，可以3-21天才解一次大便，若食慾正常，無腹脹、嘔吐或其他不適症狀發生，只需觀察即可。',
      '2.一歲前的小孩避免給蜂蜜水，以免引起肉毒桿菌中毒。',
    ],
  },
  {
    type: 'important',
    text: '二、腹瀉',
  },
  {
    type: 'normal',
    text: '以氣味及性質為主，不以次數定論，若大便比以前酸臭，或由軟便轉為稀水便，或帶黏液且次數比平常多，則為腹瀉。',
  },
  {
    type: 'normal-bold',
    text: '◎原因',
  },
  {
    type: 'normal',
    text: [
      '引起腹瀉的原因很多，約可分為以下幾點：',
      '1.與飲食有關：牛奶過敏、配方奶沖泡太濃、乳糖耐受不良、喝過量的果汁、吃到不新鮮的食物、副食品添加不當等。',
      '2.感染：由病毒或細菌等引起之腸炎。',
      '3.其他：巨結腸、內分泌問題等。',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎嚴重腹瀉可能出現的症狀',
  },
  {
    type: 'normal',
    text: [
      '1.不想吃或食量減少，甚至體重減輕。',
      '2.腹脹或嘔吐。',
      '3.嚴重時會有發燒脫水如嘴唇乾、哭鬧不安、小便減少或活動力下降、嗜睡等情形。',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎居家照護',
  },
  {
    type: 'normal',
    text: [
      '1.可持續哺餵母乳，但餵奶前照顧者請加強洗手動作。',
      '2.泡配方奶前及接觸嬰兒前後都要洗手。',
      '3.要用煮沸過的開水沖泡奶粉，奶瓶須正確消毒及存放，且避免接觸不乾淨物品。',
      '4.勤換尿布保持乾燥，避免紅臀。',
      '5.寶寶出院後，如有多次嘔吐、腹脹、水瀉、解血便的情況，應儘速就醫。',
      '6.非經醫師指示，不可服用任何藥物。',
    ],
  },
];

export const homeCareCleanWording = [
  // {
  //   type: 'important',
  //   text: '三、清潔沐浴',
  // },
  {
    type: 'normal',
    text: [
      '此時是觀察寶寶全身最重要的時機，也是親子互動的良好時刻，父母應好好把握為寶寶洗澡的大好時機。',
      '1.時間：每天選擇氣溫較高的時間為寶寶洗澡，一天一次，並應選在餵奶前，以防吐溢奶及可能發生的吸入性肺炎問題。',
      '2.環境：選擇安全、避風、溫暖的地方，室溫最好在25~28℃左右。',
      '3.沐浴前的準備：',
      '照顧者的指甲應剪短，協助沐浴前應先洗手，並取下手錶、戒指。',
      '將所需衣物備妥，且將沐浴完欲穿之衣物一一套好。',
      '準備洗澡水時，先放冷水再加熱水，避免家中其他幼兒靠近；以水溫計或手腕內側試水溫，約37-40℃左右就可以了。',
      '4.用品準備，如下：',
    ],
  },

  {
    type: 'normal-indent',
    text: [
      '(1)浴盆一個、',
      '(2)水溫計、',
      '(3)大浴巾一條、',
      '(4)小毛巾二條、',
      '(5)微酸性或中性(PH5.5左右)清潔沐浴乳（肥皂）、',
      '(6)嬰兒衣物及尿布、',
      '(7)小棉花棒、',
      '(8)臍帶護理包（75%酒精、95%酒精、無菌小棉棒）',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: '5.沐浴步驟：',
    style: {
      marginTop: 0,
    },
  },
  {
    render: textInRow([
      {
        t: '脫下寶寶衣褲後，以大毛巾包裹其身體，將寶寶身體夾在協助者的腰側處，然後一手托住寶寶的頭、頸及背部，如同抱橄欖球的方式。依以下步驟清洗：',
      },
      {
        t: '洗臉(眼、鼻孔、耳、臉)→頭→以毛巾擦乾頭髮→身體(胸部、肚子、四肢、縐摺處、生殖器及肛門區)→擦乾身體',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
    ]),
  },
  {
    render: h(MultipleImg, {
      imgs: [
        {
          src: washBaby1,
          maxWidth: '150px',
          textAlign: 'left',
        },
        {
          src: washBaby2,
          maxWidth: '150px',
          textAlign: 'left',
        },
        {
          src: washBaby3,
          maxWidth: '150px',
          textAlign: 'left',
        },
        {
          src: washBaby4,
          maxWidth: '150px',
          textAlign: 'left',
        },
        {
          src: washBaby5,
          maxWidth: '150px',
          textAlign: 'left',
        },
      ],
    }),
  },
  {
    type: 'normal',
    text: '(洗澡步驟示意圖)',
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: [
      '選擇適合的紙尿褲，穿上衣服並拉平整齊：由於早產寶寶肌膚較脆弱，為了避免寶寶身體被尿布或紙尿褲整個包覆而悶熱不舒服，以降低不適感與勒痕的發生，並可同時防止外漏。',
      '◆注意事項',
    ],
  },

  {
    type: 'normal-indent',
    text: [
      '(1)洗臉以清水擦拭，不須用肥皂。',
      '(2)洗眼睛時，宜由內而外，勿來回擦拭。',
      '(3)洗頭時以大拇指、中指分別壓住寶寶的兩耳，以防止水流入耳內',
      '(4)如有糞便附著在臀部，以小毛巾擦去，以減少紅臀的發生。',
      '(5)女嬰應多注意會陰部的清洗，須把小陰唇的皺摺處撐開，由前向後清洗（由寶寶前面的尿道口向後面的肛門口清洗），男嬰則將尿道口、包皮皺摺、陰囊洗淨。',
      '(6)耳後、頸部、腋下、腹股溝及關節等皮膚皺摺處應清洗乾淨並擦乾。',
      '(7)臍帶護理：臍帶護理的時間可於沐浴後、臍帶潮濕或沾上糞便時給予清潔消毒。臍帶於出生後約10~14天會自然乾硬脫落。',
    ],
    style: {
      marginTop: 0,
    },
  },
  {
    type: 'normal',
    text: [
      '步驟1.先用75%之酒精在臍帶根部，以無菌棉花棒由內向外作環形消毒。',
      '步驟2.用95%酒精再作一次消毒。',
      '※備註：觀察臍帶有無任何發紅臭味、出血或感染之現象。',
    ],
  },
];

export const homeCareBodyTemparatureWording = [
  // {
  //   type: 'important',
  //   text: '四、體溫調節',

  // },
  {
    type: 'normal-bold',
    text: '◎如何維持寶寶適合的溫度',
  },
  {
    type: 'normal',
    text: '寶寶缺乏足夠的皮下脂肪來禦寒，汗腺的功能也尚未發展完全，因此，大人不容易由寶寶是否出汗來辨別他是否穿太多。不過，可以參考以下指標來決定衣物多寡：',
  },
  {
    render: h(SimpleTable, {
      content: bodyTemperatureAdjustContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },

  {
    type: 'normal',
    text: '備註：嬰兒生病時，身體調節溫度的能力較不穩定，需要視情況做衣量增減。',
  },
  {
    type: 'normal-bold',
    text: '◎一般發燒概念',
  },
  {
    type: 'normal',
    text: ['平均正常核心體溫是37℃，介於36.4～37.5℃間，核心體溫如超過38℃即是發燒。', '正確的體溫測量方法：'],
  },
  {
    render: h(SimpleTable, {
      content: takeBodyTemperatureContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
  {
    type: 'normal',
    text: '3個月以上可以使用肛溫、腋溫電子體溫計及耳溫槍',
  },
  {
    type: 'normal-bold',
    text: '◎體溫過低之處理',
  },
  {
    type: 'normal',
    text: '當腋溫36.5℃以下時，給寶寶增加蓋被、衣物，或提高室內溫度，約30分鐘至1小時後再測量寶寶體溫，若仍未上升，應就醫求治。',
  },
  {
    type: 'normal-bold',
    text: '◎體溫過高',
  },
  {
    type: 'normal',
    text: [
      '發燒是一種生理性的調節反應，可以增強免疫功能，幫助身體抵抗外來的微生物感染。',
      '當體溫超過37.5℃時：',
      '1.請減少寶寶的衣物或蓋被。',
      '2.溫水拭浴。',
      '3.視情況使用涼水枕(非冰枕)，但需要小心評估，避免引起寶寶發冷、顫抖，引發體溫過低的危險。',
      '4.請勿自行服用退燒藥使寶寶退燒，退燒藥物一律需經由醫師指示服用。',
      '5.執行措施後，請於30分鐘至1小時後再測量體溫，若體溫仍未降低，則應送醫治療。',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎嬰兒發燒應送醫就診的標準（若有下列任何一症狀出現，要立即就醫）',
  },
  {
    render: h(SimpleTable, {
      content: babyHeatToHospitalContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },
];

export const homeCareSleepWording = [
  // {
  //   type: 'important',
  //   text: '五、睡眠型態',
  // },
  {
    type: 'normal-bold',
    text: '◎嬰兒睡眠與成長',
  },
  {
    type: 'normal',
    text: [
      '1.寶寶在睡覺時，腦部會進行整理、重整與認知日間接收的資料及恢復所消耗的體力，避免隨意吵醒寶寶。',
      '2.睡眠時，於晚上10點到凌晨2點所釋出的生長激素較清醒時高達3倍或以上，另外也能加強釋放肌肉生長與修復的主要激素。',
      '3.睡眠減少或睡眠被剝奪會造成免疫細胞功能降低，使免疫力、專注及集中力都會較差，長期睡眠不足，會產生對外界事物失去興趣，並影響情緒及入學前的適應期。',
      '※備註：生長激素能促進骨骼神經生長和腦部發育(學習認知、記憶力發展及注意力集中程度等)、幫助嬰幼兒燃燒脂肪，轉化成肌肉能量，使身體強化韌帶與肌腱，加強蛋白質合成等。 ',
    ],
  },
  {
    type: 'normal-bold',
    text: '◎小寶寶要睡多久，怎麼睡才算正常？',
  },
  {
    type: 'normal',
    text: [
      '每個寶寶各有不同的體質、睡眠需求和模式。『吃飽睡，睡飽吃』是初生嬰兒的典型作息，他們的吃睡週期是沒有晝夜分別的。大約要到六個月大之後，自主活動能力逐漸增加，開始試著探索周遭的世界，同時較有能力和大人互動之後，才逐漸呈現『白天活動、晚上睡覺』的作息模式。平均來說，新生兒的一天大約有2/3以上的時間是在睡夢中，一直到三歲大的小兒一天仍需要睡到12小時左右。一般來說，只要不太脫離常軌，生長發育曲線也正常即可。',
      '下表僅供參考之用：0-3歲嬰幼兒睡眠需求(單位：小時)',
    ],
  },
  {
    render: h(SimpleTable, {
      content: babySleepDemainingContent,
    }),
  },

  {
    type: 'normal-bold',
    text: '◎夜間睡不好的常見原因',
  },
  {
    type: 'normal',
    text: [
      '一歲以內寶寶夜哭的常見原因：',
      '1.飢餓。',
      '2.因大小便，需要更換尿褲。',
      '3.睡眠環境不適如太熱、太冷、太吵。',
    ],
  },
  {
    type: 'normal',
    text: [
      '其他可能原因：',
      '1.單純腹絞痛：睡到半夜會突然，開始脹紅著臉大哭，約在三月大後就會改善。',
      '2.腹絞痛合併腹瀉：胃口變差可能有腸胃炎或是牛奶蛋白過敏，建議就醫檢查。',
    ],
  },
  {
    type: 'normal',
    text: [
      '一歲以後幼兒夜哭、不睡覺的常見原因：',
      '1.生理狀況不適。',
      '2.心理因素如認床、作惡夢、尿床、上床時間不固定、白天或睡覺前太興奮等。',
    ],
  },

  {
    type: 'normal-bold',
    text: '◎七大方法讓寶寶好入眠',
  },
  {
    type: 'normal',
    text: [
      '1.白天適當增加寶寶活動量，午睡時間安排在中餐後，以2小時為上限。',
      '2.培養規律的作息及配合生長激素分泌時段，建議每天晚上9點安排小孩上床。',
      '3.睡前可做溫和的活動如：洗澡、穿舒適的睡衣、聽柔和的音樂。',
      '4.寶寶睡覺時無特定姿勢，以舒適為主，但若有不適可側睡、正躺。',
      '5.營造睡眠環境，柔和的光線可讓寶寶放鬆，安心入睡。',
      '6.在固定環境睡覺，熟悉的環境、氣味能產生安全感，較易安心入睡。',
      '7.建立寶寶獨睡的習慣，減少搖哄次數。',
    ],
  },
  {
    type: 'normal',
    text: '睡眠是人類生活中不可或缺的一部分，對於正在成長中的嬰幼兒而言更顯得重要、不可或缺，孩童的成長是不分白天黑夜的，分秒都在變化發育，睡眠與寶寶的生長發展有很大的關聯。',
  },
  {
    type: 'normal-bold',
    text: '◎嬰兒睡眠影響認知',
  },
  {
    type: 'normal',
    text: '嬰兒在睡覺時，有一半的時間腦部在進行整理、重整與認知日間接收的資料。提醒家長應注意寶寶的睡眠品質，不要無謂吵醒寶寶，以養成良好的睡眠習慣。研究報告顯示，睡眠不足的寶寶，專注及集中力都會較差。長期睡眠不足，會產生對外界事物失去興趣，並影響情緒及入學前的適應期。',
  },
  {
    type: 'normal-bold',
    text: '◎嬰兒睡眠與免疫抵抗力',
  },
  {
    type: 'normal',
    text: [
      '睡眠減少或睡眠被剝奪，會造成免疫細胞功能降低，使得免疫力降低。',
      '嬰兒睡眠不僅是為了休息，睡眠時可同時刺激大腦不同的部位，對於學習非常重要。認知功能的維持與記憶力發展與睡眠的品質有直接關聯。',
    ],
  },
];

export const homeCareGrowingWording = [
  {
    type: 'normal',
    text: [
      '生長發展分為兩部份，隨著年齡增加產生變化的身高、體重及器官稱「生長」；智力與行為功能的成熟、由簡至繁的變化則稱為「發展」。',
      '家長若要學習評估早產兒的發展趨勢：',
      '1.父母親平日對孩子的生活行為觀察。',
    ],
  },
  {
    type: 'normal',
    render: textInRow([
      {
        t: '2.以',
      },
      {
        t: '矯正年齡',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
      {
        t: '為主，利用',
      },
      {
        t: '評估工具',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
      {
        t: '檢視孩子的發展進程是否符合標準：',
      },
    ]),
  },

  {
    type: 'normal',
    render: textInRow([
      {
        t: '(1)兒童健康手冊中的',
      },
      {
        t: '兒童發展連續圖',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
      {
        t: '及',
      },
      {
        t: '生長曲線百分位圖',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
    ]),
  },
  {
    type: 'normal',
    render: textInRow([
      {
        t: '(2)',
      },
      {
        t: '線上兒童發展檢核表篩檢',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
    ]),
  },

  {
    type: 'normal-indent',
    render: textInRow([
      {
        t: '(3)醫院的',
      },
      {
        t: '兒童發展評估門診',
        style: {
          fontWeight: '700',
          textDecoration: 'underline',
        },
      },
    ]),
  },
  {
    type: 'normal',
    text: [
      '如何使用生長曲線圖：',
      '利用世界衛生組織(WHO)公布之「國際嬰幼兒生長標準」為基礎所繪製「兒童生長曲線圖」來評估早產兒的身高、頭圍、體重的生長曲線圖是否符合標準，以更清楚孩子生長方面的狀況。',
      '1.按寶寶的性別，先找到橫向座標標示的矯正年齡。',
      '2.再對照縱向座標標示之身長/身高、體重與頭圍數值。',
      '3.即可找到寶寶在同年齡小孩的百分位。',
      '*備註：',
      '1.寶寶2歲以內請測量其躺下時的身長，2歲以上則是測量站立時的身高。',
      '2.生長狀況若介於3-97百分位屬正常範圍，但若超過97百分位或低於3百分位則代表有過高過重或是過低過輕之情形，成長是連續性的，依循整個生長趨勢，較能讓醫師準確評估孩子的發展是否落後。',
    ],
  },
  {
    render: h('div', [
      h('p', [
        h(
          'span',
          {
            style: font(),
          },
          '(',
        ),
        h(
          'a',
          {
            href: 'https://health99.hpa.gov.tw/onlineQuiz/child',
            target: '_blank',
            rel: 'noreferrer noopener',
            style: {
              ...font(),
              'text-decoration': 'underline',
              cursor: 'pointer',
            },
          },
          '歡迎使用衛生部福利部國民健康署健康九九資源-新版生長曲線',
        ),
        h(
          'span',
          {
            style: font(),
          },
          ')',
        ),
      ]),
    ]),
  },

  {
    render: h(LeftWordingRightImage, {
      src: preemieBrochure,
      wording: [
        {
          render: h('div',
            [h('p', [
              h(
                'span',
                {
                  style: font(),
                },
                '發展可再細分為粗動作、精細動作、語言及認知以及身邊處理及社會性，',
              ),
              h(
                'span',
                {
                  style: font(),
                },
                '可閱讀本會之出版刊物-',
              ),
              h(
                'a',
                {
                  href: 'https://api.pbf.org.tw/uploads/articles/e648ea33c7fa315ce3b77eb997ed3630.pdf',
                  target: '_blank',
                  rel: 'noreferrer noopener',
                  style: {
                    ...font(),
                    'text-decoration': 'underline',
                    cursor: 'pointer',
                  },
                },
                '早產兒追蹤檢查手冊P.19-P.29',
              ),

              h(
                'span',
                {
                  style: font(),
                },
                '供家長參考或創意激發，可以和孩子有更多的互動。',
              ),
            ]),

            ]),
        },
        // {
        //   render: h('p', [
        //     h(
        //       'span',
        //       {
        //         style: font(),
        //       },
        //       '每個孩子發展都存有變異，正常時程為50%的兒童能達到其發展；警訊時程為90%的兒童能達到其發展，',
        //     ),
        //     h(
        //       'span',
        //       {
        //         style: font({ color: '#FF000A' }),
        //       },
        //       '可利用',
        //     ),
        //     h(
        //       'a',
        //       {
        //         href: 'https://kids.eden.org.tw/?action=screening&year=1',
        //         target: '_blank',
        //         rel: 'noreferrer noopener',
        //         style: {
        //           ...font({ color: '#FF000A' }),
        //           'text-decoration': 'underline',
        //           cursor: 'pointer',
        //         },
        //       },
        //       '伊甸社會福利基金會-兒童線上篩檢',
        //     ),

        //     h(
        //       'span',
        //       {
        //         style: font({ color: '#FF000A' }),
        //       },
        //       '作為發展評估之參考',
        //     ),
        //   ]),
        // },
        // {
        //   type: 'normal',
        //   text: [
        //     '若超過警訊時程的時間，孩子仍然無法完成該能力時，建議立即到醫院尋求兒科醫師診斷及完整評估，若評估結果為發展遲緩，則會轉介至相關機構接受早期療育課程。',
        //   ],
        // },

        // {
        //   type: 'normal',
        //   text: '每個孩子發展都存有變異，正常時程為50%的兒童能達到其發展；警訊時程為90%的兒童能達到其發展。若超過警訊時程的時間，孩子仍然無法完成該能力時，建議立即到醫院尋求兒科醫師診斷及完整評估，若評估結果為發展遲緩，則會轉介至相關機構接受早期療育課程。',
        // },
      ],
    }),
  },

  {
    render: h('p', [
      h(
        'span',
        {
          style: font(),
        },
        '每個孩子發展都存有變異，正常時程為50%的兒童能達到其發展；警訊時程為90%的兒童能達到其發展，',
      ),
      h(
        'span',
        {
          style: font(),
        },
        '可利用',
      ),
      h(
        'a',
        {
          href: 'https://kids.eden.org.tw/?action=screening&year=1',
          target: '_blank',
          rel: 'noreferrer noopener',
          style: {
            ...font(),
            'text-decoration': 'underline',
            cursor: 'pointer',
          },
        },
        '伊甸社會福利基金會-兒童線上篩檢',
      ),

      h(
        'span',
        {
          style: font(),
        },
        '作為發展評估之參考',
      ),
    ]),
  },
  {
    type: 'normal',
    text: [
      '若超過警訊時程的時間，孩子仍然無法完成該能力時，建議立即到醫院尋求兒科醫師診斷及完整評估，若評估結果為發展遲緩，則會轉介至相關機構接受早期療育課程。',
    ],
  },
  {
    type: 'normal',
    text: [
      '兒童早期療育治療包含物理治療、職能治療、語言治療、心理治療，透過 0-6歲黃金期的復健療育課程，慢慢帶著孩子趕上發展。另外，各縣市也有提供「早療補助」、「交通費及療育費補助」，申請方式及準備資料，可以向評估醫院或是各縣市政府的負責單位諮詢，早期發現、早期治療，才有更高的機會改善問題。',
    ],
  },

  {
    render: h('p', [
      h(
        'span',
        {
          style: font(),
        },
        '衛生福利部社家署 早期療育相關資源 參考網址：',
      ),
      h(
        'a',
        {
          href: 'https://system.sfaa.gov.tw/cecm/resourceView/index',
          target: '_blank',
          rel: 'noreferrer noopener',
          style: {
            ...font(),
            'text-decoration': 'underline',
            cursor: 'pointer',
          },
        },
        'https://system.sfaa.gov.tw/cecm/resourceView/index',
      ),

    ]),
  },

  // {
  //   type: 'normal',
  //   text: '兒童早期療育治療包含物理治療、職能治療、語言治療、心理治療，透過 0-6歲黃金期的復健療育課程，慢慢帶著孩子趕上發展。另外，各縣市也有提供「早療補助」，每三個月申辦一次，包含「交通費及療育費補助」，申請方式及準備資料，可以向評估醫院或是各縣市政府的負責單位諮詢，早期發現、早期治療，才有更高的機會改善問題。',
  // },
  // {
  //   render: h(SimpleTable, {
  //     content: babyGrowContent,
  //     style: {
  //       marginTop: '20px',
  //       marginBottom: '20px',
  //     },
  //   }),
  // },
];

// 腦室出血
export const intracerebralHemorrhageWording = [
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '早期側腦室的腹側含有許多不成熟血管',
        },
        {
          id: uuid(),
          t: '因生產窒息、急救、氣胸及種種處置所產生的血壓或缺氧變化導致血管破裂',
        },
        {
          id: uuid(),
          t: '造成不同程度的周腦室及腦室內出血',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'heart',
      wording: [
        {
          type: 'normal',
          text: [
            '常見於出生週數 < 32週 或 出生體重 < 1500公克的早產兒。',
            '早產兒出生後2-7天內可能會發生腦室出血，但20-50%的沒有症狀。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'heart',
  //   }),
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '常見於出生週數 < 32週 或 出生體重 < 1500公克的早產兒。',
  //     '早產兒出生後2-7天內可能會發生腦室出血，但20-50%的沒有症狀。',
  //   ],
  // },

  {
    render: h(SimpleTable, {
      content: intracerebralHemorrhageSymdronesContent,
    }),
    style: {
      marginTop: '50px',
    },
  },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '典型症狀',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.原本穩定生理現象卻突然變差',
  //     '2.出現呼吸暫停',
  //     '3.運動異常、角弓反張',
  //     '4.抽搐',
  //     '5.前囟門緊且膨出',
  //     '6.血球容積下降、血壓降低和酸血症',
  //   ],
  // },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'atypical-symptoms',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '非典型症狀',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.意識程度變差',
  //     '2.木僵和焦躁不安',
  //     '3.呼吸不規則',
  //     '4.體溫不穩',
  //     '5.自發動作減少、肌肉張力降低或增加等',
  //     '以上表現可時好時壞，持續幾天，也可能惡化變成水腦。',
  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'degree-impact',
      wording: [
        {
          type: 'important',
          text: '程度分級與影響',
        },
        {
          type: 'normal',
          text: [
            '輕度：一、二級：出血會逐漸被吸收，對孩子影響較輕。',
            '中度：三級：其發育及神經發展均正常的機會有50%以上。',
            '重度：四級：有可能導致水腦及日後神經發展異常。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'degree-impact',
  //   }),
  // },

  // {
  //   type: 'important',
  //   text: '程度分級與影響',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '輕度：一、二級：出血會逐漸被吸收，對孩子影響較輕。',
  //     '中度：三級：其發育及神經發展均正常的機會有50%以上。',
  //     '重度：四級：有可能導致水腦及日後神經發展異常。',
  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'ultrasound-examination',
      wording: [
        {
          type: 'important',
          text: '超音波檢查',
        },
        {
          type: 'normal',
          text: [
            '常見腦部超音波檢查結果',
            '1.有亮點、很小的水泡，許多正常的孩子也會出現，再追蹤亮點變化即可。',
            '2.腦部太亮、有出血情形，先以支持性治療並密切追蹤血塊吸收狀況。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'ultrasound-examination',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '超音波檢查',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '常見腦部超音波檢查結果',
  //     '1.有亮點、很小的水泡，許多正常的孩子也會出現，再追蹤亮點變化即可。',
  //     '2.腦部太亮、有出血情形，先以支持性治療並密切追蹤血塊吸收狀況。',

  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '一般性治療：如發展性照護、維持體溫、給予氧氣矯正發紺，或給予抗抽搐藥物控制。',
            '追蹤超音波檢查：測量腦部血流情形，維持腦部血流灌注，避免休克。',
            '治療因腦壓出血後所造成的水腦：',
            '1.藥物 2.腦室造口引流術 3.腰椎穿刺',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '治療',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '一般性治療：如發展性照護、維持體溫、給予氧氣矯正發紺，或給予抗抽搐藥物控制。',
  //     '追蹤超音波檢查：測量腦部血流情形，維持腦部血流灌注，避免休克。',
  //     '治療因腦壓出血後所造成的水腦：',
  //     '1.藥物 2.腦室造口引流術 3.腰椎穿刺',

  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'words-for-mom-and-dad',
      wording: [
        {
          type: 'important',
          text: '給爸爸媽媽的話',
        },
        {
          type: 'normal',
          text: [
            '早產兒出生後，腦部還在發育中，具有極大彈性，超音波結果雖然有相當程度決定未來的發展。但如果其他生理情況穩定，沒有嚴重的呼吸合併症或異常症狀，那麼代表有可能克服腦室內出血。',
            '爸爸媽媽要練習讓自己減少擔憂與緊張，也不要洩氣，切記避免將焦點放在每一次的檢查報告。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'words-for-mom-and-dad',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '給爸爸媽媽的話',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '早產兒出生後，腦部還在發育中，具有極大彈性，超音波結果雖然有相當程度決定未來的發展。但如果其他生理情況穩定，沒有嚴重的呼吸合併症或異常症狀，那麼代表有可能克服腦室內出血。',
  //     '爸爸媽媽要練習讓自己減少擔憂與緊張，也不要洩氣，切記避免將焦點放在每一次的檢查報告。',
  //   ],
  // },
];

// 周腦室白質軟化症
export const periventricularLeukomalaciaWording = [
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '早產兒腦部組織尚未完全成熟',
        },
        {
          id: uuid(),
          t: '因窒息、缺氧、低血壓、腦室出血、敗血症等腦部血流量不足因素',
        },
        {
          id: uuid(),
          t: '造成圍繞在腦室旁白質的動脈血流梗塞',
        },
        {
          id: uuid(),
          t: '凝固性壞死',
        },
        {
          id: uuid(),
          t: '二到六週會變成小囊泡狀空洞，融合形成鈣化或疤痕',
        },
        {
          id: uuid(),
          t: '出現於靠近側腦室的白色物質(掌管下肢的神經傳導路徑)',
        },
        {
          id: uuid(),
          t: '周腦室白質軟化',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'heart',
      wording: [
        {
          type: 'normal',
          text: '常見於週數小、出生體重輕 的早產兒。',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'heart',
  //   }),
  // },
  // {
  //   type: 'normal',
  //   text: '常見於週數小、出生體重輕 的早產兒。',
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: ['初期：可能毫無症狀或是出現低血壓、缺氧等臨床症狀，較不容易察覺。', '(當孩子年齡較大時)'],
        },
        {
          render: textInRow([
            {
              t: '輕微：通常有',
            },
            {
              t: '肌肉張力不足',
              style: {
                fontWeight: '700',
                textDecoration: 'underline',
              },
            },
            {
              t: '及',
            },
            {
              t: '下肢發展動作遲緩',
              style: {
                fontWeight: '700',
                textDecoration: 'underline',
              },
            },
            {
              t: '問題；講話、智力發育都很正常，因此上學與同儕互動都沒有影響。',
            },
          ]),
        },
        {
          render: textInRow([
            {
              t: '嚴重：可能造成',
            },
            {
              t: '肢體兩側痙攣性麻痺',
              style: {
                fontWeight: '700',
                textDecoration: 'underline',
              },
            },
            {
              t: '的後遺症，四肢僵硬，有時合併癲癇、智能障礙、聽覺障礙、語言障礙等情形。',
            },
          ]),
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'ultrasound-examination',
      wording: [
        {
          type: 'important',
          text: '超音波檢查',
        },
        {
          type: 'normal',
          text: [
            '腦部超音波診斷，最早可在出生十四天內被發現。',
            '備註：周腦室白質軟化症若較輕微，腦部超音波不一定能確診。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '若孩子為周腦室白質軟化症的高危險群，會定期安排腦部超音波檢查，以早期診斷疾病。',
            '無論疾病嚴重度，首要治療方向為復健，出院後到診所或居家復健都建議持續不間斷，長期不間斷的復健治療能有明顯療效。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '若孩子為周腦室白質軟化症的高危險群，會定期安排腦部超音波檢查，以早期診斷疾病。',
            '無論疾病嚴重度，首要治療方向為復健，出院後到診所或居家復健都建議持續不間斷，長期不間斷的復健治療能有明顯療效。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'words-for-mom-and-dad',
      wording: [
        {
          type: 'important',
          text: '給爸爸媽媽的話',
        },
        {
          type: 'normal',
          text: [
            '此疾病在神經發育上的預後差，有運動障礙的危險性高達75-100%，少數也會有認知障礙。會造成運動障礙如腦性麻痺、視覺聽覺障礙和痙攣抽搐、兩側性障礙等後遺症。',
            '提醒爸爸媽媽多觀察孩子各階段的生長發展，若3-4個月還不太會抬頭，下肢張力逐漸變大且很僵硬，甚至雙腳會交叉像剪刀腳一樣，就有周腦室白質軟化症的可能，及早帶小朋友尋求小兒神經科醫師的協助，利用超音波、核磁共振等影像檢查工具以早期診斷。',
          ],
        },
      ],
    }),
  },
];

// 腦性麻痺
export const cerebralPalsyWording = [
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '可能與孕期母體感染、嬰兒先天腦部發育不良、生產過程中難產、早產、缺氧窒息，或是出生後腦室出血、腦膜炎等因素有關',
        },
        {
          id: uuid(),
          t: '造成中樞神經系統的未成熟組織受到損傷，導致「非進行性」的運動障礙(腦傷)。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'degree-impact',
      wording: [
        {
          type: 'important',
          text: '腦部損傷程度及預後',
        },
        {
          type: 'normal',
          text: [
            '輕度：症狀輕微，可獨立完成日常生活的活動及照顧自己，不需輔助工具可自己步行。',
            '中度：症狀較重，需配合輔助工具才能步行或完成日常活動。',
            '重度：有嚴重運動機能障礙，通常合併語言、智力等問題、治療困難、進步緩慢，無法自己獨立生活，必須終生被照顧。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },

        {
          render: h(SimpleTable, {
            content: cerebralPalsyContent,
            style: {
              marginTop: '20px',
              marginBottom: '20px',
            },
          }),
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            // '腦部細胞數目於出生後，絕大部分不再增生，但人類的腦細胞彼此互相連結運作，因此輕度和中度的腦性麻痺，只要及早發現並給予適當的復健職能治療，日常獨立生活的機率相當高',
            '復健治療：',
            '1.進行病因探討，做動作機能、視力與聽力、精神心理及性向評估、語言能力的測定，以瞭解神經異常所在及缺陷。',
            '2.復健。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'words-for-mom-and-dad',
      wording: [
        {
          type: 'important',
          text: '給爸爸媽媽的話',
        },
        {
          type: 'normal',
          text: [
            '出生後的腦細胞數目絕大部分不再增生，若是受到損傷，恢復完全正常的可能性低，但在早期腦細胞的發育有相當大的可塑性，人類腦細胞彼此互相連結運作，若是輕或中度的腦性麻痺，只要及早發現並給予適當的復健職能治療，日常獨立生活的機率相當高。因此爸爸媽媽協助孩子接受治療的態度與對疾病的認知也是復健成功非常重要的因素哦！',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'words-for-mom-and-dad',
  //   }),
  // },
];

// 開放性動脈導管
export const openDuctusArteriosusWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: '開放性動脈導管是一條正常存在的組織結構，靠近於心臟與肺臟的血管，原本應在新生兒出生後數天自動關閉消失，卻仍存在著，使肺臟負擔過多的血液。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'checking',
      wording: [
        {
          type: 'important',
          text: '檢查',
        },
        {
          type: 'normal',
          text: [
            '(1)聽診：連續性心雜音。',
            '(2)心臟超音波檢查：檢查開放性動脈導管的大小、血流的方向，以及相鄰主動脈和肺動脈的構造。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'checking',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: [
            '開放性動脈導管會因其大小而有不同的臨床表現：',
            '1.可能沒有症狀。',
            '2.可能出現呼吸變得困難、呼吸喘，心跳變快、聽診有心雜音、低血壓，餵食困難、長不大，活動力差等症狀。',
            '3.嚴重會引起肺水腫、慢性肺病、充血性心臟衰竭、壞死性腸炎及腎衰竭等情形。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '1.尚無症狀時採觀察療法。',
            '2.開始有症狀時則使用內科療法：如限水或給予利尿劑、矯正貧血及藥物。',
            '3.心導管治療。',
            '4.手術治療：為小兒心臟外科常見手術之一。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'supplementary-knowledge',
      wording: [
        {
          type: 'important',
          text: '補充小知識',
        },
        {
          render: h(SimpleTable, {
            content: openDuctusArteriosusTreatContent,
          }),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'supplementary-knowledge',
  //   }),
  // },

  // {
  //   type: 'normal-bold',
  //   text: '藥物治療',
  // },
  // {
  //   type: 'normal',
  //   text: '臨床上在給予藥物來關閉動脈導管前，需先確認有無出血傾向或腎功能狀況方可使用，通常給予Indomethacin、ibuprofen、ACT治療，目前藥物有口服及針劑劑型兩種(自費)。',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '心導管治療',
  // },
  // {
  //   type: 'normal',
  //   text: '心導管治療：在X光機的放射線導引下，從鼠蹊部的血管(股動脈或是股靜脈)，將封阻器放置到開放性動脈導管中完成關閉的效果。但因其器材與嬰幼兒血管大小的限制，會視體重足夠時再執行，雖曾有1000公克以下的早產兒接受心導管治療，但仍缺乏長期追蹤報告，目前美國建議接受此治療方式的新生兒體重為2500公克以上。',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '手術治療',
  // },
  // {
  //   type: 'normal',
  //   text: '手術方法由左後側開胸一個5公分左右的切口，進行動脈導管綁紮手術，以達斷絕其血流的效果。手術傷口面積較心導管術大，會留下疤痕。但發生合併症機率較低，可能有傷口感染、喉返神經麻痺（recurrent laryngeal nerve palsy）或是乳糜胸情形。在還沒有足夠的臨床證據證實心導管的長期效果之前，外科手術治療仍會是首選。',
  // },
];

// 呼吸暫停
export const apneaWording = [
  // {
  //   type: 'normal',
  //   text: [
  //     '早產兒因早產(腦部呼吸中樞的機能未成熟)、心臟相關問題、腦損傷或含氧量不足、體溫過高或過低、癲癇(痙攣)、感染、低血糖等所造成',
  //     '規律地呼吸和呼吸暫停交替發生（間歇性呼吸），且呼吸暫停時間超過15-20秒',
  //     '呼吸暫停',
  //   ],
  // },
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '早產兒因早產(腦部呼吸中樞的機能未成熟)、心臟相關問題、腦損傷或含氧量不足、體溫過高或過低、癲癇(痙攣)、感染、低血糖等所造成',
        },
        {
          id: uuid(),
          t: '規律地呼吸和呼吸暫停交替發生（間歇性呼吸），且呼吸暫停時間超過15-20秒',
        },
        {
          id: uuid(),
          t: '呼吸暫停',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'important',
          text: '常見於',
        },
        {
          type: 'normal',
          text: '出生週數較小的早產兒在住院期間(常見於剛出生第一週)，在睡眠中(尤其快速動眼期)容易出現呼吸暫時症狀。',
          style: {
            marginTop: '10px',
          },
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: [
            '1.膚色、唇色會呈現微紫藍色或蒼白色。',
            '2.有時會合併心跳過慢現象。',
            '3.生理監視器會出現心跳及血氧下降等警示訊號。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '1.出現的次數少、症狀較輕微：採觀察即可，一般住院期間可藉由趴睡(配合生理監視器下才可執行)改善。發生呼吸暫停時可以給予適當刺激，或是提供氧氣及甦醒球按壓等叫醒孩子。',
            '2.出現次數頻繁：可以給予刺激呼吸的茶鹼藥物(如Aminophylline、Theophylline、Caffeine)。',
            '3.給予呼吸治療，在鼻子裝上一種有兩根短管的裝置(豬鼻子)，供給氧氣或空氣，使呼吸道維持正壓，經由呼吸反射作用以調解呼吸。',
            '4.採取上述方法仍出現嚴重呼吸暫停，且導致心跳下降、缺氧的呼吸暫停等現象，則需插管及呼吸器輔助呼吸。',
            '若出現3、4情形，醫生則會進一步做身體檢查及相關檢驗，確認是否因貧血或顱內出血、血糖過低、電解質不平衡、敗血症等原因而引起的呼吸暫停。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'supplementary-knowledge',
      wording: [
        {
          type: 'important',
          text: '知識小補充',
        },
        {
          type: 'normal',
          text: '上述治療用的茶鹼類藥物可代謝成咖啡因，而咖啡因對刺激呼吸器官的作用上非常有效，經過醫師計算準確劑量及評估，並做好觀察及評估，在症狀改善後即停藥，無須太擔心是否過量或是對身體有不好的影響。',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'supplementary-knowledge',
  //   }),
  // },
];

// 呼吸窘迫症候群
export const respiratoryDistressSyndromeWording = [
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '早產兒提早出生，肺臟尚未成熟',
        },
        {
          id: uuid(),
          t: '肺泡內的表面張力素(surfactant)不足，造成肺泡容易塌陷',
        },
        {
          id: uuid(),
          t: '使得身體內的二氧化碳不易排出，空氣中的氧氣不易進入血管',
        },
        {
          id: uuid(),
          t: '產生呼吸窘迫現象',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'important',
          text: '常見於',
        },
        {
          type: 'normal',
          text: ['出生週數小於32週或出生體重不足1500公克的早產兒。'],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'diagnosis',
      wording: [
        {
          type: 'important',
          text: '診斷方式',
        },
        {
          type: 'normal',
          text: [
            '依照病史、血液檢查及X光檢查等來做判斷，而X光表現為毛玻璃狀模糊的肺，嚴重的可能會在X光顯示出整個胸腔全部「泛白」。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'diagnosis',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: ['呼吸急促、胸骨肋間凹陷、鼻翼搧動或唇指發紺及出現呻吟聲等呼吸費力情形。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '1.持續監測及維護生命徵象',
            '2.提供水分、電解質及營養、常規血液監測',
            '3.胸部物理治療',
            '4.集中照護、減少不必要刺激',
            '5.必要時使用呼吸器治療並給予表面張力素藥物治療',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },
];

// 慢性肺疾病
export const chronicLungDiseaseWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'important',
          text: '慢性肺疾病(早產兒肺部疾病的廣泛通稱)',
        },
        {
          type: 'normal',
          text: [
            '1.肺支氣管發育不全症(常見)。',
            '2.早產兒慢性肺功能不足。',
            '3.肺泡纖維化。',
            '4.急性或慢性肺部感染。',
            '5.威爾森-米開第症候群。',
          ],
        },
      ],
    }),
  },

  // {
  //   type: 'normal',
  //   text: [
  //     '當早產兒出生時因肺部疾病需氧氣輔助，但數週後仍需仰賴氧氣及呼吸器無法脫離，再配合X光出現變化即可定義為慢性肺疾病。此為廣泛描述早產兒肺部疾病的通稱。',
  //     '凡肺支氣管發育不全症、早產兒慢性肺功能不足、肺泡纖維化、急性或慢性肺部感染及威爾森-米開第症候群等皆屬於慢性肺疾病；其中，肺支氣管發育不全症佔慢性肺疾病中的最大部分。',
  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'diagnosis',
      wording: [
        {
          type: 'important',
          text: '診斷方式',
        },
        {
          type: 'normal',
          text: ['1.使用氧氣及呼吸器治療的日數。', '2.定期或視情況追蹤X光檢查為主。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'diagnosis',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: ['脫離氧氣或呼吸器時會出現呼吸偏快、呼吸困難、費力，易喘。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          render: h(SimpleTable, {
            content: chronicLungDiseaseTreatContent,
          }),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  // {
  //   type: 'normal-bold',
  //   text: '肺部',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.呼吸道支持：維持良好心肺循環，觀察及監測呼吸狀態、膚色及血氧變化等',
  //     '2.提供胸腔物理治療：醫護人員應定時檢查與必要時立即予呼吸道抽吸',
  //     '3.使用呼吸器或氧氣支持，維持良好的血氧，避免缺氧狀況發生。',
  //     '4.適時訓練脫離呼吸器：固定監測血液中氣體、氧氣量以及觀察早產兒的呼吸型態調整機器設定，維持情況的穩定才能有效脫離呼吸器。',
  //   ],
  // },
  // {
  //   type: 'normal-bold',
  //   text: '腸胃',
  // },
  // {
  //   type: 'normal',
  //   text: '避免胃食道逆流，可以降低肺部發炎的發生',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '輸液及營養',
  // },
  // {
  //   type: 'normal',
  //   text: '可能因疾病造成肺部積水干擾呼吸，故可以減少營養針的水份攝取或是藉由提供母乳或配方奶做調整。',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '藥物',
  // },
  // {
  //   type: 'normal',
  //   text: '支氣管擴張劑、類固醇、利尿劑。',
  // },
];

// 眼睛發育
// export const eyesDevelopWoridng = [

//   {
//     type: 'normal',
//     text: '正常血管會供應氧氣及養分給視網膜，在受孕後第四個月這些血管由視神經開始向外呈放射狀的成長，約在第八個月時可長到鼻側的末端，而距離較遠的顳側視膜血管在第十個月(足月產)時發育完成。',
//   },
//   {
//     type: 'important',
//     text: '眼睛',
//   },
//   {
//     type: 'normal',
//     text: [
//       '眼睛前段的角膜及水晶體：對焦',
//       '曈孔：調節適度的光量',
//       '視網膜：負責感光、接收影像。',

//     ],
//   },
// ];

// 視網膜病變
export const retinopathyWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'important',
          text: '眼睛發育',
        },
        {
          type: 'normal',
          text: '正常血管會供應氧氣及養分給視網膜，在受孕後第四個月這些血管由視神經開始向外呈放射狀的成長，約在第八個月時可長到鼻側的末端，而距離較遠的顳側視膜血管在第十個月(足月產)時發育完成。',
        },
        {
          type: 'important',
          text: '眼睛功能',
        },
        {
          type: 'normal',
          text: ['眼睛前段的角膜及水晶體：對焦', '曈孔：調節適度的光量', '視網膜：負責感光、接收影像。'],
        },
        {
          type: 'important',
          text: '視網膜病變',
        },
        {
          render: h(Processing, {
            content: [
              {
                id: uuid(),
                t: '早產兒出生時正值視網膜血管發展階段，因各器官尚未成熟，易出現低血氧及低血壓等問題，需使用氧氣及呼吸器改善，',
              },
              {
                id: uuid(),
                t: '當未成熟的視網膜接觸到較高濃度氧氣，可能使視網膜血管停止生長',
              },
              {
                id: uuid(),
                t: '導致血管異常增生及產生纖維化病變',
              },
            ],
          }),
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'retina-examination',
      wording: [
        {
          type: 'important',
          text: '檢查對象',
        },
        {
          type: 'normal',
          text: [
            '1.出生體重小於1500公克或出生週數小於32週的早產兒都需要接受檢查。',
            '2.出生週數介於32週至36週合併有出生體重低於2500克或子宮內生長遲滯或病程不順利或曾接受氧氣治療之早產兒，醫師會視需要進行檢查。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'retina-examination',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'retina-fundus-examination',
      wording: [
        {
          type: 'important',
          text: '眼底檢查時間',
        },
        {
          type: 'normal',
          text: [
            '1.出生週數小於28週早產兒，於矯正週數滿31週時進行眼底檢查。',
            '2.出生週數滿28週早產兒，於出生後四週時進行眼底檢查。',
            '3.眼科醫師會評估結果決定下次追蹤時間，直到確認視網膜血管發展完全為止。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'retina-fundus-examination',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'level-group',
      wording: [
        {
          type: 'important',
          text: '程度分級',
        },
        {
          type: 'normal',
          text: [
            '依結果分為五期，大多數出現視網膜病變的早產兒多為第一、二期輕度變化，且大多會自行消退。',
            '1.第一期：在有血管發育的視網膜與無血管的視網膜間，有一白色平坦的分界。',
            '2.第二期：第一期所說的分界線隆起，可看出高度及寬度。',
            '3.第三期：異常的血管往玻璃體增生，如果同時合併有視網膜後極部的血管擴張扭曲(plus disease；加重期疾病)，那麼進一步惡化到纖錐化增殖引起視膜剝離的可能性可能高達一半。',
            '4.第四期及第五期：第四期部分視網膜剝離及第五期完全視網膜剝離。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'level-group',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          render: h(SimpleTable, {
            content: retinopathyContent,
          }),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'senses-vision',
  //   }),
  // },
  // {
  //   type: 'normal-bold',
  //   text: '雷射或冷凍治療',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.介入時機：第三期視網膜病變(或合併有後極部血管擴張及扭曲(加重期)時)。',
  //     '2.作用原理：消減不正常的血管組織，以減少不正常的新生血管增生，維護視網膜後極部所負責的中心、清晰的視力。',
  //     '3.副作用：出現疼痛、呼吸或心跳減緩之症狀。',
  //     '4.合併症：可能會破壞週邊視網膜，造成日後視野較狹窄。',
  //   ],
  // },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'vaccination-importance',
  //   }),
  // },
  // {
  //   type: 'normal-bold',
  //   text: '抗血管內皮生長因子治療',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '研究顯示患有早產兒視網膜病變的眼裡有高濃度的血管內皮生長因子，若阻斷此因子，視網膜缺氧的逐漸現象改善，視網膜上的新生血管緩慢消失。',
  //     '1.方法：在玻璃體注射抗血管內皮生長因子以減少異常新生血管；過程相較雷射或冷凍治療簡單。',
  //     '2.優點：對視網膜傷害更小。',
  //     '3.目前趨勢：',

  //   ],
  // },
  // {
  //   type: 'normal-indent',
  //   text: [
  //     '(1)多數臨床研究報告顯示療效良好',
  //     '(2)未發現嚴重的短期副作用',
  //     '(3)未得知對於新生兒全身性的安全性影響，待研究',
  //   ],
  //   style: {
  //     marginTop: 0,
  //   },
  // },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'surgery',
  //   }),
  // },
  // {
  //   type: 'normal-bold',
  //   text: '手術治療',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.介入時機：當早產兒出現第四或第五期並有視網膜剝離。',
  //     '2.種類：分為鞏膜扣壓術或玻璃體切除術。',
  //     '3.預後：眼科醫師會視情況選擇合適手術做治療，但視力恢復的效果有限。',
  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'affect',
      wording: [
        {
          type: 'important',
          text: '影響',
        },
        {
          type: 'normal',
          text: [
            '早產兒罹患視網膜病變通常會同時影響到兩眼，嚴重可能會',
            '1.雙眼無光覺、無法辨別顏色及接受影像的視覺能力弱。',
            '2.對聲音語言的意義化，會有不同程度的影響。',
            '3.合併造成認知發展遲滯。',
            '4.晚期症狀：視力減弱、近視、散光，容易鬥雞眼或弱視，光反射減弱、斜視及白內障。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'affect',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'words-for-mom-and-dad',
      wording: [
        {
          type: 'important',
          text: '給爸爸媽媽的話',
        },
        {
          type: 'normal',
          text: [
            '隨著早產兒照護品質的進步，臨床上對早產兒使用氧氣或呼吸器治療的觀念改變，再透過眼科醫師定期的眼底檢查，及時發現第三期需治療的早產兒，以降低進展到第四或第五期的機會，嚴重的視網膜病變或失明已極少發生，大多數的早產兒即使有視網膜病變，通常程度輕微且會自然消退。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'words-for-mom-and-dad',
  //   }),
  // },
];

// 胃食道逆流
export const gastroesophagealRefluxWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: '新生兒胃賁門與食道下的括約肌鬆弛無力，且腸道蠕動方式未成熟，無法有效將食物往下送、胃排空時間延長，引起胃酸、消化液甚至膽汁逆流到食道。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'heart',
      wording: [
        {
          type: 'normal',
          text: '常見於早產新生兒出生後的前四個月，六個月後賁門括約肌較成熟會逐漸改善。',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'heart',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'diagnosis',
      wording: [
        {
          type: 'important',
          text: '診斷方式',
        },
        {
          type: 'normal',
          text: [
            '1.24小時胃食道逆流監測：將攜帶式胃食道逆流監測器之導管，由鼻部放入食道中，經X光確認位置正確後，執行24小時監測餵食前後食道內酸鹼值變化。監測過程仍可正常餵食，檢查結束後，經監測器紀錄分析診斷逆流嚴重度。',
            '2.上腸胃道攝影術。',
            '3.上腸胃道內視鏡檢查。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: [
            '1.餵食時可能會口唇發紺。',
            '2.餵食後數分鐘至數小時發生溢吐奶(胃內逆流上來的胃酸刺激神經)',
            '3.可能會引發呼吸暫停、心跳變慢、血氧下降、食慾差、反覆咳嗽、拱背或哭鬧躁動不安等。',
            '4.長期可能會有食道發炎、吸入性肺炎、貧血、食道出血、營養不良、體重不增或下降及生長遲緩等現象。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '1.輕度症狀觀察生長發育狀況。',
            '2.餵食採少量多餐並加強拍嗝排氣。依體重調整奶量避免過度餵食。',
            '3.餵食後採直立姿勢抱20-30分鐘或床頭墊高、側臥，或在配合生理監視器下採趴睡姿勢。',
            '4.有出現嘔吐、溢奶情形須記錄次數、量及顏色。若嘔吐物呈咖啡色、黃綠色、鮮紅色液體時須立即就醫。',
            '5.中重度症狀者依醫師指示服藥治療：口服促進消排空藥物(Domperidone、Primperan等等)、中和胃酸藥物來減緩症狀。',
            '6.手術治療：若胃食道逆流已嚴重影響營養攝取並造成生長遲緩時，可考慮胃底摺疊手術。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'supplementary-knowledge',
      wording: [
        {
          type: 'important',
          text: '補充小知識',
        },
        {
          type: 'normal',
          text: [
            '胃底摺疊手術：將賁門附近的胃組織─胃底，輕巧的包覆在食道周圍，用縫線加以固定。',
            '藉由改變胃的解剖結構，使得賁門附近空間較為窄縮，容納胃酸的空間變小、逆流遭遇的阻力增大來緩解症狀。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'supplementary-knowledge',
  //   }),
  // },
];

// 壞死性腸炎
export const necrotizingenteritisWording = [
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '因缺氧、缺血因素※',
        },
        {
          id: uuid(),
          t: '使腸道細胞組織損傷 或 未消化餘奶在腸道中滯留',
        },
        {
          id: uuid(),
          t: '腸道感染',
          e: '※缺氧、缺血的原因例如懷孕早期破水、前置胎盤、敗血症或新生兒呼吸窘迫、先天性心臟病、使用臍管、體溫不穩、換血等。',
        },
      ],
    }),
  },
  // {
  //   type: 'normal',
  //   text: [
  //     '詳細機轉尚未完全清楚，可能是因缺氧或血流變化而導致腸道細胞組織損傷，或未消化餘奶在腸道中滯留造成的腸道感染。早產兒出生的週數越小或體重越輕，受到壞死性腸炎威脅的時間就越長，死亡率高達10-30%，為早產兒最嚴重的胃腸道急症。',
  //     '造成缺血/缺氧或感染的原因如懷孕早期破水、前置胎盤、產褥敗血症、新生兒呼吸窘迫症、體溫不穩、換血、使用臍管以及先天性心臟病等誘發因素感染到腸道。',
  //   ],
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'important',
          text: '常見於',
        },
        {
          type: 'normal',
          text: '早產兒出生的週數越小或體重越輕，受到壞死性腸炎威脅的時間就越長，死亡率高達10-30%，為早產兒最嚴重的胃腸道急症。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'diagnosis',
      wording: [
        {
          type: 'important',
          text: '診斷方式',
        },
        {
          type: 'normal',
          text: ['X光腸氣擴張，腸壁間有空氣。若在肝臟門脈處見空氣，其預後較差。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'diagnosis',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: [
            '發作常是爆發性的，且病情惡化極快。',
            '1.生命徵象異常：體溫不穩、心跳變慢、呼吸暫停。',
            '2.出現餵食不佳症狀，如餘奶增加、腹脹、腹部外觀亮及呈青色或黑色、嘔吐可能含有膽汁、血便',
            '3.嗜睡或活動力明顯減弱。',
            '4.嚴重甚至到腸穿孔、腹膜炎、休克等，並伴隨敗血症的症狀。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'checking',
      wording: [
        {
          type: 'important',
          text: '檢查',
        },
        {
          type: 'normal',
          text: ['急性期應每6小時照一張X光，以早期避免有腸穿孔發生。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'checking',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '1.使用鼻胃管引流腹腔內空氣、減少腹脹。',
            '2.禁食，並給予全靜脈營養。',
            '3.作細菌培養並給予抗生素，通常治療10-14天。',
            '4.視呼吸情況予呼吸器支持。',
            '5.手術治療：持續惡化或無進展時則需開刀切除壞死的腸子。後續需追蹤檢查生育發展情形。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'supplementary-knowledge',
      wording: [
        {
          type: 'important',
          text: '補充小知識',
        },
        {
          type: 'normal',
          text: ['多數研究顯示母乳的免疫抗體可使哺餵母乳的寶寶較少發生壞死性腸炎，一般早產兒餵食可考慮以母乳為首選。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'supplementary-knowledge',
  //   }),
  // },
];

// 感染
export const infectionWording = [
  {
    render: h(Processing, {
      content: [
        {
          id: uuid(),
          t: '提早出生的早產兒其補體量及功能不足、吞噬細胞吞噬及殺菌的能力有限',
          a: '(造成抵抗力不足)',
        },
        {
          id: uuid(),
          t: '出生後必須住加護病房，使用呼吸器及各種醫療處置如放置導管、全靜脈營養等',
          a: '(增加感染的來源)',
        },
        {
          id: uuid(),
          t: '容易使細菌侵犯到身體各器官，引起敗血症、腦膜炎、肺炎、關節炎、骨髓炎。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'typical-symptoms',
      wording: [
        {
          type: 'important',
          text: '症狀',
        },
        {
          type: 'normal',
          text: [
            '1.生命徵象異常：呼吸暫停、體溫不穩。',
            '2.腹脹、活動力差、不正常黃疸或休克現象。',
            '3.嚴重者會併發腦膜炎、水腦、聽力障礙，甚至導致死亡等。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'typical-symptoms',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'important',
          text: '治療',
        },
        {
          type: 'normal',
          text: [
            '一旦懷疑早產兒有細菌感染時，',
            '1.視症狀立即作各種細菌培養檢體，如血液、脊髓液、尿液等。',
            '2.馬上予抗生素治療，治療時間則視感染情形及菌種種類而有不同，一般需二至三週，腦膜炎及骨髓炎則需更長時間。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },
];

// 黃疸
export const jaundiceWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: 'jaundice-breastfeeding',
      wording: [
        {
          type: 'important',
          text: '母乳性黃疸',
        },
        {
          type: 'normal',
          text: [
            '哺餵母乳的寶寶，其生理性黃疸期較長，因哺餵初期喝的母乳量還不足且正值生理性脫水時期，身體正在做腸肝循環，黃疸指數容易竄升，此時照常規追蹤黃疸指數外，建議依照寶寶的餵食情況適當加奶，加速排泄情形，以助黃疸消退。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'jaundice-breastfeeding',
  //     mt: false,
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'jaundice-physiological',
      wording: [
        {
          type: 'important',
          text: '生理性黃疸',
        },
        {
          type: 'normal',
          text: [
            '新生兒因為紅血球的新陳代謝快，而肝臟代謝膽紅素功能較弱，在膽紅素生產速度快、排出速度慢的情況下堆積起來形成黃疸。',
            '通常在出生後第2-3天開始出現，會先觀察到膚色、眼白偏黃等表現。',
          ],
        },
        {
          type: 'normal-bold',
          text: '如何分辨是否有黃疸?',
        },
        {
          type: 'normal',
          text: [
            '1.將寶寶放在自然光線充足的地方，並觀察全身膚色，一般會從頭開始黃，腳開始退。眼白最早開始黃，但最晚消退。用大拇指輕壓寶寶的皮膚、再放開，可用手掌背及腳掌和臉部做對比或是否有呈現黃色。',
            '2.同時也注意寶寶是否吸吮力變弱、不願喝奶或有嘔吐、特別愛睡、活動力較軟弱等，也需留意排泄情形如更換尿布次數或是尿量情形及是否為灰白色便等 (可參考健兒手冊-大便辨識卡)。',
            '3.較嚴重會出現哭鬧難安撫、哭聲尖銳、四肢僵硬、發燒或抽筋等情形。',
          ],
        },
        {
          type: 'normal-bold',
          text: '臨床作法',
        },
        {
          type: 'normal',
          text: [
            '1.觀察全身膚色和眼白及排泄情形。',
            '2.若能進食則開始餵食母乳或配方奶加速排黃疸。',
            '3.依醫囑追蹤「黃疸指數」通常在出生第2-4天開始上升。',
            '4.依照黃疸指數標準需要時執行照光治療，照光治療需協助寶寶遮眼及生殖器做保護，並觀察皮膚是否過乾、有脫水症狀。',
            '5.嚴重黃疸需換血治療。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'jaundice-physiological',
  //   }),
  // },
];

// 生理性脫水
export const physiologicalDehydrationWording = [
  {
    type: 'normal',
    text: '早產新生兒在出生後的頭幾天會有一段利尿期，所以會出現體重下降的情形，出生後的3-5天內可以觀察到體重比出生體重減少約5-10%，這樣正常的生理變化稱為生理性脫水，約莫兩個星期會逐漸回復到原來的出生體重，無須特別擔憂。',
  },
];

// 聽力
export const hearingWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'important',
          text: '聽力篩檢',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'hearing-screening',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'premature-massage-prep',
      wording: [
        {
          type: 'normal-bold',
          text: '補助對象',
        },
        {
          type: 'normal',
          text: '自101年3月15日(含)以後出生，本國籍未滿3個月之新生兒',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'premature-massage-prep',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'hearing-screening',
      wording: [
        {
          type: 'normal-bold',
          text: '聽力檢查時機',
        },
        {
          type: 'normal',
          text: [
            '新生兒：在出生後24-60小時可於衛生福利部國民健康署合約之醫療院所做聽力初篩；若初篩未通過，應在出院前進行複篩或是滿月前做複篩。',
            '早產兒：出生時因腦部體溫中樞未成熟且體重輕，需使用保溫箱，無法於出生後立即接受聽力篩檢，須等到生命徵象穩定離開保溫箱後，由醫師安排評估。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'hearing-screening',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'diagnosis',
      wording: [
        {
          type: 'normal-bold',
          text: '檢查方式',
        },
        {
          type: 'normal',
          text: '自動型聽性腦幹反應(aABR)：將3個連接儀器的感應貼片，分別貼在寶寶的額頭、臉頰、後頸部上，戴上儀器的耳機或耳塞，經由耳機放出滴答聲音，再由感應貼片接收寶寶對聲音的腦波反應，約20-25分鐘即可完成，為非侵入性檢查不會造成疼痛。(篩檢工具可能依醫院有所不同)',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'diagnosis',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'affect',
      wording: [
        {
          type: 'normal-bold',
          text: '篩檢結果',
        },
        {
          type: 'normal',
          text: [
            '1.通過(Pass)：表示目前聽力與一般聽力正常者接近相同，但仍要留意會造成聽力受損的因素，如：中耳炎、外傷、腦膜炎、感染或遲發性遺傳性聽損等。持續觀察孩子在每個成長階段的聽語發展能力。若任何時刻懷疑有聽力問題時，可參考兒童健康手冊－新生兒聽力篩檢，做自我檢視，或至有耳鼻喉科之醫療院所重新評估。 ',
            '2.需追蹤(Refer)：可能原因有以下',
            '(1)先天性聽力損失的可能',
            '(2)在接受聽力篩檢時的條件不佳(哭鬧或環境噪音過大)',
            '(3)剛出生的幾天內，外耳道或中耳內有羊水、胎脂阻塞、發炎或還沒發展成熟等因素。',
            '結果需追蹤的孩子需在滿三個月時與確診醫院聯絡再複篩，才能排除或確定診斷有聽力損失。在看診前觀察孩子對周遭環境聲音的反應，於看診時提供主觀的觀察訊息。',
          ],
        },
        {
          type: 'important',
          text: '高危險群',
        },
        {
          type: 'normal',
          text: '出生體重小於1500公克的極低體重早產兒。',
        },
        {
          type: 'important',
          text: '原因',
        },
        {
          type: 'normal',
          text: '早產兒出生時有缺氧或受到病毒感染、腦膜炎、使用輔助呼吸器或耳毒性藥物、嚴重黃疸需要換血、身體器官或神經系統還尚未發育成熟等問題者，若合併兩項因素以上，則會增加聽力缺損的比率。',
        },
        {
          type: 'important',
          text: '建議',
        },
        {
          type: 'normal',
          text: [
            '1.以聲音刺激來觀察早產兒反應，但其聽力閾值較低，大人認為很大聲，早產兒可能覺得還好所以沒有反應，則不能代表聽不見。即使早產兒的聽力篩檢通過，也需持續觀察與追蹤。',
            '2.早期配戴輔具或者植入電子耳，能刺激尚未進行重組的大腦，會讓大腦對聽覺輸入的接收性更高，進而提升聽力能力。',
            '可參考以下連結了解更多。',
          ],
        },
        {
          render: h(
            'a',
            {
              href: 'https://www.slh.org.tw/upload/files/%E6%96%B0%E7%94%9F%E5%85%92%E8%81%BD%E7%AF%A9%E5%B0%8F%E5%B9%AB%E6%89%8B(%E7%B7%9A%E4%B8%8A%E7%89%88)(1090526%E4%BF%AE%E6%94%B9)%20.pdf',
              target: '_blank',
              rel: 'noreferrer noopener',
              style: {
                ...font(),
                'text-decoration': 'underline',
                cursor: 'pointer',
                marginTop: '20px',
              },
            },
            '備註：新生兒聽篩小幫手-台灣聽力語言學會提供',
          ),
        },
      ],
    }),
  },

  // {
  //   type: 'normal-bold',
  //   text: '重要性',
  // },
  // {
  //   type: 'normal',
  //   text: '研究顯示每1，000位新生兒中有1-2位患有先天性雙側中重度聽力損失，若透過新生兒聽力篩檢及早發現，並於六個月前接受治療，開始配戴聽覺輔具及接受聽能復健，則未來在語言、認知及溝通技巧等方面不會落後於一般孩子的發展。',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '檢查方式',
  // },
  // {
  //   type: 'normal',
  //   text: '自動型聽性腦幹反應(aABR)：將3個連接儀器的感應貼片，分別貼在寶寶的額頭、臉頰、後頸部上，並讓寶寶戴上儀器的耳機或耳塞，經由耳機放出滴答聲音，再由感應貼片接收寶寶對聲音的腦波反應，約20～25分鐘即可完成。為非侵入性檢查不會造成疼痛',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '篩檢結果',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.篩檢結果為通過(Pass)：表示目前聽力與一般聽力正常者接近相同，但並不代表終生沒有問題，仍要留意會造成聽力受損的因素，如：中耳炎、外傷、腦膜炎、感染或遲發性遺傳性聽損等。持續觀察孩子在每一個成長階段的聽語發展能力。若任何時刻懷疑有聽力問題時（可參考兒童健康手冊－新生兒聽力篩檢部分，先做自我檢視），都應該要到有耳鼻喉科之醫療院所重新評估。 ',
  //     '2.篩檢結果為需追蹤(Refer)：說明聽力需再追蹤的情況除了可能有先天性聽力損失之外，若孩子在接受聽力篩檢時的條件不佳（哭鬧或環境噪音過大），或是因為剛出生的幾天內，外耳道或中耳內有羊水、胎脂阻塞、發炎或還沒發展成熟等都可能造成需追蹤的結果。需在孩子滿三個月時與確診醫院聯絡再做一次複篩，才能排除或是確定診斷有聽力損失。在看診前可先觀察孩子對周遭環境聲音的反應，於看診時提供醫師主觀的觀察訊息。',
  //   ],
  // },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'hearing-loss',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '聽力缺損',
  // },
  // {
  //   render: h('div', [
  //     h(
  //       'p',
  //       { style: font() },
  //       '早產兒為聽力缺損的高危險群，尤其是低體重(出生體重小於1500公克)、出生時缺氧或受到病毒感染、腦膜炎、使用輔助呼吸器或耳毒性藥物、嚴重黃疸需要換血、身體器官或神經系統還尚未發育成熟等問題者。研究顯示，若其中幾項因素同時出現，發生聽損的比率就更高。然而，早產兒由於出生時腦部尚未成熟且體重較輕需使用保溫箱，而無法於出生後立即接受聽力篩檢，須等到離開保溫箱及生命徵象穩定之後，經醫師評估再安排。雖然可以透過聲音刺激來觀察反應，但早產兒聽力閾值比較低，大人認為很大聲，早產兒可能覺得還好所以沒有反應但不能代表聽不見。即使早產兒聽篩通過，亦需持續觀察與追蹤。',
  //     ),
  //     h(
  //       'p',
  //       { style: font() },
  //       '早期配戴輔具或者植入電子耳、刺激尚未進行重組的大腦，會讓大腦對聽覺輸入的接收性更高，進而提升聽力能力。研究顯示，孩童若在出生後18個月內植入電子耳，大多數可觀察到與聽力正常孩童相似的語言表達及接收發展； 在18至36個月之間植入者則次之。植入年齡在18至36個月之間的孩子，理解和表達能力顯著提高；而超過 36個月才植入的孩子，成效會是最多變的。因此建議在12-36個月間植入電子耳，對孩子語言發展效果較佳。',
  //     ),
  //     h(
  //       'p',
  //       { style: font() },
  //       h(
  //         'a',
  //         {
  //           href: 'https://bit.ly/36K0l2E',
  //           target: '_blank',
  //           rel: 'noreferrer noopener',
  //           style: {
  //             ...font(),
  //             'text-decoration': 'underline',
  //             cursor: 'pointer',
  //           },
  //         },
  //         '聽損嬰幼兒(0-3 歲)早期療育及教育諮詢之機構',
  //       ),
  //     ),
  //   ]),
  // },
];

// 聽力缺損
// export const hearingLossWording = [
//   {
//     type: 'important',
//     text: '高危險群',
//   },
//   {
//     type: 'normal',
//     text: '出生體重小於1500公克的極低體重早產兒。',
//   },
//   {
//     type: 'important',
//     text: '原因',
//   },
//   {
//     type: 'normal',
//     text: '早產兒出生時有缺氧或受到病毒感染、腦膜炎、使用輔助呼吸器或耳毒性藥物、嚴重黃疸需要換血、身體器官或神經系統還尚未發育成熟等問題者，若合併兩項因素以上，則會增加聽力缺損的比率。',
//   },
//   {
//     type: 'important',
//     text: '建議',
//   },
//   {
//     type: 'normal',
//     text: [
//       '1.以聲音刺激來觀察早產兒反應，但其聽力閾值較低，大人認為很大聲，早產兒可能覺得還好所以沒有反應，則不能代表聽不見。即使早產兒的聽力篩檢通過，也需持續觀察與追蹤。',
//       '2.早期配戴輔具或者植入電子耳，能刺激尚未進行重組的大腦，會讓大腦對聽覺輸入的接收性更高，進而提升聽力能力。',
//       '可參考以下連結了解更多。',

//     ],
//   },
//   {
//     render: h(
//       'a',
//       {
//         href: 'https://www.slh.org.tw/upload/files/%E6%96%B0%E7%94%9F%E5%85%92%E8%81%BD%E7%AF%A9%E5%B0%8F%E5%B9%AB%E6%89%8B(%E7%B7%9A%E4%B8%8A%E7%89%88)(1090526%E4%BF%AE%E6%94%B9)%20.pdf',
//         target: '_blank',
//         rel: 'noreferrer noopener',
//         style: {
//           ...font(),
//           'text-decoration': 'underline',
//           cursor: 'pointer',
//           marginTop: '20px',
//         },
//       },
//       '備註：新生兒聽篩小幫手-台灣聽力語言學會提供',
//     ),
//   },

// ];

// 預防接種
export const vaccinationWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: '由於早產兒的抵抗力較足月兒差，更需要按時接種疫苗，以避免感染嚴重疾病。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'vaccination-principles',
      wording: [
        {
          type: 'important',
          text: '接種原則',
        },
        {
          type: 'normal',
          text: '早產兒若出生體重未滿2000公克，需等至體重滿2000克或出生1個月後，依正常的時程順序接種。但若為B肝帶原母親的早產兒，則需於出生24小時內應接種免疫球蛋白及1劑B肝疫苗。',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'vaccination-principles',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'vaccination-pre-vaccination-assessment',
      wording: [
        {
          type: 'important',
          text: '接種疫苗前的評估',
        },
        {
          type: 'normal',
          text: [
            '1.身體狀況：是否有下列病徵如發燒(38.5℃以上)、嘔吐、呼吸困難、正服用八寶散或驚風散等藥物。或是最近一年內是否有發生抽痙狀況。',
            '2.過去接種反應：預防接種後是否曾經有嚴重反應，如發高燒(40.5℃以上)、抽搐、昏迷、休克、哭鬧不安3小時以上等。',
            '3.特殊疾病：是否有嚴重心、肝、腎、白血病、癌症等疾病。',
            '4.其他：最近三個月內就醫及服藥等情形。近三個月是否注射過免疫球蛋白或使用免疫製劑或輸血。',
          ],
        },
        {
          type: 'normal',
          text: '目前衛生福利部健保署核准之預防接種年齡時間表(如下表)2022.02更新',
        },
        {
          render: h(SimpleTable, {
            content: vaccinationContent,
            style: {
              marginTop: '20px',
              marginBottom: '20px',
            },
          }),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'vaccination-pre-vaccination-assessment',
  //   }),
  // },
];

// 新生兒照護發展
export const neonatalCareevelopmentWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: [
            '早產兒出生後由於各方面器官的成熟度不足，自我調節適應環境的能力較差，若長期處於不當的環境下易造成發展上的問題。',
            '因此在出生後開始施行發展性照護，可系統性地觀察早產兒的行為訊息，並依據其個別需求，減少環境壓力刺激、提供合適的環境，並給予適合其需求的發展照護，使早產兒的發展達最佳化。',
          ],
        },
        // {
        //   render: h(HomeCareImg, {
        //     type: 'newborn-care-behavioural-messages',
        //   }),
        // },

        {
          type: 'important',
          text: '認識早產兒行為訊息',
        },
        {
          type: 'normal-bold',
          text: '良好行為能力',
        },
        {
          type: 'normal',
          text: [
            '1.膚色穩定',
            '2.良好的自我安靜，專注有神的清醒狀態',
            '3.眼神發亮，注視著的笑容',
            '4.有意及有生氣的表情，規律強健的哭聲、皺眉等',
            '5.呼吸平穩、規則',
            '6.消化良好',
            '7.兩頰放鬆、口部有搜尋和吸吮的反應，手放入口中/抓握/握住，表情噘嘴成要說 “ㄨ(嗚)”的嘴形，發咕咕聲，嘴巴做出像在說話的動作等行為。',
            '8.活動平順、手交握、腳交扣、努力縮攏軀幹成彎曲的姿勢，腳會主動尋求支撐',
            '9.清楚明顯的睡眠狀態 (睡得好)',
          ],
        },
        {
          type: 'normal-bold',
          text: '壓力反應訊息',
        },
        {
          type: 'normal',
          text: [
            '1.膚色斑紋、灰白、泛紅、發紺',
            '2.狀態突然轉變',
            '3.兩眼直視、眼球飄動哭泣、皺眉、舌頭伸出',
            '4.呼吸急促、呼吸暫停、喘氣、心跳加快',
            '5.咳嗽、打噴嚏、震顫、驚嚇、抽動、煩躁或擔憂的警覺、混亂的動作',
            '6.溢吐、反胃、打嗝、看起來像排便樣的用力',
            '7.手指張開、手放在臉上的防禦性動作、手掌用力握拳、手臂(向兩旁伸展)',
            '8.軀幹(角弓反張、背往後弓)、軀幹及四肢(過度緊縮)、過度屈曲、伸展',
            '9.癱軟：軀幹、四肢、臉部肌肉',
            '10.混亂的睡眠或清醒狀態',
            '若以上反應可以快速自我調節而恢復，就不用太擔心。',
          ],
        },
        // {
        //   render: h(HomeCareImg, {
        //     type: 'newborn-care-take-fcocused-care',
        //   }),
        // },

        {
          type: 'important',
          text: '採取集中式照護',
        },
        {
          type: 'normal',
          text: '讓早產兒不受干擾，有較長的睡眠時間，睡眠對早產兒的痊癒、健康及成長具有重要性。',
        },
        // {
        //   render: h(HomeCareImg, {
        //     type: 'newborn-care-posture-support',
        //   }),
        // },

        {
          type: 'important',
          text: '擺位姿勢支持',
        },
        {
          type: 'normal',
          text: '使用蓋被、包裹及捲軸維持屈曲姿勢，讓早產兒猶如躺在母親子宮內的姿勢，約每2-3小時會更換姿勢，維持側躺或俯臥姿，讓早產兒有邊界感，促進安全感、安靜與能量保存。',
        },

        {
          type: 'important',
          text: '五感刺激',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'senses-vision',
      wording: [
        {
          type: 'normal-bold',
          text: '視覺',
        },
        {
          type: 'normal',
          text: [
            '早產兒因病情因素需住在加護病房，照護上可依正常生理作息時間提供視覺刺激：',
            '1.調整天花板燈光，每張床位旁應有獨立光源以維持可安全觀察亮度',
            '2.應用窗簾或其他屏障減少陽光直射',
            '3.因為在加護病房無法感受明確的白天黑夜，建議早上可將保溫箱布蓋微開，提供溫暖明亮的燈光；晚上則採微亮舒服的亮度或是將保溫箱蓋布放下。',
            '4.無論何時，在打開保溫箱遮蓋布前，為避免保溫箱外頭的強光直接照射早產兒的眼睛，打開保溫箱罩子或是抱出保溫箱時，保護嬰兒的眼睛免於光線直接照射，但也不建議只有暗光，可以仿照太陽光作用讓早產兒在保溫箱內感受慢慢變亮。',
            '5.應視嬰兒的週數及生理狀況作個別化的調整。',
            '6.矯齡0-2個月的早產兒能看清楚距離約20-30公分內的物品，建議給予辨認黑白的條紋、圖卡，或是方塊類的玩具等比較鮮明顏色且不複雜的物品，誘發視覺刺激。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'senses-vision',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'senses-hearing',
      wording: [
        {
          type: 'normal-bold',
          text: '聽覺',
        },
        {
          type: 'normal',
          text: [
            '早產兒的聽力系統在30-32週左右就成熟到可以學習，無需經由特別的訓練。但突然超過 75dB的聲音，會造成心跳、血壓、氧氣濃度、呼吸、腸胃蠕動及葡萄糖消耗量的改變。暴露在60dB或以上的噪音，會造成持續的睡眠障礙。',
            '因此在新生兒加護病房要避免及預防突然的聲響或過度的大聲以防驚嚇，如以下情形：',
            '1.保溫箱：手指敲打保溫箱、開關保溫箱圓窗門或抽屜',
            '2.氧氣供氣設施，排除呼吸氣管路中的積水',
            '3.輸入幫浦機和監視器警報聲',
            '4.電話響聲是屬於高振幅的聲音。',
            '5.醫護工作人員的活動：大笑、溝通、關門、蓋上垃圾桶蓋子',
          ],
        },
        {
          type: 'normal',
          text: [
            '建議',
            '1.提供適當環境，擺放分貝機以提醒醫護人員音量控制或協助早產兒戴小型耳罩(塞)',
            '2.早產兒生理穩定時，可適當增加家長的現場聲音刺激，並搭配手勢、撫摸嬰兒',
            '3.鼓勵家長親子共讀',
            '4.提升家長對早產兒照護的參與',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'senses-hearing',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'senses-smell',
      wording: [
        {
          type: 'normal-bold',
          text: '嗅覺',
        },
        {
          type: 'normal',
          text: [
            '早產兒的嗅覺來自對周圍環境的安全感，提供以下建議，將有助於維持寶寶的穩定度及安全感：',
            '1.打開酒精、優碘或其他消毒水時盡量遠離嬰兒',
            '2.在保溫箱內使用完酒精棉球或其他消毒棉棒後要立即移開',
            '3.沐浴時選擇無色香味的嬰兒專用沐浴乳或是清水。',
            '4.每天擦拭保溫箱避免異味產生。',
            '5.更換保溫箱內所使用的褥套、大小毛巾。',
            '6.接觸者應避免身上有太強烈的味道如香水、乳液或食物味。',
            '7.家長及母乳的味道具有安撫及舒適作用。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'senses-smell',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'senses-taste',
      wording: [
        {
          type: 'normal-bold',
          text: '味覺',
        },
        {
          type: 'normal',
          text: [
            '1.早期早產兒口腔味覺-非營養性吸吮：吸奶嘴、小棉枝(俗稱棒棒糖)。',
            '2.矯正週數32-34週生理狀態穩定的早產兒可開始嘗試由口進食，視情況加入口腔復健訓練。',
            '3.奶品選擇：強調新鮮配製及母乳正確解凍回溫，避免有腥味產生，造成挑食情形。',
            '備註：',
            '1.非營養性吸吮：多用在非餵食時段，自我調節與安慰的來源，可改善氧合作用、降低腦壓、安靜睡眠期增加、減少活動程度與哭泣、促進奶嘴餵食的準備度、體重增加較快、縮短住院日。',
            '2.口腔復健訓練：減敏早產兒的口腔周圍肌肉，並透過母乳或配方奶來添增對味道的記憶及喝奶能力。',
          ],
        },
        {
          render: h('div', [
            h('p', [
              h(
                'a',
                {
                  href: 'https://www.youtube.com/watch?v=1N9L4AlEh0I',
                  target: '_blank',
                  rel: 'noreferrer noopener',
                  style: {
                    ...font(),
                    'text-decoration': 'underline',
                    cursor: 'pointer',
                  },
                },
                '口腔按摩及餵食訓練',
              ),
              h(
                'span',
                {
                  style: font(),
                },
                '(取得作者同意)',
              ),
            ]),
          ]),
        },
        {
          type: 'normal',
          text: [
            '1.目的：減輕早產兒對疼痛的反應及壓力行為表現。',
            '2.時機：當早產兒躁動不安、不易入睡或給予刺激、進行侵入性處置後。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'senses-taste',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'senses-execution',
      wording: [
        {
          type: 'normal-bold',
          text: '觸覺',
        },
        {
          type: 'normal',
          text: [
            '方式',
            '1.讓早產兒抓握毛巾或照顧者的手指增加安全感。',
            '2.照顧者採寧握照護，寧握指的是照護者一手放在早產兒兒的頭部，另一手放在早產兒的腹部或臀部予安撫，避免來回地撫摸及按摩。',
            '3.視情況鼓勵父母親進行袋鼠護理。',
            '4.嬰幼兒撫觸按摩增加早產兒對觸覺的刺激，穩定生理狀態，還能增加親子互動。',
          ],
        },
        {
          render: h(
            'a',
            {
              href: 'http://tsn-neonatology.com/news/content.php?id=558',
              target: '_blank',
              rel: 'noreferrer noopener',
              style: {
                ...font(),
                'text-decoration': 'underline',
                cursor: 'pointer',
              },
            },
            '資料來源：新生兒個別化發展性照護-自學手冊-台灣新生兒科醫學會',
          ),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'senses-execution',
  //   }),
  // },
];

// 袋鼠護理
export const kangarooCareWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: '讓父/母親將早產兒抱在胸前，經由皮膚與皮膚(skin to skin)的接觸，讓早產兒去感受父/母親的心跳、呼吸聲及溫度，模仿類似子宮內的環境。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'kangaroo-care-benefits',
      wording: [
        {
          type: 'important',
          text: '優點',
        },
        {
          type: 'normal',
          text: [
            '1.幫助早產兒適應子宮外環境，增加睡眠時數及熟睡期。',
            '2.穩定早產兒生命徵象、減少哭鬧狀況、減少低血氧情形。',
            '3.幫助體重增加進而縮短住院天數。',
            '4.促進神經、動作及智力等發展，且有止痛效果。',
            '5.可增加親子間連結，協助父母親減輕心理壓力(如焦慮、憂鬱)，增加與早產兒正向的互動模式。',
            '6.幫助母親促進乳汁排出、增加母乳量及延長哺乳期。',
          ],
        },
        {
          type: 'important',
          text: '執行條件',
        },
        {
          type: 'normal',
          text: ['1.早產兒體重大於1500公克或矯正週數大於32週後。', '2.經醫師評估生命徵象及病情已穩定即可開始執行。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'kangaroo-care-benefits',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'kangaroo-care-execution',
      wording: [
        {
          type: 'important',
          text: '執行時間',
        },
        {
          type: 'normal',
          text: ['每次約20-60分鐘，視寶寶生理及呼吸情況縮短或延長時間。'],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'kangaroo-care-execution',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'kangaroo-care-preparing',
      wording: [
        {
          type: 'important',
          text: '執行準備',
        },
        {
          type: 'normal',
          text: [
            'Step.1父母親準備：',
            '1.在家先沐浴完成(一般方式清潔即可)，避免擦拭香水或乳液。',
            '2.切勿抽煙、避免身上有二手菸味。',
            '3.可預先用餐。 ',
            '4.從家中直接前往病房，中途避免去其他地方。',
            '5.到病房前先如廁及確實洗手。',
            '6.保持輕鬆愉悅的心情。',
            '7.提交呼吸道融合病毒抗原檢測檢驗的正常報告(視醫療院所)。',
            'Step.2環境準備：',
            '1.乾淨的開襟式寬鬆衣服。',
            '2.提供小房間或是使用圍簾。',
            '3.座椅及毛毯或毛巾。',
            '4.避開空調通風口正下方或陽光直接照射處執行，柔陰暗光。',
            'Step.3護理人員先協助早產兒更換新的尿片、固定身上管路後，請父/母親維持半躺姿式，讓寶寶直接趴於胸前做皮膚接觸，父/母親可以看到寶寶的臉及口鼻。',
            '‧注意事項：',
            '1.剛開始執行可能會有短時間的躁動不安或執行者感覺背、臀部酸麻；以及過程中有出現體溫偏低、呼吸或心跳不穩、膚色發紺，可請護理人員協助更換姿勢或立即停止袋鼠護理。',
            '2.護理人員會在旁監測及記錄寶寶生命徵象，如需要任何幫助可隨時請求協助。',
            '3.父/母親如果患有皮膚方面疾病、傷口、或是呼吸道感染者，建議暫停執行',
            '4.袋鼠護理過程中，父/母親避免使用手機以預防外來感染，若想拍照建議由他人協助。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'kangaroo-care-preparing',
  //   }),
  // },
];
// 親子共讀
export const parentChildReadingWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: [
            '親子共讀的理念是「孩子出生後，就可以開始唸故事書給寶寶聽。」重點不在於口說技巧，而是：',
            '1.刺激寶寶腦部及語言發展。',
            '2.促進親子互動及親密關係。',
            '3.藉由家長的閱讀方式以增加孩子的字彙量。',
            '4.啟發孩子未來的想像力及培養其創造力。',
          ],
        },
        {
          type: 'important',
          text: '工具',
        },
        {
          type: 'normal',
          text: '紙本書、繪本、布書、洗澡書、電子書(視情況提供需求)等。',
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'share-reading',
      wording: [
        {
          type: 'important',
          text: '建立小腳丫的共讀習慣',
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'share-reading',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'treat',
      wording: [
        {
          type: 'normal-bold',
          text: '住院期間',
        },
        {
          type: 'normal',
          text: [
            '親子共讀的目的是促進親子關係及視聽覺的發展性照護。',
            '1.適合時機：會客時間',
            '2.帶本合適童書，在保溫箱旁和寶寶輕聲說故事、看圖片，隨時注意寶寶反應、給予正向回饋。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'treat',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'parent-child-reading-environment',
      wording: [
        {
          type: 'normal-bold',
          text: '出院後',
        },
        {
          type: 'normal',
          text: [
            '1.寶寶清醒的時候就可以隨時隨地做親子共讀。',
            '2.最好的地點是在父母親的懷裡。',
            '3.時間無限制，可長可短，以寶寶的專注力為主。',
            '4.要長期持續執行才能見效。',
            '5.隨著年齡成長，運用書本內容與孩子做對話式閱讀，以看圖說故事和自問自答，同步觀察寶寶反應，出現笑、拍書、咬撕書都是其開心的表現。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'parent-child-reading-environment',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'parent-child-reading-habits',
      wording: [
        {
          type: 'important',
          text: '大孩子的居家親子共讀環境',
        },
        {
          type: 'normal',
          text: [
            '1.固定時段。',
            '2.簡約環境並規劃固定閱讀區域。',
            '3.讓孩子選擇自己要讀的書。',
            '4.營造愉悅輕鬆的閱讀氣氛並適時讚美和鼓勵。',
          ],
        },
        {
          type: 'normal',
          text: [
            '成長中的孩子有樣學樣，父母要以身作則，家裡經常有書，常有人閱讀，孩子自然而然就會親近書、親近閱讀。由少而多自然養成長期的閱讀習慣。',
          ],
        },
        {
          type: 'important',
          text: 'Bookstart閱讀起步走',
        },
        {
          render: h(SimpleTable, {
            content: bookStartReadingContent,
            style: {
              marginTop: '20px',
              marginBottom: '20px',
            },
          }),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'parent-child-reading-habits',
  //   }),
  // },

  // {
  //   type: 'normal-bold',
  //   text: '歷史',
  // },
  // {
  //   type: 'normal',
  //   text: ['1992年從英國伯明罕開始推廣讓幼兒提早開始養成閱讀習慣的活動，後來推展至歐洲各國、日本、韓國、泰國、台灣、澳洲等地。台灣是由信誼基金會與地方政府及各鄉鎮圖書館合作，致力推廣於全國。教育部於2009年也開始推行此活動進入國民小學， 2014年更名為「國民中小學新生閱讀推廣計畫」，國中小新生可獲得一份閱讀禮袋。'],
  // },
  // {
  //   type: 'normal-bold',
  //   text: '目的',
  // },
  // {
  //   type: 'normal',
  //   text: ['讓嬰幼兒從出生後就能開始接觸多元的圖書本，在閱讀中促進不同能力的發展，並養成持續閱讀習慣的活動。'],
  // },
  // {
  //   type: 'normal-bold',
  //   text: '活動',
  // },
  // {
  //   render: h(Processing, {
  //     content: [
  //       {
  //         id: uuid(),
  //         t: '與童書出版商、當地圖書館合作出產免費「閱讀禮袋」',

  //       },
  //       {
  //         id: uuid(),
  //         t: '提供家長推薦的童書清單及免費童書',
  //       },
  //       {
  //         id: uuid(),
  //         t: '指導家長培養幼兒養成閱讀習慣的方法鼓勵、參與圖書館舉辦之相關活動',
  //       },
  //     ],
  //   }),
  // },
  // {
  //   type: 'normal-bold',
  //   text: '書單類型',
  // },
  // {
  //   type: 'normal',
  //   text: '感官動作、語文學習、認知學習、生活能力、人際互動、想像創意。',
  // },
  // {
  //   type: 'normal-bold',
  //   text: '教育部閱讀禮袋領取資格',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1. 0-5歲嬰幼兒(民國103年1月1日以後出生)。',
  //     '2.戶口名簿及家長或監護人之身份證件。',
  //     '3.0-5歲嬰幼兒圖書館借書證。',
  //     '4.只要年齡在0-5歲，每一年皆可領取閱讀禮袋，至5歲為止。',
  //     '備註：因各縣市圖書館規定略有不同，建議先向孩子設籍所在地的圖書館詢問以取得最新訊息。',

  //   ],
  // },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'parent-child-reading-habits',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '如何開始建立共讀習慣',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '1.首先父母親一定要有一個觀念，親子共讀的目的不在於口說技巧，而是促進早產兒腦部發展和彼此親子間之親密關係以及藉由家長的閱讀方式以增加孩子的字彙量。',
  //     '2.早產兒住院期間，親子共讀目的是為了促進親子關係及視覺和聽覺的發展性照護，建議住院中早產兒的父母親可以在會客時間，帶本合適的童書，在保溫箱旁和寶寶輕聲說故事，也能讓寶寶看書本的圖片，隨時注意寶寶反應、給予正向回饋。',
  //     '3.出院後無論環境地點，只要早產寶寶清醒，安排一個適合與寶寶相處的時間，找個舒服的地方像是父母懷裡是聽故事最舒服的位置，就可以隨時隨地做親子共讀，時間短至五分鐘、也可依照寶寶反應增加閱讀時間，因為嬰幼兒專注力原本就不長，所以時間上無一定限制，但要持續執行才能見效。隨著年齡成長，就能運用書本的內容與嬰幼兒做對話式閱讀，以看圖說故事和自問自答方式，邊講邊觀察寶寶反應，寶寶笑、拍書、咬撕書都是開心的表現。',
  //     '4.父母要以身作則，成長的孩子有樣學樣，家裡經常有書，常有人閱讀，孩子自然而然就會親近書、親近閱讀。由少而多自然養成閱讀習慣，建議剛開始每星期至少有3天，找個輕鬆的時間抱著寶寶念故事書，從幾分鐘開始，慢慢延長時間，自然養成閱讀習慣。',
  //   ],
  // },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'parent-child-reading-reading-tool',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '閱讀工具',
  // },
  // {
  //   type: 'normal',
  //   text: '紙本書、繪本、電子書等。(小插圖)',
  // },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'parent-child-reading-environment',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '打造居家親子共讀環境',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '‧固定時段',
  //     '‧簡約環境並規劃固定閱讀區域',
  //     '‧讓孩子選擇自己要讀的書',
  //     '‧營造愉悅輕鬆的閱讀氣氛並適時讚美和鼓勵',
  //   ],
  // },
  // {
  //   render: h(HomeCareImg, {
  //     type: 'parent-child-reading-remarks',
  //   }),
  // },
  // {
  //   type: 'important',
  //   text: '備註',
  // },
  // {
  //   type: 'normal',
  //   text: [
  //     '「閱讀起步走」連結網址https://www.bookstart.org.tw/p4.html',
  //     '活動最初是從1992年英國伯明罕開始推廣，由圖書信託基金會、伯明罕大學教育學院及伯明罕當地的衛生機構和圖書館共同發起。除英國以外，目前此活動以推展至歐洲各國、日本、韓國、泰國、台灣、澳洲等地。',
  //     '台灣則是由信誼基金會與各地方政府合作進行推廣，透過各鄉鎮之圖書館作為協助推廣單位，致力推廣於全國。同時在2009年起，教育部也開始推動此活動進入國民小學，國小新生也會獲得一份閱讀禮袋及一本書。',
  //     '目的是讓幼兒提早開始養成閱讀習慣的活動。活動內容通常會與童書出版商以及當地圖書館合作，以「禮物袋」的形式提供「六個月以上」之幼兒家長數本的免費童書，以及一份推薦的童書清單，並指導家長培養幼兒養成閱讀習慣的方法，後續再配合圖書館舉辦之各項活動直到三歲學齡前；希望能讓幼兒從出生起就能開始接觸書本，藉此養成未來持續閱讀的習慣。',
  //     '書單內容類型：感官動作、語文學習、認知學習、生活能力、人際互動、想像創意，不同的類別，讓寶寶從小就可以接觸多元的圖畫書內容，在閱讀中促進不同能力的發展。',
  //     '閱讀禮袋領取資格及條件：',
  //     '(1) 0-5歲嬰幼兒<民國103年1月1日以後出生>',
  //     '(2) 戶口名簿及家長或監護人之身份證件',
  //     '(3) 0-5歲嬰幼兒圖書館借書證',
  //     '只要寶貝年齡是0-5歲，就可以領取閱讀禮袋，而且每一年皆可以領取，直至5歲為止。因各縣市圖書館規定不一定一樣，請向孩子設籍所在地的圖書館電話詢問取得最新訊息。',
  //   ],
  // },
];

// 早產兒按摩
export const prematureMassageWording = [
  {
    render: h(HomeCareImgWithText, {
      imgType: '',
      wording: [
        {
          type: 'normal',
          text: [
            '根據多年的研究及臨床證明，按摩對早產寶寶帶來各種益處：',
            '1.增加免疫力。',
            '2.增加食慾和體重，並有利於成長發育。',
            '3.減少哭鬧、減輕疼痛。',
            '4.幫助睡眠。',
            '5.促進親子互動、提升寶寶的安全感、發展對父母的信任感及愛的傳遞。',
            '6.按摩可以刺激大腦產生後葉催產素，幫助寶寶和父母有平和安靜的感覺。',
          ],
        },
      ],
    }),
  },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'premature-massage-prep',
      wording: [
        {
          type: 'important',
          text: '按摩前準備',
        },
        {
          type: 'normal',
          text: [
            '1.室溫約維持在26-28度左右。',
            '2.選擇在地上鋪瑜珈軟墊或尿布墊來按摩(地板較床或桌上安全，避免寶寶不慎滾落)。',
            '3.準備純天然無色無味的按摩油，避免受香氣影響情緒，建議選擇安全可食的冷壓植物油。',
            '4.按摩者須注意指甲修剪，避免刮傷嬰兒皮膚。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'premature-massage-prep',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'premature-massage-time',
      wording: [
        {
          type: 'important',
          text: '按摩時間',
        },
        {
          type: 'normal',
          text: [
            '1.建議飯後30分鐘-2小時，以免溢奶發生。',
            '2.寶寶清醒的時間如沐浴前後或入睡前。',
            '備註：避免在寶寶肚子餓、身體不舒服、哭鬧或精神狀態不佳的時候進行按摩。',
          ],
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'premature-massage-time',
  //   }),
  // },

  {
    render: h(HomeCareImgWithText, {
      imgType: 'premature-massage-sequence',
      wording: [
        {
          type: 'important',
          text: '注意事項',
        },
        {
          type: 'normal',
          text: [
            '按摩的重點是「質」(按摩的品質)，而非「量」(按摩的時間多久)，且每個寶寶對皮膚接觸的敏感度不一樣，因此，剛開始可以隔著毛巾給寶寶觸覺的刺激，如果可以逐漸適應，則可進行與寶寶皮膚的直接撫觸與按摩。千萬不要強迫寶寶，過程中隨時觀察寶寶的反應來決定是否該休息暫停按摩。',
          ],
        },
        {
          render: h(
            'a',
            {
              href: 'https://youtu.be/wBeACaN-hXo',
              target: '_blank',
              rel: 'noreferrer noopener',
              style: {
                ...font(),
                'text-decoration': 'underline',
                cursor: 'pointer',
                marginTop: '20px',
              },
            },
            '可參考影片：嬰兒按摩示範-早產兒基金會',
          ),
        },
      ],
    }),
  },

  // {
  //   render: h(HomeCareImg, {
  //     type: 'premature-massage-sequence',
  //   }),
  // },
];

// 什麼是「早產兒追蹤檢查」
export const whatIsPreemieTrackingCheckWording = [
  {
    type: 'normal',
    text: [
      '在早產兒追蹤檢查計畫中，我們建議出生體重≤1500公克或出生週數≤29週的極低出生體重早產兒，於『矯正年齡』第6、12、24個月定期回診接受完整的追蹤檢查（所謂矯正年齡，是以媽媽的預產期來計算寶寶的年齡）。依據不同年齡進行適齡能力與心智發展成熟度的評估，及早篩檢出異常情形，做適當的轉介與治療，進一步提供給早產兒更好的發展環境與機會。',
    ],
  },
  {
    render: h(CorrectedAgeIntro),
  },
  {
    type: 'normal',
    text: [
      '不論寶寶何時出生，以目前日期減預產期日期即可計算寶寶的矯正年齡。',
      '(例如：寶寶出生日期為5月1日，媽媽的預產期是7月1日，則至8月1日時，寶寶的矯正年齡為1個月。)',
    ],
  },
];

// 為何早產兒需要做「早產兒追蹤檢查」
export const whyPreemieTrackingCheckWording = [
  {
    type: 'normal',
    text: [
      '台灣平均每年有近20萬個新生兒誕生，早產兒出生比例約佔8%-10%，因此每年有近2萬個早產兒出生。民國84年3月全民健保的實施，與近十幾年來台灣早產兒醫護照顧的顯著進步，不僅提升早產兒存活率，也減輕許多父母的經濟負擔。其中出生體重低於1500公克(極低出生體重)早產兒存活機率增加，如何協助這些弱小的孩子進行全面性的長期追蹤顯得十分重要。',
      '這些幸運存活下來的極低出生體重兒，他們的神經發展後遺症及認知、動作發展的狀況，成為醫護人員、孩子的父母、家人及社會大眾另一關心的議題。早產兒基金會的早產兒追蹤門診中，分別針對足月及出生體重低於1500公克，矯正年齡2歲時仍有接受追蹤檢查的早產兒做比較，發現極低出生體重兒較足月兒易發生認知發展及動作遲緩。發展異常之發生和懷孕週數低於29週，出生體重低於1001公克、男嬰、出生後需急救、3度以上腦室內出血、腦室旁白質軟化、慢性肺疾病等有關。',
      '另外根據台灣早產兒聯合追蹤小組2011年成果報告顯示，出生體重≦1500公克存活下來的極低體重早產兒，2歲時15.6%有認知發展指數(MDI)異常，16.4﹪有動作發展指數(PDI)異常，重度視障或兩眼失明的發生率為1.15%，聽力檢查重度異常為3.9%，腦性麻痺為7.8%。神經發展及視聽力檢查均為正常的為40.1%，輕度異常為35.3%，中度異常為10.8%，重度異常的為13.8%。',
      '隨著週產期及早產醫療的進步，將有愈來愈多的極低出生體重兒能幸運地存活下來，然而，這些嬰兒易發生神經、心智發展及視力聽力的問題，因此極需要長期的追蹤這些早產兒，以收早期療育之效。',
    ],
  },
];

// 完整的「早產兒追蹤檢查」包含哪些項目
export const completePreemieTrackingCheckWording = [
  {
    type: 'normal',
    text: '追蹤門診檢查的項目設計，著重於生長營養狀態、視覺、聽覺、心智發展、神經肌肉與粗細動作的發展評量。期能早期發現發展遲滯的孩童，以便能幫助他們獲得早期治療。',
  },
  {
    type: 'normal-bold',
    text: '1、身高、頭圍、體重與營養狀態評估：',
  },
  {
    type: 'normal',
    text: '除了量測生長指標，並對照矯正年齡的生長曲線表外，並應針對營養狀態、哺育攝取情形、副食品添加比重提供適當的營養諮詢。',
  },
  {
    type: 'normal-bold',
    text: '2、神經發育與粗細動作檢查：',
  },
  {
    type: 'normal',
    text: '藉由肌肉張力的評量(如關節角度的量測)，神經反射的出現或消失、坐姿與站姿的穩定性來評量早產兒的神經發育狀況。提醒家長及醫療人員，注意早產兒之後是否迎頭趕上。',
  },
  {
    type: 'normal-bold',
    text: '3、心智發展評測：',
  },
  {
    type: 'normal',
    text: '目前常用來評測心智發展的工具在3歲以前為「貝利嬰幼兒發展測驗」第3版( Bayley Scales of Infant Development, 簡稱為 BSID－Ⅲ)，藉由經設計過的模型、圖型與玩具加以評量嬰幼兒目前在認知、語言、社會人際以及精細動作（如手部模仿、握筆）、粗動作（如爬、坐、站、走）之各項功能，配合評測過程的行為觀察，全面而整體性地了解嬰幼兒的心智發展情形。在5歲兒童的追蹤門診中，心智發展評測的工具包括中文版魏氏幼兒智力量表修訂版、以及活動量表、氣質量表的評估，希望藉助完整的評估來瞭解學前早產兒的心智發展狀況與行為表現。',
  },
  {
    type: 'normal-bold',
    text: '4、眼科評估：',
  },
  {
    type: 'normal',
    text: [
      '視網膜是寶寶看到物體的重要工具，而早產兒們視網膜產生病變的機率偏高，建議父母應該讓寶寶追蹤至受孕滿40週的週齡左右，才可以安心（部分早產兒日後仍會發生遠視、近視、斜視、散光、視力障礙與影像變形的後遺症）。',
      '視網膜以及視力檢查是早產兒的追蹤檢查中重要的一環，因為一些眼科問題並非外觀或肉眼觀察就可得知，尤其是視網膜病變的變化快速，更要及早發現，才能避免發生嚴重的視力問題。因此在早產兒追蹤門診中，除了滿40週齡左右的首次視網膜檢查外，建議在早產兒矯正年齡1歲到1歲半時，也須開始做視力檢查，之後再依照寶寶的個別情況，由小兒眼科醫師持續追蹤。',
    ],
  },
  {
    type: 'normal-bold',
    text: '5、聽力評估：',
  },
  {
    type: 'normal',
    text: '早產兒寶寶出院前，皆須接受初步的聽力篩檢檢查。檢測結果若出現異常，則需在門診中提醒家屬後續的追蹤，與決定是否需要及早轉介小兒耳鼻喉科醫師進一步評估與處理。另外提醒父母的是，並沒有一種聽力檢查能夠完全檢查出聽力問題，所以除了聽力篩檢所提供的數據以外，仍應多從小朋友發展的語言、說、聽、理解、表達或認知能力，來評估聽力是否異常，才能更為準確。',
  },
];

// 「早產兒追蹤檢查」與「早期療育」有何不同
export const preemieTrackingCheckAndEarlyCareWording = [
  {
    type: 'normal',
    text: [
      '多數人初聞「早產兒追蹤檢查」，心中難免與「早期療育」產生連結，部分的早產兒父母，走動醫院進行評估或療育之餘，有可能也會因為孩子的評估結果與需求，進而轉介早療，這兩種制度都是針對早產兒的嗎? 選擇上又有何差異呢?',
      '此兩者最大的差異在於，「早產兒追蹤檢查」是極早介入的(矯正年齡6個月開始至兩歲)、全面性不分程度的(與醫院合作追蹤全國出生體重≤1500公克或出生週數≤29週早產兒)、主動式的篩檢制度；「早期療育」通常較無明確固定的起始點(家屬發現常是2歲以後)，是針對有發展遲緩疑慮的孩童，被動式的(通報後接續進行)模式。',
    ],
  },
  {
    type: 'normal',
    text: ['「早產兒追蹤檢查工作」與「早期療育評估機制」的差異，分述如下圖：'],
  },
  {
    render: h(SimpleTable, {
      content: preemieTrackingCheckAndEarlyCareContent,
      style: {
        marginTop: '20px',
        marginBottom: '20px',
      },
    }),
  },

  {
    type: 'normal',
    text: '經由上述說明，可以瞭解到兩者從介入的時間點、服務對象與進行方式是不全相等的，彼此屬於合作關係。經由全國性、全面的早產兒追蹤檢查工作，及早篩檢出有疑慮、有需要的個案，及時轉介早療或相關科別以進行療育，方可適時適當的給予協助，確保早產兒及其家庭良好的生活品質，提供給早產兒更好的發展環境與機會。',
  },
  {
    render: h(OpenItem, {
      link: 'https://pbf.org.tw/pdf/%E7%99%BC%E5%B1%95%E9%81%B2%E7%B7%A9%E5%85%92%E7%AB%A5%E6%97%A9%E6%9C%9F%E7%99%82%E8%82%B2%E6%9C%8D%E5%8B%99%E6%B5%81%E7%A8%8B.pdf',
      label: '發展遲緩兒童早期療育服務流程(衛生福利部社會及家庭署資料)',
    }),
  },
  {
    render: h(OpenItem, {
      link: {
        name: 'related-sites',
      },
      label: '早期療育相關網站',
      type: 'internal',
    }),
  },
];

export const disadvantagedChildrenContentWording = [
  {
    render: h(OpenList, {
      list: [
        {
          label: '基隆市',
          link: 'https://www.klcg.gov.tw/tw/social/2793-113082.html',
        },
        {
          label: '台北市',
          link: 'https://dosw.gov.taipei/Content_List.aspx?n=27572369655BF62F',
        },
        {
          label: '新北市',
          link: 'https://service.ntpc.gov.tw/eservice/CaseData.action?itemId=110058',
        },
        {
          label: '桃園市',
          link: 'https://sab.tycg.gov.tw/home.jsp?id=30572&parentpath=0,30484,30493&mcustomize=onemessages_view.jsp&dataserno=201301240001&aplistdn=ou=data,ou=young,ou=chsocial,ou=ap_root,o=tycg,c=tw&toolsflag=Y',
        },
        { label: '新竹縣', link: 'https://social.hsinchu.gov.tw/News_Content.aspx?n=203&s=3715' },
        {
          label: '新竹市',
          link: 'https://society.hccg.gov.tw/ch/home.jsp?id=10327&parentpath=0,3,21&mcustomize=onemessages_view.jsp&toolsflag=Y&dataserno=201704270002&t=SocietyOnes&mserno=201803140001',
        },
        { label: '苗栗縣', link: 'https://www.miaoli.gov.tw/social_affairs/News.aspx?n=683&sms=9467' },
        { label: '台中市', link: 'https://www.society.taichung.gov.tw/13710/13735/13738/461238/post' },
        {
          label: '南投縣',
          link: 'https://welfare.nantou.gov.tw/1486/ch002_5',
        },
        { label: '彰化縣', link: 'https://social.chcg.gov.tw/07other/other01_con.asp?topsn=1755&data_id=14572' },
        { label: '雲林縣', link: 'https://social.yunlin.gov.tw/News_Content.aspx?n=737&s=294673' },
        { label: '嘉義市', link: 'https://social.chiayi.gov.tw/News_Content.aspx?n=401&s=293357' },
        { label: '嘉義縣', link: 'https://sabcc.cyhg.gov.tw/cp.aspx?n=AC4A64318B66ADCA' },
        { label: '台南市', link: 'https://sab.tainan.gov.tw/News_Content.aspx?n=21344&s=4378096' },
        { label: '高雄市', link: 'https://socbu.kcg.gov.tw/index.php?prog=2&b_id=2&m_id=2&s_id=2' },
        {
          label: '屏東縣',
          link: 'https://www.pthg.gov.tw/planjdp/cp.aspx?n=2CD67C748CF32401',
        },
        {
          label: '台東縣',
          link: 'https://taisoc.taitung.gov.tw/WebSite/Service/serviceDetail.aspx?menuid=lW%2bfKiAxClc%3d&page=1&id=ZFokpInvAnU%3d',
        },
        { label: '花蓮縣', link: 'https://sa.hl.gov.tw/Detail_sp/836fff2dc9d34061b282cfbadc0023e3' },
        {
          label: '宜蘭縣',
          link: 'https://sntroot.e-land.gov.tw/News_Content.aspx?n=D1E59CE36C8E1953&sms=6A41E7DE9B5CA4AD&s=2067B6DAFB69917C',
        },
        { label: '金門縣', link: 'https://social.kinmen.gov.tw/cp.aspx?n=69B652E4C1464FFE&s=9276BA63ED769ADE' },
      ],
    }),
  },
];
export const maternityAllowancesWording = [
  {
    render: h(OpenList, {
      list: [
        { label: '基隆市', link: 'https://civil.klcg.gov.tw/tw/Subject/ThemesService?TSerNo=0A0000D8' },
        {
          label: '台北市',
          link: 'https://www.gov.taipei/News_Content.aspx?n=EEC70A4186D4C828&sms=87415A8B9CE81B16&s=7CFAB551F7DA3852',
        },
        { label: '新北市', link: 'https://welfare.ntpc.gov.tw/viewService/show/1008103' },
        {
          label: '桃園市',
          link: 'https://sab.tycg.gov.tw/home.jsp?id=30567&parentpath=0,30484,30492&mcustomize=onemessages_view.jsp&dataserno=202005250001&aplistdn=ou=data,ou=childcar',
        },
        { label: '新竹縣', link: 'https://social.hsinchu.gov.tw/News_Content.aspx?n=203&s=3713' },
        {
          label: '新竹市',
          link: 'https://dep-civil.hccg.gov.tw/ch/home.jsp?id=136&parentpath=0,9&mcustomize=onemessages_view.jsp&dataserno=201605080012',
        },
        { label: '苗栗縣', link: 'https://mlhr.miaoli.gov.tw/Theme.php?id=3' },
        { label: '台中市', link: 'https://www.society.taichung.gov.tw/461494/post' },
        { label: '彰化縣', link: 'https://social.chcg.gov.tw/06service/service01_con.asp?data_id=11371' },
        {
          label: '南投縣',
          link: 'https://glrs.nantou.gov.tw/glrsout/LawContent.aspx?id=GL000080&KeyWord=%e7%94%9f%e8%82%b2',
        },
        {
          label: '雲林縣',
          link: 'https://law.yunlin.gov.tw/LawContent.aspx?id=GL000080&KeyWord=%E7%94%9F%E8%82%B2%E6%B4%A5%E8%B2%BC',
        },
        { label: '嘉義縣', link: 'https://sabcc.cyhg.gov.tw/cp.aspx?n=B5EE49FA21B5A443' },
        { label: '嘉義市', link: 'https://social.chiayi.gov.tw/News_Content.aspx?n=403&s=293369' },
        { label: '台南市', link: 'https://tnscg-agr.tainan.gov.tw/mcontent.php?ms=ZnVfSUQ9MTM0Jm1pX0lEPTEzNTM=' },
        { label: '高雄市', link: 'https://socbu.kcg.gov.tw/index.php?prog=2&b_id=25&m_id=126&s_id=760' },
        { label: '屏東市', link: 'https://www.pthg.gov.tw/e-service/page_1_1_7.html' },
        { label: '台東縣', link: 'https://tth.taitung.gov.tw/files/11-1000-111-1.php' },
        { label: '花蓮縣', link: 'https://sa.hl.gov.tw/Detail_sp/933bc57c73ce40f0997247a34148bd85' },
        { label: '宜蘭縣', link: 'https://sntroot.e-land.gov.tw/cp.aspx?n=8FF8CE287F348716' },
        {
          label: '澎湖縣',
          link: 'https://eservice.penghu.gov.tw/Service_Content.aspx?n=A7ECB1F9E8CAF76E&p=0DFA87C55E765CC7&s=22A59DF85FC4B108',
        },
        { label: '金門縣', link: 'https://social.kinmen.gov.tw/cp.aspx?n=23A3A23B56E70887&s=1D59B8E69C745002' },
        { label: '連江縣', link: 'https://www.weseematsu.com/forum.php?mod=viewthread&tid=537' },
      ],
    }),
  },
];
export const variousInsuranceWording = [
  {
    type: 'normal',
    text: '依投保身份僅能擇一領取',
  },
  {
    render: h(OpenList, {
      list: [
        { label: '勞保生育給付', link: 'https://www.bli.gov.tw/0004836.html' },
        { label: '國保生育給付', link: 'https://www.bli.gov.tw/0016966.html' },
        { label: '農保生育給付', link: 'https://www.bli.gov.tw/0006758.html' },
      ],
    }),
  },
];
export const childcareAllowanceWording = [
  {
    type: 'normal-bold',
    text: '育兒津貼提升補助金額，更擴大補助對象',
  },
  // {
  //   type: 'normal',
  //   text: [
  //     '今年(2021) 8月起，每月發放3500元；明年(2022) 8月起，每月發放5000元，原本要第3胎才會加碼1000元，提前到第2胎就加發。同時，育兒津貼也擴大了發放對象，今年8月開始，正在領育嬰留停津貼或其他弱勢補助的家庭，也可以請領津貼；在一般私立幼兒園讀書的5至6歲小朋友，就學補助也比照津貼額度。',
  //     '另外，還針對就讀公共化及準公共托育機構的幼兒，分兩階段再降低費用。2歲以下的幼兒送去公共化托嬰中心、社區家園，和準公共托嬰中心和保母，今年8月開始，每個月托育補助加1000元，達7000元，明年8月再加1500元，達8500元，2胎、3胎、低收入戶及中低收入戶幼兒的補助再增加。就讀公共化及準公共幼兒園的2至6歲幼兒，今年8月起，家長每月繳費再減1000元，明年8月再減500元，每月繳費最多不超過3000元。',
  //   ],

  // },
  {
    render: h(OpenList, {
      style: {
        marginTop: '20px',
      },
      list: [
        { label: '基隆市', link: 'https://www.klcg.gov.tw/tw/News/Detail2?NewsId=127100F5&i=0' },
        { label: '台北市', link: 'https://dosw.gov.taipei/cp.aspx?n=C189BFAB86EAF184' },
        { label: '新北市', link: 'https://welfare.ntpc.gov.tw/viewService/show/1008029' },
        { label: '桃園市', link: 'https://sab.tycg.gov.tw/home.jsp?id=30567&parentpath=0,30484,30492' },
        { label: '新竹縣', link: 'https://social.hsinchu.gov.tw/News_Content.aspx?n=203&s=236405' },
        {
          label: '新竹市',
          link: 'https://society.hccg.gov.tw/ch/home.jsp?id=189&parentpath=0,5,43&mcustomize=qanda_view.jsp&toolsflag=Y&dataserno=201808100002&t=QandA&mserno=201603090004',
        },
        { label: '苗栗縣', link: 'https://www.miaoli.gov.tw/social_affairs/News.aspx?n=695&sms=9615' },
        { label: '台中市', link: 'https://www.society.taichung.gov.tw/1052461/post' },
        { label: '彰化縣', link: 'https://social.chcg.gov.tw/07other/other01_list.asp?topsn=1755' },
        {
          label: '南投縣',
          link: 'https://www.nantou.gov.tw/big5/downloaddetail.asp?cid=75&cid1=251&dptid=376480000&mcid=134770',
        },
        { label: '雲林縣', link: 'https://social.yunlin.gov.tw/News_Content.aspx?n=737&s=256538' },
        { label: '嘉義縣', link: 'https://sabcc.cyhg.gov.tw/cp.aspx?n=2947BC4C3FBC8E1C' },
        { label: '嘉義市', link: 'https://social.chiayi.gov.tw/infant.htm' },
        { label: '台南市', link: 'https://sab.tainan.gov.tw/News.aspx?n=21448&sms=19675' },
        { label: '高雄市', link: 'https://www.kh.edu.tw/forms/getDirectory/3624' },
        {
          label: '屏東縣',
          link: 'https://www.pthg.gov.tw/planjdp/Cus_Petition_Detail.aspx?s=1569C994501A622A&n=3E778AC8AAED37D2',
        },
        {
          label: '台東縣',
          link: 'https://taisoc.taitung.gov.tw/WebSite/Service/service.aspx?menuid=lW%2BfKiAxClc%3D&cate=0cySt5Aggpk%3D',
        },
        { label: '花蓮縣', link: 'https://sa.hl.gov.tw/Detail_sp/5e3b2c931b1c46ccbd50376ac60eafeb' },
        { label: '宜蘭縣', link: 'https://sntroot.e-land.gov.tw/News.aspx?n=04383821D6DC3CAB&sms=291EF45DAE0EB576' },
        { label: '澎湖縣', link: 'https://www.penghu.gov.tw/edu/home.jsp?id=203' },
        { label: '金門縣', link: 'https://social.kinmen.gov.tw/cp.aspx?n=69B652E4C1464FFE&s=B55EFC468B94D84B' },
      ],
    }),
  },
];
export const nationalNannySystemWording = [
  {
    render: h(OpenList, {
      list: [
        {
          link: 'https://ncwisweb.sfaa.gov.tw/home/index',
          label: '托育中心',
        },
        {
          label: '基隆市',
          link: 'https://social.klcg.gov.tw/social_srv/info_view.php?Kid=11&Mid=7&Sid=145&Tid=0&sid=596&serno=20151222192726&page_num=1',
        },
        { label: '台北市', link: 'https://dosw.gov.taipei/Content_List.aspx?n=E7F1297C3E905941' },
        { label: '新北市', link: 'https://www.sw.ntpc.gov.tw/home.jsp?id=b2dfefc09cf046f2' },
        { label: '桃園市', link: 'https://sab.tycg.gov.tw/home.jsp?id=30492&parentpath=0,30484' },
        { label: '新竹縣', link: 'https://social.hsinchu.gov.tw/News.aspx?n=203&sms=8665' },
        { label: '新竹市', link: 'https://society.hccg.gov.tw/ch/home.jsp?id=189&parentpath=0,5,43' },
        { label: '苗栗縣', link: 'https://www.miaoli.gov.tw/social_affairs/News.aspx?n=701&sms=9619' },
        { label: '台中市', link: 'https://www.society.taichung.gov.tw/13753/Lpsimplelist' },
        { label: '彰化縣', link: 'https://social.chcg.gov.tw/07other/other01_con.asp?topsn=1755&data_id=19504' },
        {
          label: '南投縣',
          link: 'https://www.nantou.gov.tw/big5/download.asp?dptid=376480000au130000&catetype=01&cid=944&cid1=955',
        },
        { label: '雲林縣', link: 'https://social.yunlin.gov.tw/News_Content.aspx?n=737&s=256538' },
        { label: '嘉義縣', link: 'https://sabcc.cyhg.gov.tw/Content_List.aspx?n=9C5E6B6259E6DA0F' },
        { label: '嘉義市', link: 'https://social.chiayi.gov.tw/infant.htm' },
        { label: '台南市', link: 'https://sab.tainan.gov.tw/cl.aspx?n=21443' },
        { label: '高雄市', link: 'https://socbu.kcg.gov.tw/index.php?prog=1&b_id=25' },
        { label: '屏東縣', link: 'https://www.pthg.gov.tw/planjdp/cp.aspx?n=C93C0A0A7ADE2D94' },
        {
          label: '台東縣',
          link: 'https://taisoc.taitung.gov.tw/WebSite/Service/service.aspx?menuid=lW%2bfKiAxClc%3d&cate=0cySt5Aggpk%3d',
        },
        { label: '花蓮縣', link: 'https://sa.hl.gov.tw/List_sp/609ce5960e21412fa39bba36a2b8cdad' },
        { label: '宜蘭縣', link: 'https://sntroot.e-land.gov.tw/News.aspx?n=04383821D6DC3CAB&sms=291EF45DAE0EB576' },
        { label: '澎湖縣', link: 'https://www.penghu.gov.tw/society/home.jsp?id=181' },
        { label: '金門縣', link: 'https://social.kinmen.gov.tw/cp.aspx?n=69B652E4C1464FFE&s=66DCCDD84951C415' },
      ],
    }),
  },
];

export const homeUndestandPreventHabit = [
  {
    type: 'normal',
    text: [
      '1.臥床休息：一般返家後建議繼續臥床休息，若無破水、陰道出血或子宮收縮情形，可適度下床活動，減輕壓力及焦慮。',
      '2.避免引起子宮收縮之活動：如刺激乳頭、從事粗重工作及激烈活動 (如搬重物、跑步、爬山、頻繁上下樓梯等)。',
      '3.每日測量體溫一次，注意有無感染現象。',
      '4.避免性生活及陰道灌洗。',
      '5.依醫生指示按時服用藥物，按時返診。',
      '6.妊娠糖尿病孕婦及子癲前症孕婦之相關居家衛教資訊，可至高危險妊娠-常見高危險妊娠的處置與治療方式了解更多。',
    ],
  },
  {
    type: 'normal',
    render: h('p', { style: font() }, [
      h(
        'span',
        '7.密切觀察可能早產的徵兆如胎動、子宮收縮及血壓變化等情形，或是出現不正常出血、破水須立即返診求診，可至',
      ),
      h(OpenItem, {
        link: {
          name: 'what-is-preemie',
        },
        label: '認識早產-如何預防早產了解更多',
        type: 'internal',
      }),
      h('span', '。'),
    ]),
  },
];

export const homeUndestandPreventNutrition = [
  {
    type: 'normal',
    text: [
      '1.葉酸: 建議懷孕前到三個月補充。',
      '2.孕婦綜合維他命:懷孕三個月後可補充。',
      '3.DHA:主要來源有魚油、藻油、堅果類食物。',
      '4.Ca:建議額外補充，因為孕婦綜合維他命中所含的鈣通常不足。',
      '5.Vit. D3: 除可幫助鈣的吸收，臨床上對調整身體免疫及心理狀態也有幫助。',
    ],
  },
];

export const privacyWording = [
  {
    type: 'important',
    text: '隱私權策略',
  },
  {
    type: 'normal',
    text: [
      '台灣早產兒基金會 | Premature Baby Foundation of Taiwan.(以下稱本會)依據「個人資料保護法」及衍伸之相關規定，並促進個人自主權且及慎重管理，本會對於個人資料之蒐集、處理、利用等，皆依「個人資料保護政策」辦理。',
    ],
  },
  {
    type: 'normal',
    text: [
      '一、本會義務',
      '本會依循「個人資料保護法」及其衍伸之相關規定，履行相關義務。惟目的事業主管機關或法律另有規定者，本會從其規定。',
      '本會對個人資料之蒐集、處理、利用等方法，已明確界定本會人員之保密義務與責任。本會人員皆已確實瞭解此政策內容，且依本會所訂定之個人資料保護管理措施，落實於日常作業流程中。',
    ],
  },
  {
    type: 'normal',
    text: [
      '二、個資之蒐集、處理及利用',
      '本會個人資料蒐集對象包含(但不限於)本會捐贈人、服務對象、其他有關業務往來之個人、私人團體及相關公立機關。',
      '本會之個人資料管理皆於合理正當之業務範圍內，基於本會宗旨提供之服務或舉辦之活動、講座、公益活動等相關特定目的及其他依法令規範所需留存個人資料之情況，而蒐集、處理或利用之個人資料。或在當事人的同意下，以誠信、合法之方式，蒐集、處理、利用並傳輸之。',
      '本會蒐集之個人資料依法進行妥善之保存及刪除。惟有必要委託第三者以提供服務時，應依本會規定、「個人資料保護法」及其衍伸之相關規定辦理，以充分保護個人資料。',
      '非經當事人同意、授權或法律另有規定，本會不會任意出售、交換或提供個人資料給其他團體或個人。',
    ],
  },
  {
    type: 'normal',
    text: [
      '三、當事人權利 本會尊重當事人對其個人資料所能行使之權利，包含查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用及請求刪除等。',
      '如有上述權利相關之主張，請聯繫本會：02-25111608。',
    ],
  },
];

export const healthCareWording = [
  {
    type: 'normal',
    text: '「尊重生命，重視生命的品質」是本會推展服務方案的信念，早產兒健康保護網的四項服務專案「早產防治暨安胎示範病房」、「早產兒醫療訓練中心」、「出院後社區照顧服務」、「出院後追蹤檢查服務」即是本會與合約醫院共同成立推展。',
  },
  {
    type: 'normal',
    text: '「親密相伴．陪他長大」早產兒健康保護網的建立是以三級預防的觀點來規劃，「預防早產發生」、「預防早產兒的後遺症」、「預防早產兒再度住院」，從預防早產教育宣導到出院後的追蹤檢查門診服務，都是希望讓早產兒獲得適當的醫療照顧，以減少社會成本的浪費。',
  },
];

export const highriskPregnantEmergencyHospitalWording = [
  {
    render: h('p', { style: font() }, [
      h('span', '高危險妊娠急救責任醫院名單為「'),
      h(OpenItem, {
        link: 'https://dep.mohw.gov.tw/doma/cp-979-4112-106.html',
        label: '衛生福利部醫事司',
      }),
      h('span', '」網站提供，詳情可上網站確認。'),
    ]),
  },
];

export const highriskPregnantEmergencyHospitalNoticeWording = [
  {
    type: 'normal',
    text: '註：',
  },
  {
    type: 'normal',
    text: '1.中度級可於上班時間提供高危險妊娠及新生兒照護，並能安排適當轉診，提供在地化緊急醫療服務。',
  },
  {
    type: 'normal',
    text: '2.重度級可提供高危險妊娠及新生兒全天候治療與照護。',
  },
  {
    type: 'normal',
    text: '3.含110年「提升兒科緊急醫療救護品質及資源整合計畫」補助醫院(17間)。',
  },
];

export const antiFraudTitle = '早產兒基金會提醒您！';
export const antiFraudWording = [
  {
    render: textInRow([
      {
        t: '近日詐騙猖獗，本會',
      },
      {
        t: '不會',
        style: {
          fontWeight: '700',
          color: '#FF000A',
          fontSize: '28px',
        },
      },
      {
        t: '致電您重複扣款、誤植定期定額捐款、或要求操作ATM及網銀等。',
      },
    ]),
  },
  {
    type: 'normal',
    text: '如有疑問請洽本會02-25111608，感謝您對小腳ㄚ的關懷及愛心捐助。',
  },
];
